// App text strings & brand-specific overrides, used by react-intl-redux

import * as _ from 'lodash';

// TODO: BRANDING AND INTL-MESSAGES HAVE CIRCULAR DEPENDENCIES. REFACTOR TO FIX
import Branding from '../branding/branding';

/* IMPORTANT: FOR IMAGES, SEE /src/config/images.tsx instead! */

export const ComplexSolutionsMessages = {
    // App text overrides for complex solutions brand
    'app.branding.company': 'Complex Solutions Ltd.',
    'app.branding.images.defaultAvatar': require('../branding/complex-solutions/default-avatar.png'),
    'app.branding.images.logo.login': require('../branding/complex-solutions/logo-login.png'),
    'app.branding.images.logo.nav': require('../branding/complex-solutions/logo-app-nav.png'),
    /* IMPORTANT: FOR IMAGES, SEE /src/config/images.tsx instead! */
    'app.branding.images.logo.report-cover-page': require('../branding/complex-solutions/logo-report-cover-page.svg'),
    'app.branding.images.logo.report-footer': require('../branding/complex-solutions/logo-report-footer.svg'),
    'app.branding.images.logo.report-portal': require('../branding/complex-solutions/logo-report-footer.svg'),
    // 'app.branding.images.logo.report-cover-page': require('../branding/complex-solutions/logo-report-cover-page.png'),
    // 'app.branding.images.logo.report-footer': require('../branding/complex-solutions/logo-report-footer.png'),
};

export const AppliedReserveMessages = {
    // App text overrides for applied reserve brand
    'app.branding.company': 'Applied Reserve Analytics',
    'app.branding.images.defaultAvatar': require('../branding/applied-reserve-analysis/default-avatar.png'),
    'app.branding.images.logo.login': require('../branding/applied-reserve-analysis/logo-login.png'),
    'app.branding.images.logo.nav': require('../branding/applied-reserve-analysis/logo-app-nav.png'),
    /* IMPORTANT: FOR IMAGES, SEE /src/config/images.tsx instead! */
    'app.branding.images.logo.report-cover-page': require('../branding/applied-reserve-analysis/logo-report-cover-page.png'),
    'app.branding.images.logo.report-footer': require('../branding/applied-reserve-analysis/logo-report-footer.png'),
    'app.branding.images.logo.report-portal': require('../branding/applied-reserve-analysis/logo-report-footer.png'),
};

export default class Messages {
    public static defaultMessages = {
        // Define default app text messages
        'app.branding.company': 'app.branding.company',
        'app.branding.images.defaultAvatar': '',
        'app.branding.images.logo.login': '',
        'app.branding.images.logo.nav': '',
        'app.branding.images.logo.report-cover-page': '',
        'app.branding.images.logo.report-footer': '',
        'app.branding.images.logo.report-portal': '',

        'app.copy-address-to-clipboard.address-copied': 'Address Copied',
        'app.copy-address-to-clipboard.address-has-been-copied': 'The address has been copied to the clipboard',
        'app.copy-address-to-clipboard.copy-address-to-clipboard': 'Copy Address to Clipboard',

        'app.common.buttons.abandon-changes': 'Abandon Changes',
        'app.common.buttons.add-document': 'Add Document',
        'app.common.buttons.add': 'Add',
        'app.common.buttons.cancel': 'Cancel',
        'app.common.buttons.change': 'Change',
        'app.common.buttons.clear': 'Clear',
        'app.common.buttons.close': 'Close',
        'app.common.buttons.delete': 'Delete',
        'app.common.buttons.details': 'Details',
        'app.common.buttons.duplicate': 'Duplicate',
        'app.common.buttons.edit': 'Edit',
        'app.common.buttons.new': 'New',
        'app.common.buttons.next': 'Next',
        'app.common.buttons.no-changes': 'No Changes',
        'app.common.buttons.of': 'of',
        'app.common.buttons.previous': 'Prev',
        'app.common.buttons.print-document': 'Print Document',
        'app.common.buttons.print-page': 'Print Page',
        'app.common.buttons.rename': 'Rename',
        'app.common.buttons.save-changes': 'Save Changes',
        'app.common.buttons.save': 'Save',
        'app.common.buttons.select-picture': 'Select Picture',
        'app.common.buttons.select': 'Select',
        'app.common.buttons.update': 'Update',
        'app.common.buttons.user-inventory-template': 'User Inventory Template',
        'app.common.buttons.add-order': 'Add Order',
        'app.common.buttons.delete-association': 'Delete Association',

        'app.common.buttons.bulk-complete': 'Bulk Complete',

        'app.common.buttons.view-association': 'Association',
        'app.common.buttons.view-disclosure': 'View Disclosure',
        'app.common.buttons.view-inventory': 'Inventory',
        'app.common.buttons.view-lookup-tables': 'Lookup Tables',
        'app.common.buttons.view-order': 'View Order',
        'app.common.buttons.view-portal': 'Portal',
        'app.common.buttons.view-profile': 'View Profile',
        'app.common.buttons.view-property-description': 'Property Description',
        'app.common.buttons.view-report-pdf': 'Report (PDF)',
        'app.common.buttons.view-research': 'Research',
        'app.common.buttons.view-reserve-study': 'View Report',
        'app.common.buttons.show-component-research-modal': 'Show Component Research History Modal',
        'app.common.buttons.clone-default': 'Clone Default',
        'app.common.buttons.use-default': 'Use Default',

        'app.common.contacts.send-email-to': 'Send email to',

        'app.common.forms.date-input.placeholder': 'MM/DD/YYYY',

        'app.common.forms.filter-option-any': '- ANY -',
        'app.common.forms.filter-option-no': 'No',
        'app.common.forms.filter-option-show-all': '- SHOW ALL -',
        'app.common.forms.filter-option-yes': 'Yes',

        'app.common.forms.number-input.placeholder': '0',
        'app.common.forms.phone-number.placeholder': '(___) ___-____',
        'app.common.forms.select-option.placeholder': 'Choose...',
        'app.common.forms.user.password.must-change-password': 'Must Change Password',
        'app.common.forms.validation.password-min-length': '* Password must be at least {TOKEN_VALUE} characters',
        'app.common.forms.validation.passwords-mismatched': '* Passwords do not match',

        'app.common.loading-data': 'Loading data...',
        'app.common.location.address.help': 'Enter the first line of mailing address',
        'app.common.location.address.placeholder': '1234 Main St.',
        'app.common.location.address': 'Address',
        'app.common.location.address2.help': 'Enter the second line of mailing address',
        'app.common.location.address2.placeholder': 'Building, floor or suite',
        'app.common.location.address2': 'Address 2',
        'app.common.location.city.help': 'Enter city name',
        'app.common.location.city.placeholder': 'City',
        'app.common.location.city': 'City',
        'app.common.location.country.help': 'Select country',
        'app.common.location.country.placeholder': 'Select country',
        'app.common.location.country': 'Country',
        'app.common.location.state.help': 'Select state or province',
        'app.common.location.state.placeholder': 'Select state or province',
        'app.common.location.state': 'State',
        'app.common.location.zip.help': 'Enter postal code',
        'app.common.location.zip.placeholder': 'Enter postal code',
        'app.common.location.zip': 'Zip',

        'app.common.name': 'Name',
        'app.common.search.results': 'Results',
        'app.common.search.result': 'Result',

        'app.entity-notes.on': 'On',
        'app.entity-notes.wrote': 'wrote',

        'app.association-add.add-association': 'Add Association',
        'app.association-add.add-association-with-order': 'Add Association With Order',
        'app.association-add.address': 'Address',
        'app.association-add.address.placeholder': '1234 Main St.',
        'app.association-add.address2': 'Address 2',
        'app.association-add.address2.placeholder': 'Building, floor or suite',
        'app.association-add.association-name-orig': 'Association Name',
        'app.association-add.association-name': 'Assoc. Name',
        'app.association-add.association-name.placeholder': 'Association Name',
        'app.association-add.association-type': 'Association Type',
        'app.association-add.association-type.placeholder': 'Association Type',
        'app.association-add.city': 'City',
        'app.association-add.city.placeholder': 'City',
        'app.association-add.client': 'Client',
        'app.association-add.client-info': 'Client Details',
        'app.association-add.client-info.placeholder': '--',
        'app.association-add.clubhouse-rec-room-orig': 'Clubhouse/Rec Room',
        'app.association-add.clubhouse-rec-room': 'Recreation Building',
        'app.association-add.company': 'Company',
        'app.association-add.construction-date': 'Construction Date',
        'app.association-add.contact-orig': 'Association Contact',
        'app.association-add.contact': 'Assoc. Contact',
        'app.association-add.conversion-date': 'Conversion Date',
        'app.association-add.country': 'Country',
        'app.association-add.date-input.placeholder': 'MM/DD/YYYY',
        'app.association-add.elevators': 'Elevators',
        'app.association-add.executive-summary-details': 'Executive Summary Details',
        'app.association-add.fencing': 'Fencing',
        'app.association-add.fiscal-year-end': 'Fiscal Year End',
        'app.association-add.inactive': 'Inactive',
        'app.association-add.interior-hallways': 'Interior Hallways',
        'app.association-add.irrigation': 'Irrigation',
        'app.association-add.mechanical': 'Mechanical',
        'app.association-add.notes': 'Notes',
        'app.association-add.number-input.placeholder': '0',
        'app.association-add.number-of-buildings-orig': 'Number of Buildings',
        'app.association-add.number-of-stories-orig': 'Number of Stories',
        'app.association-add.number-of-units-orig': 'Number of Units',
        'app.association-add.number-of-buildings': 'Num. of Buildings',
        'app.association-add.number-of-stories': 'Num. of Stories',
        'app.association-add.number-of-units': 'Num. of Units',
        'app.association-add.page-title': 'Add Association',
        'app.association-add.painted-exteriors': 'Painted Exteriors',
        'app.association-add.phases': 'Phases',
        'app.association-add.phone': 'Phone',
        'app.association-add.phone-number.placeholder': '(___) ___-____',
        'app.association-add.pools': 'Pools',
        'app.association-add.region': 'Region',
        'app.association-add.roofs': 'Roofs',
        'app.association-add.section-title.common-area-amenities-orig': 'Common Area Amenities',
        'app.association-add.section-title.common-area-amenities': 'Common Area Amenities Covered By HOA',
        'app.association-add.section-title.construction-info': 'Construction Information',
        'app.association-add.section-title.details': 'Association Details',
        'app.association-add.section-title.location': 'Association Location',
        'app.association-add.section-title.amenity-responsibilities-exterior': 'Amenity Responsibilities: Building Exteriors and Grounds',
        'app.association-add.section-title.amenity-responsibilities-interior': 'Amenity Responsibilities: Building Interiors',
        'app.association-add.section-title.notes': 'Association Notes',
        'app.association-add.secured-property': 'Secured Property',
        'app.association-add.select-option.placeholder': 'Choose...',
        'app.association-add.spas': 'Spas',
        'app.association-add.state': 'State',
        'app.association-add.streets': 'Streets',
        'app.association-add.tennis': 'Tennis',
        'app.association-add.zip': 'Zip',
        'app.association-add.zip.placeholder': 'Zip Code',
        'app.association-add.trash-enclosures': 'Trash Enclosures',
        'app.association-add.monument-signs': 'Monument Signs',
        'app.association-add.bike-walking-paths-orig': 'Bike/Walking Paths',
        'app.association-add.bike-walking-paths': 'Bike/Walk Paths',
        'app.association-add.street-lighting': 'Street Lighting',
        'app.association-add.street-signs': 'Street Signs',
        'app.association-add.outdoor-furniture': 'Outdoor Furniture',
        'app.association-add.awnings': 'Outdoor Furniture',
        'app.association-add.mailboxes': 'Mailboxes',
        'app.association-add.walkways': 'Walkways',
        'app.association-add.fire-escapes': 'Fire Escapes',
        'app.association-add.building-exterior-and-grounds': 'Amenitiy Responsibilities: Building Exteriors and Grounds',
        'app.association-add.building-lighting': 'Building Lighting',
        'app.association-add.decks-balconies': 'Decks/Balconies',
        'app.association-add.carports': 'Carports',
        'app.association-add.garages': 'Garages',
        'app.association-add.exterior-stairways': 'Exterior Stairways',
        'app.association-add.waterscapes-fountains-orig': 'Waterscapes/Fountains',
        'app.association-add.playground-equipment-orig': 'Playground Equipment',
        'app.association-add.waterscapes-fountains': 'Waterscapes',
        'app.association-add.playground-equipment': 'Playground Equip.',
        'app.association-add.gazebos': 'Gazebos',
        'app.association-add.wading-pools': 'Wading Pools',
        'app.association-add.saunas': 'Saunas',
        'app.association-add.marinas-docks': 'Marinas/Docks',
        'app.association-add.generators': 'Generators',
        'app.association-add.water-heaters': 'Water Heaters',
        'app.association-add.boilers': 'Boilers',
        'app.association-add.hvac-units': 'HVAC units',
        'app.association-add.chillers': 'Chillers',
        'app.association-add.maintenance-buildings': 'Maintenance Buildings',
        'app.association-add.volleyball-courts': 'Volleyball Courts',
        'app.association-add.basketball-courts': 'Basketball Courts',
        'app.association-add.building-interiors': 'Amenitiy Responsibilities: Building Interiors',
        'app.association-add.interior-lighting': 'Interior Lighting',
        'app.association-add.interior-painting': 'Interior Painting',
        'app.association-add.interior-flooring': 'Interior Flooring',
        'app.association-add.interior-elevators': 'Elevators',
        'app.association-add.office': 'Office',
        'app.association-add.laundry-equipment-orig': 'Laundry Equipment',
        'app.association-add.laundry-equipment': 'Laundry Equip.',
        'app.association-add.kitchen': 'Kitchen',
        'app.association-add.gym': 'Gym',
        'app.association-add.restrooms': 'Restrooms',

        'app.association-edit.address.placeholder': '1234 Main St.',
        'app.association-edit.address': 'Address',
        'app.association-edit.address2.placeholder': 'Building, floor or suite',
        'app.association-edit.address2': 'Address 2',
        'app.association-edit.association-name.placeholder': 'Association Name',
        'app.association-edit.association-name-orig': 'Association Name',
        'app.association-edit.association-name': 'Assoc. Name',
        'app.association-edit.association-type': 'Association Type',
        'app.association-edit.change': 'Change',
        'app.association-edit.city.placeholder': 'City',
        'app.association-edit.city': 'City',
        'app.association-edit.client-info.placeholder': '--',
        'app.association-edit.client-info': 'Client Location',
        'app.association-edit.client': 'Client',
        'app.association-edit.clubhouse-rec-room-orig': 'Clubhouse/Rec Room',
        'app.association-edit.clubhouse-rec-room': 'Recreation Building',
        'app.association-edit.company': 'Company',
        'app.association-edit.construction-date': 'Construction Date',
        'app.association-edit.contact': 'Client Contact for Association',
        'app.association-edit.conversion-date': 'Conversion Date',
        'app.association-edit.country': 'Country',
        'app.association-edit.date-input.placeholder': 'MM/DD/YYYY',
        'app.association-edit.edit-association': 'Edit Association',
        'app.association-edit.elevators': 'Elevators',
        'app.association-edit.executive-summary-details': 'Executive Summary Details',
        'app.association-edit.fencing': 'Fencing',
        'app.association-edit.fiscal-year-end': 'Fiscal Year End',
        'app.association-edit.inactive': 'Inactive',
        'app.association-edit.interior-hallways': 'Interior Hallways',
        'app.association-edit.irrigation': 'Irrigation',
        'app.association-edit.mechanical': 'Mechanical',
        'app.association-edit.no-changes': 'No Changes',
        'app.association-edit.note-on': 'On',
        'app.association-edit.note-wrote': 'wrote',
        'app.association-edit.notes-add': 'Add New Note',
        'app.association-edit.notes': 'Notes',
        'app.association-edit.number-input.placeholder': '0',
        'app.association-edit.number-of-buildings-orig': 'Number of Buildings',
        'app.association-edit.number-of-stories-orig': 'Number of Stories',
        'app.association-edit.number-of-units-orig': 'Number of Units',
        'app.association-edit.number-of-buildings': 'Num. of Buildings',
        'app.association-edit.number-of-stories': 'Num. of Stories',
        'app.association-edit.number-of-units': 'Num. of Units',
        'app.association-edit.page-title': 'Edit Association',
        'app.association-edit.painted-exteriors': 'Painted Exteriors',
        'app.association-edit.phases': 'Phases',
        'app.association-edit.phone-number.placeholder': '(___) ___-____',
        'app.association-edit.phone': 'Phone',
        'app.association-edit.pools': 'Pools',
        'app.association-edit.region': 'Region',
        'app.association-edit.roofs': 'Roofs',
        'app.association-edit.save-changes': 'Save Changes',
        'app.association-edit.save': 'Save',
        'app.association-edit.section-title.common-area-amenities': 'Common Area Amenities Covered By HOA',
        'app.association-edit.section-title.construction-info': 'Construction Information',
        'app.association-edit.section-title.amenity-responsibilities-exterior': 'Amenity Responsibilities: Building Exteriors and Grounds',
        'app.association-edit.section-title.amenity-responsibilities-interior': 'Amenity Responsibilities: Building Interiors',
        'app.association-edit.section-title.details': 'Association Details',
        'app.association-edit.section-title.location': 'Association Location',
        'app.association-edit.section-title.notes': 'Association Notes',
        'app.association-edit.secured-property': 'Secured Property',
        'app.association-edit.select-option.placeholder': 'Choose...',
        'app.association-edit.spas': 'Spas',
        'app.association-edit.state': 'State',
        'app.association-edit.streets': 'Streets',
        'app.association-edit.tennis': 'Tennis',
        'app.association-edit.zip.placeholder': 'Zip Code',
        'app.association-edit.zip': 'Zip',
        'app.association-edit.trash-enclosures': 'Trash Enclosures',
        'app.association-edit.monument-signs': 'Monument Signs',
        'app.association-edit.bike-walking-paths-orig': 'Bike/Walking Paths',
        'app.association-edit.bike-walking-paths': 'Bike/Walk Paths',
        'app.association-edit.street-lighting': 'Street Lighting',
        'app.association-edit.street-signs': 'Street Signs',
        'app.association-edit.outdoor-furniture': 'Outdoor Furniture',
        'app.association-edit.awnings': 'Outdoor Furniture',
        'app.association-edit.mailboxes': 'Mailboxes',
        'app.association-edit.walkways': 'Walkways',
        'app.association-edit.fire-escapes': 'Fire Escapes',
        'app.association-edit.building-exterior-and-grounds': 'Amenitiy Responsibilities: Building Exteriors and Grounds',
        'app.association-edit.building-lighting': 'Building Lighting',
        'app.association-edit.decks-balconies': 'Decks/Balconies',
        'app.association-edit.carports': 'Carports',
        'app.association-edit.garages': 'Garages',
        'app.association-edit.exterior-stairways': 'Exterior Stairways',
        'app.association-edit.waterscapes-fountains-orig': 'Waterscapes/Fountains',
        'app.association-edit.playground-equipment-orig': 'Playground Equipment',
        'app.association-edit.waterscapes-fountains': 'Waterscapes',
        'app.association-edit.playground-equipment': 'Playground Equip.',
        'app.association-edit.gazebos': 'Gazebos',
        'app.association-edit.wading-pools': 'Wading Pools',
        'app.association-edit.saunas': 'Saunas',
        'app.association-edit.marinas-docks': 'Marinas/Docks',
        'app.association-edit.generators': 'Generators',
        'app.association-edit.water-heaters': 'Water Heaters',
        'app.association-edit.boilers': 'Boilers',
        'app.association-edit.hvac-units': 'HVAC units',
        'app.association-edit.chillers': 'Chillers',
        'app.association-edit.maintenance-buildings': 'Maintenance Buildings',
        'app.association-edit.volleyball-courts': 'Volleyball Courts',
        'app.association-edit.basketball-courts': 'Basketball Courts',
        'app.association-edit.building-interiors': 'Amenitiy Responsibilities: Building Interiors',
        'app.association-edit.interior-lighting': 'Interior Lighting',
        'app.association-edit.interior-painting': 'Interior Painting',
        'app.association-edit.interior-flooring': 'Interior Flooring',
        'app.association-edit.interior-elevators': 'Elevators',
        'app.association-edit.office': 'Office',
        'app.association-edit.laundry-equipment-orig': 'Laundry Equipment',
        'app.association-edit.laundry-equipment': 'Laundry Equip.',
        'app.association-edit.kitchen': 'Kitchen',
        'app.association-edit.gym': 'Gym',
        'app.association-edit.restrooms': 'Restrooms',

        'app.form.location.address': 'Address',
        'app.form.location.address.placeholder': '1234 Main St.',
        'app.form.location.address2': 'Address 2',
        'app.form.location.address2.placeholder': 'Building, floor or suite',
        'app.form.location.city': 'City',
        'app.form.location.city.placeholder': 'City',
        'app.form.location.country': 'Country',
        'app.form.location.name': '1Name',
        'app.form.location.name.placeholder': 'Enter Name',
        'app.form.location.select-option.placeholder': 'Choose...',
        'app.form.location.state': 'State',
        'app.form.location.zip': 'Zip',
        'app.form.location.zip.placeholder': 'Zip Code',

        'app.google-map-link.click-to-open-map': 'Click to open location on Google Maps',

        'app.reserve-study.adjustments': 'Adjustments',
        'app.reserve-study.annual-increase': 'Annual Increases to Current %',
        'app.reserve-study.annual-increases-percent': 'Annual Increases %',
        'app.reserve-study.association-details': 'Association Details',
        'app.reserve-study.auto-compute': 'Auto Compute',
        'app.reserve-study.beginning-assumptions': 'Beginning Assumptions',
        'app.reserve-study.beginning-balance': 'Beginning Balance $',
        'app.reserve-study.beginning-year': 'Beginning Year',
        'app.reserve-study.change': 'Change',
        'app.reserve-study.component-funding': 'Component Funding',
        'app.reserve-study.cover-page-picture': 'Cover Page Picture',
        'app.reserve-study.current-expenditures': 'Current Expenditures',
        'app.reserve-study.current-mrc': 'Current MRC',
        'app.reserve-study.current-order-id': 'current order id',
        'app.reserve-study.current-pct-funded': 'Current PCT Funded',
        'app.reserve-study.current-status': 'Current Status',
        'app.reserve-study.currently-programmed-projects': 'Currently Programmed Projects',
        'app.reserve-study.draft': 'Draft',
        'app.reserve-study.executive-summary': 'Executive Summary',
        'app.reserve-study.expenditures-by-year': 'Expenditures By Year',
        'app.reserve-study.expenditures': 'Expenditures',
        'app.reserve-study.ffb': 'FFB',
        'app.reserve-study.fully-funded': 'Fully Funded',
        'app.reserve-study.fully-funded-balance': 'Fully Funded Balance',
        'app.reserve-study.funding-amount': 'Funding Amount',
        'app.reserve-study.funding-disclosure-summary': 'Funding Disclosure',
        'app.reserve-study.fy-end-mm-dd': 'Fiscal Year End',
        'app.reserve-study.fy-end': 'FY End',
        'app.reserve-study.grid-title-prefix': 'Group',
        'app.reserve-study.grid.column-headers.erb': 'Ending Reserve Balance',
        'app.reserve-study.grid.column-headers.ffb': 'Fully Funded Balance',
        'app.reserve-study.grid.column-headers.id': 'Id',
        'app.reserve-study.grid.column-headers.ii': 'Interest Income',
        'app.reserve-study.grid.column-headers.name': 'Component Name',
        'app.reserve-study.grid.column-headers.pf': '% Funded',
        'app.reserve-study.grid.column-headers.rb': 'Reserve Balance',
        'app.reserve-study.grid.column-headers.rc': 'Reserve Contributions',
        'app.reserve-study.grid.column-headers.re': 'Reserve Expenses',
        'app.reserve-study.grid.column-headers.reserve-study-values': 'Reserve Study Values',
        'app.reserve-study.grid.column-headers.study-avg-cost': 'Study Avg Cost',
        'app.reserve-study.grid.column-headers.study-rl': 'Study RL',
        'app.reserve-study.grid.column-headers.study-ul': 'Study UL',
        'app.reserve-study.grid.column-headers.year': 'Year',
        'app.reserve-study.grid.column-headers.your-avg-cost': 'Your Avg Cost',
        'app.reserve-study.grid.column-headers.your-included': 'Include',
        'app.reserve-study.grid.column-headers.your-rl': 'Your RL',
        'app.reserve-study.grid.column-headers.your-ul': 'Your UL',
        'app.reserve-study.grid.column-headers.your-values': 'Your Values',
        'app.reserve-study.hypothetical-expenditures-by-year': 'Hypothetical Expenditures By Year',
        'app.reserve-study.hypothetical-fully-funded': 'Hypothetical Fully Funded',
        'app.reserve-study.hypothetical-fully-funded-balance': 'Hypothetical Fully Funded Balance',
        'app.reserve-study.hypothetical-funding-amount': 'Hypothetical Funding Amount',
        'app.reserve-study.hypothetical-mrc': 'Hypothetical MRC',
        'app.reserve-study.hypothetical-pct-funded': 'Hypothetical PCT Funded',
        'app.reserve-study.hypothetical-percent-funded': 'Hypothetical Percent Funded',
        'app.reserve-study.inflation-percent': 'Inflation %',
        'app.reserve-study.inflation': 'Inflation',
        'app.reserve-study.interest-percent': 'Interest %',
        'app.reserve-study.interest': 'Interest',
        'app.reserve-study.minimum-amount-increase': 'Minimum Amount / Increase $ / %',
        'app.reserve-study.minimum-mrc': 'Minimum MRC',
        'app.reserve-study.minimum-pct-funded': 'Minimum PCT Funded',
        'app.reserve-study.minimum': 'Minimum',
        'app.reserve-study.monthly-fee-text-example': ' - Ex: $35.00 or (2) at $35.00, (3) at $40.00',
        'app.reserve-study.monthly-fee-text': 'Monthly Fee Text',
        'app.reserve-study.months': 'Months',
        'app.reserve-study.mrc-per-unit': 'MRC per Unit',
        'app.reserve-study.mrc-value': 'MRC Value',
        'app.reserve-study.mrc': 'MRC $',
        'app.reserve-study.no-changes': 'No Changes',
        'app.reserve-study.non-calendar-fye': 'Non Calendar FYE',
        'app.reserve-study.order': 'Order',
        'app.reserve-study.select-cover-page-picture': 'Select/Change Cover Page Picture',
        'app.reserve-study.stale-report-date': 'Warning: Date differs from today\'s date.',
        'app.reserve-study.num-periods': '# Periods First Year',
        'app.reserve-study.num-units': '# of Units',
        'app.reserve-study.num-years': '# of Years',
        'app.reserve-study.order-dash': 'Order Dash',
        'app.reserve-study.order-id': 'Order Id',
        'app.reserve-study.order-start-date': 'order start date',
        'app.reserve-study.override-default-text': 'Override Default Text',
        'app.reserve-study.reset-default-text': 'Reset Default Text',
        'app.reserve-study.override-save-changes': 'Discard Changes & View',
        'app.reserve-study.page-title': 'Reserve Study Analysis',
        'app.reserve-study.modals.select-picture.currently-selected-picture': 'Currently Selected Picture',
        'app.reserve-study.modals.select-picture.displaying': '',
        'app.reserve-study.modals.select-picture.in-folder': 'in',
        'app.reserve-study.modals.select-picture.picture': 'Picture',
        'app.reserve-study.modals.select-picture.title': 'Select Report Cover Picture for',
        'app.reserve-study.modals.select-picture.upload-pictures-to-folder': 'Upload Pictures to Folder',
        'app.reserve-study.modals.special-assessments-worksheet.hide': 'Hide Special Assessments Worksheet',
        'app.reserve-study.modals.special-assessments-worksheet.show': 'Show Special Assessments Worksheet',
        'app.reserve-study.modals.special-assessments-worksheet.save': 'Save',
        'app.reserve-study.modals.special-assessments-worksheet.title': 'Special Assessments Worksheet',
        'app.reserve-study.modals.special-assessments-worksheet.add-year': 'Add Additional Year',
        'app.reserve-study.alerts.warn-component-negative-rul.title': 'Negative Component RULs',
        'app.reserve-study.alerts.warn-component-negative-rul.body': 'Component(s) have negative remaining life values. Report printing will be disabled until all component RLs are fixed.',
        'app.reserve-study.alerts.warn-custom-executive-summary-text.body': 'Warning, one or more executive summary paragraphs have been customized. Please review the text before printing.',
        'app.reserve-study.alerts.warn-custom-executive-summary-text.title': 'Review Executive Summary Text',
        'app.reserve-study.page.component-evaluation': 'Component Evaluation',
        'app.reserve-study.page.component-funding-information.current-fund-balance': 'Current Fund Balance as a percentage of Ideal Balance',
        'app.reserve-study.page.component-funding-information.grand-total': 'Grand Total',
        'app.reserve-study.page.component-funding-information.grid-column-headers.avg-current-cost': 'Average Current Cost',
        'app.reserve-study.page.component-funding-information.grid-column-headers.component-name': 'Component Name',
        'app.reserve-study.page.component-funding-information.grid-column-headers.current-fund-balance': 'Current Fund Balance',
        'app.reserve-study.page.component-funding-information.grid-column-headers.id': 'ID',
        'app.reserve-study.page.component-funding-information.grid-column-headers.ideal-balance': 'Ideal Balance',
        'app.reserve-study.page.component-funding-information.grid-column-headers.monthly': 'Monthly',
        'app.reserve-study.page.component-funding-information.grid-column-headers.quantity': 'Quantity',
        'app.reserve-study.page.component-funding-information.grid-column-headers.rul': 'RUL',
        'app.reserve-study.page.component-funding-information.grid-column-headers.ul': 'UL',
        'app.reserve-study.page.component-funding-information.subtotals': 'Subtotals',
        'app.reserve-study.page.component-funding-information': 'Component Funding Information',

        'app.reserve-study.page.significant-components.grid-column-headers.id': 'ID #',
        'app.reserve-study.page.significant-components.grid-column-headers.component-name': 'Component Name',
        'app.reserve-study.page.significant-components.grid-column-headers.ul': 'UL',
        'app.reserve-study.page.significant-components.grid-column-headers.rul': 'RUL',
        'app.reserve-study.page.significant-components.grid-column-headers.average-current': 'Average Current',
        'app.reserve-study.page.significant-components.grid-column-headers.significance-curr-cost-ul': 'Significance: (Curr Cost/UL)',
        'app.reserve-study.page.significant-components.grid-column-headers.significance-as-currency': 'As $',
        'app.reserve-study.page.significant-components.grid-column-headers.significance-as-percentage': 'As %',

        'app.reserve-study.per-unit-liability': 'Per Unit Liability',
        'app.reserve-study.percent-funded': 'Percent Funded',
        'app.reserve-study.recommendations': 'Recommendations',
        'app.reserve-study.recommended-amount-increase': 'Recommended Amount / Increase $ / %',
        'app.reserve-study.recommended-mrc': 'Recommended MRC',
        'app.reserve-study.recommended-pct-funded': 'Recommended PCT Funded',
        'app.reserve-study.report-date': 'Report Date to Print',
        'app.reserve-study.report-items': 'Report Items',
        'app.reserve-study.report-options': 'Report Options',
        'app.reserve-study.reserve-funding': 'Reserve Funding',
        'app.reserve-study.reserve-study-chart': 'Reserve Study Chart',
        'app.reserve-study.reserve-study-pdf-note': '(You must save the entered values before viewing)',
        'app.reserve-study.reserve-study-pdf-OLD': 'View Reserve Study (PDF)',
        'app.reserve-study.reserve-study-pdf': 'Report (PDF)',
        'app.reserve-study.revert-scenario': 'Revert',
        'app.reserve-study.save-changes-modal.body': 'You must save the changed values to update report',
        'app.reserve-study.save-changes-modal.title': 'Save Changes?',
        'app.reserve-study.save-changes-then-view': 'Save Changes & View',
        'app.reserve-study.save-this-scenario': 'Save This Scenario',
        'app.reserve-study.already-optimized-explanation': 'The values used already fall within the acceptable range. The optimizer will not make any changes.',
        'app.reserve-study.optimize-scenario': 'Optimize Scenario',
        'app.reserve-study.optimize-failure-explanation': 'The optimizer was unable to find valid results. Adjust your values and try again.',
        'app.reserve-study.save': 'Save',
        'app.reserve-study.second-increase': 'Second Increases %',
        'app.reserve-study.second-increases-percent': 'Second Increases %',
        'app.reserve-study.secondary-adjustment-years': 'Secondary Adjustment Years',
        'app.reserve-study.secondary-annual-increase': 'Secondary Annual Increase',
        'app.reserve-study.show-current': 'Show Current Funding',
        'app.reserve-study.show-page-numbers': 'Show Component Page Numbers',
        'app.reserve-study.show-grouped-components': 'Group Components',
        'app.reserve-study.show-grouped-components-picture-section': 'Group Component Pictures',
        'app.reserve-study.show-hide-footer': 'Hide Footer',
        'app.reserve-study.show-hide-number-of-units': 'Hide Number of Units',
        'app.reserve-study.is-preliminary-study': 'Preliminary Study',
        'app.reserve-study.show-hide-component-evaluation': 'Hide Component Evaluation',
        'app.reserve-study.show-minimum-funding': 'Show Minimum Funding',
        'app.reserve-study.show-recommended': 'Recommend Current Funding',
        'app.reserve-study.show-yearly-summary-current': 'Show Current Yearly Summary',
        'app.reserve-study.show-yearly-summary-minimum': 'Show Minimum Yearly Summary',
        'app.reserve-study.significant-reserve-projects': 'Significant Reserve Projects',
        'app.reserve-study.special-assessment': 'Special Assessment',
        'app.reserve-study.special-assessment-dollars': 'Special Assessment $',
        'app.reserve-study.client-approved-special-assessment-dollars': 'Client Approved Special Assessment $',
        'app.reserve-study.version-number': 'Version Number',
        'app.reserve-study.view-funding-disclosure-summary': 'Customize Funding Disclosure',
        'app.reserve-study.hide-special-assessments-worksheet-modal': 'Hide Special Assessments Worksheet',
        'app.reserve-study.view-special-assessments-worksheet-modal': 'Show Special Assessments Worksheet',
        'app.reserve-study.view-special-assessments-worksheet-customer-modal': 'Show Customer Requested SA Worksheet',
        'app.reserve-study.yearly-summary': 'Yearly Summary',

        'app.client-questions-report.page-title': 'Client Questions',
        'app.client-questions-report.report-notes': 'Report Notes',
        'app.client-questions-report.association': 'Association',
        'app.client-questions-report.grid-column-headers.id': 'Id',
        'app.client-questions-report.grid-column-headers.component-name': 'Component Name',
        'app.client-questions-report.grid-column-headers.location': 'Location',
        'app.client-questions-report.grid-column-headers.quantity': 'Quantity',

        'app.text-content.contact-details': 'Contact Details',
        'app.text-content.contact-first-name': 'First Name',
        'app.text-content.contact-last-name': 'Last Name',
        'app.text-content.contact-title': 'Title',
        'app.text-content.hide-replacement-costs': 'Hide Replacement Costs',

        'app.text-content.bid-letter.name': 'Name',
        'app.text-content.bid-letter.title': 'Bid Letter Details',
        'app.text-content.bid-letter.text-content-key': 'Text Content Key',
        'app.text-content.bid-letter.letter-intro': 'Bid Letter Intro',
        'app.text-content.bid-letter.letter-conclusion': 'Bid Letter Conclusion',
        'app.text-content.bid-letter.letter-signature': 'Bid Letter Signature',
        'app.text-content.bid-letter.contract-header-page-1': 'Contract Header Page 1',
        'app.text-content.bid-letter.contract-header-page-2': 'Contract Header Page 2',
        'app.text-content.bid-letter.contract-signatures-area': 'Contract Signatures Area',

        'app.text-content.login-details': 'Text Content Details',
        'app.text-content.login-email': 'Email',
        'app.text-content.login-last-login': 'Last Login',
        'app.text-content.login-never': 'Never',
        'app.text-content.login-password': 'Password',
        'app.text-content.login-username': 'Username',
        'app.text-content.modals.new-user.confirm-password': 'Confirm Password',
        'app.text-content.modals.new-user.email-in-use': '* Email is already in use',
        'app.text-content.modals.new-user.email': 'Email Address',
        'app.text-content.modals.new-user.first-name': 'First Name',
        'app.text-content.modals.new-user.last-name': 'Last Name',
        'app.text-content.modals.new-user.new-username': 'New Username',
        'app.text-content.modals.new-user.password-min-length': '* Password must be at least {TOKEN_VALUE} characters',
        'app.text-content.modals.new-user.password': 'Password',
        'app.text-content.modals.new-user.passwords-mismatched': '* Passwords do not match',
        'app.text-content.modals.new-user.professional-title': 'Title',
        'app.text-content.modals.new-user.required': 'Required',
        'app.text-content.modals.new-user.title': 'Create New User',
        'app.text-content.modals.new-user.username-in-use': '* Username is already in use',
        'app.text-content.modals.reset-password.new-password-confirm': 'Confirm New Password',
        'app.text-content.modals.reset-password.new-password': 'New Password',
        'app.text-content.modals.reset-password.set-changes': 'Set Changes',
        'app.text-content.modals.reset-password.title': 'Reset Password',
        'app.text-content.modals.reset-password.unlock-if-locked-out': 'Locked Out',
        'app.text-content.modals.reset-password.password-change-required': 'Must Change On Login',
        'app.text-content.new-user': 'Create New User',
        'app.text-content.not-found': 'User "{TOKEN_VALUE}" not found!',
        'app.text-content.page-title': 'Text Content',
        'app.text-content.page-title.edit': 'Edit Text Content',
        'app.text-content.portal-access': 'Manage Portal User Access',
        'app.text-content.portal-invites': 'Portal Invites',
        'app.text-content.portal-role-admin': 'User Manager Associations',
        'app.text-content.portal-role-user': 'User Associations',
        'app.text-content.portal-invite-deactive': 'Deactive Associations',
        'app.text-content.profile-settings': 'Profile Settings',
        'app.text-content.reset-password': 'Reset Password',
        'app.text-content.resume-details': 'Professional Details',
        'app.text-content.resume-permit-number-nv': 'Permit Number (Nevada)',
        'app.text-content.resume-signature': 'Document Signatures',
        'app.text-content.resume-text': 'Resume Content',
        'app.text-content.roles': 'Roles',
        'app.text-content.search-users': 'Search Users',
        'app.text-content.view-profile': 'View Profile',
        'app.text-content.edit-profile': 'Edit Profile',
        'app.text-content.security-active-no': 'No',
        'app.text-content.security-active-yes': 'Yes',
        'app.text-content.security-active': 'Account Active',
        'app.text-content.security-details': 'Security Details',
        'app.text-content.security-inactive': 'Account Disabled',
        'app.text-content.security-locked-no': 'No',
        'app.text-content.security-locked-yes': 'Yes',
        'app.text-content.security-locked': 'Account Locked',
        'app.text-content.security-roles-none': 'None Assigned',
        'app.text-content.security-roles': 'Assigned Roles',
        'app.text-content.security-regions-none': 'None Assigned',
        'app.text-content.security-regions': 'Assigned Regions',
        'app.text-content.can-see-all-jobs': 'Can See All Jobs',

        'app.association-detail.association-id': 'Association Id',
        'app.association-detail.view-portal-report': 'View Portal',
        'app.association-detail.association-name.help': 'Enter the association\'s business name',
        'app.association-detail.association-name.placeholder': 'Sample HOA',
        'app.association-detail.association-name': 'Association Name',
        'app.association-detail.association-notes': 'Association Notes',
        'app.association-detail.association-type.help': 'Select association Type',
        'app.association-detail.association-type.placeholder': 'Association Type',
        'app.association-detail.association-type': 'Association Type',
        'app.association-detail.client-id': 'Client Id',
        'app.association-detail.client': 'Client',
        'app.association-detail.clubhouse-rec-room.help': 'Select if clubhouse or rec room',
        'app.association-detail.clubhouse-rec-room.placeholder': 'Clubhouse/Rec Room',
        'app.association-detail.clubhouse-rec-room': 'Clubhouse/Rec Room',
        'app.association-detail.common-area-amenities': 'Common Area Amenities',
        'app.association-detail.common-area-amenities-covered-by-hoa': 'Common Area Amenities Covered By HOA',
        'app.association-detail.common-area-amenities-responsible-for': 'Common Area Amenities HOA Responsible For',
        'app.association-detail.company.help': 'Select the associated company',
        'app.association-detail.company.placeholder': 'Select Company',
        'app.association-detail.company': 'Company',
        'app.association-detail.construction-date.help': 'Enter the date the property was constructed',
        'app.association-detail.construction-date': 'Construction Date',
        'app.association-detail.construction-info': 'Construction Info',
        'app.association-detail.construction-information': 'Construction Information',
        'app.association-detail.contact': 'Client Contact for Association',
        'app.association-detail.conversion-date.help': 'Enter the date the property was converted',
        'app.association-detail.conversion-date': 'Conversion Date',
        'app.association-detail.create-invite-to-portal': 'Invite User to Portal',
        'app.association-detail.edit-association': 'Edit Association',
        'app.association-detail.elevators.help': 'Select if elevators',
        'app.association-detail.elevators.placeholder': 'Elevators',
        'app.association-detail.elevators': 'Elevators',
        'app.association-detail.executive-summary-details.help': 'Executive Summary Details',
        'app.association-detail.executive-summary-details.placeholder': 'Enter executive summary details for this association',
        'app.association-detail.executive-summary-details': 'Executive Summary Details',
        'app.association-detail.fencing.help': 'Select type of fencing',
        'app.association-detail.fencing.placeholder': 'Fencing',
        'app.association-detail.fencing': 'Fencing',
        'app.association-detail.fiscal-year-end.help': 'Enter the fiscal year end dated',
        'app.association-detail.fiscal-year-end': 'Fiscal Year End',
        'app.association-detail.inactive.help': 'Check box to mark as inactive',
        'app.association-detail.inactive.placeholder': 'Inactive',
        'app.association-detail.inactive': 'Inactive',
        'app.association-detail.interior-hallways.help': 'Select type of interior hallways',
        'app.association-detail.interior-hallways.placeholder': 'Interior Hallways',
        'app.association-detail.interior-hallways': 'Interior Hallways',
        'app.association-detail.inventory': 'Inventory',
        'app.association-detail.irrigation.help': 'Select irrigation type',
        'app.association-detail.irrigation.placeholder': 'Irrigation',
        'app.association-detail.irrigation': 'Irrigation',
        'app.association-detail.manager-contact': 'Manager/Contact',
        'app.association-detail.mechanical.help': 'Select if mechanical',
        'app.association-detail.mechanical.placeholder': 'Mechanical',
        'app.association-detail.mechanical': 'Mechanical',
        'app.association-detail.modals.delete-association.action-permanent': 'This action is permanent and cannot be undone.',
        'app.association-detail.modals.delete-association.are-you-sure': 'Are you sure?',
        'app.association-detail.modals.delete-association.cannot-delete': 'Cannot delete an association with Order(s) and Component List, try deleting those first?',
        'app.association-detail.modals.delete-association.delete-association': 'Delete Association',
        'app.association-detail.modals.delete-association.verify-delete': 'Please enter the Association Id Number to confirm.',
        'app.association-detail.notes': 'Notes',
        'app.association-detail.num-buildings.help': 'Enter the number of buildings on property',
        'app.association-detail.num-buildings': 'Number of Buildings',
        'app.association-detail.num-phases': 'Number of Phases',
        'app.association-detail.num-stories.help': 'Enter the number of stories',
        'app.association-detail.num-stories': 'Number of Stories',
        'app.association-detail.num-units.help': 'Enter the number of units',
        'app.association-detail.num-units': 'Number of Units',
        'app.association-detail.page-title': 'Association Detail',
        'app.association-detail.painted-exteriors.help': 'Select type of painted exteriors',
        'app.association-detail.painted-exteriors.placeholder': 'Painted Exteriors',
        'app.association-detail.painted-exteriors': 'Painted Exteriors',
        'app.association-detail.phases.help': 'Enter the number of construction phases',
        'app.association-detail.phases.placeholder': 'Phases',
        'app.association-detail.phases': 'Phases',
        'app.association-detail.phone': 'Phone',
        'app.association-detail.pools.help': 'Enter the number of swimming pools',
        'app.association-detail.pools': 'Pools',
        'app.association-detail.portal-access': 'Manage User Access',
        'app.association-detail.portal-access.none-assigned': 'None assigned',
        'app.association-detail.portal-access.none-deactivated': 'None deactivated',
        'app.association-detail.portal-access.managers': 'Portal Managers',
        'app.association-detail.portal-access.allowed-users': 'Allowed Portal Users',
        'app.association-detail.portal-access.deactivated-users': 'Deactivated Portal Users',
        'app.association-detail.portal-access.deactivated-users.role.portal-manager': 'Manager',
        'app.association-detail.portal-access.deactivated-users.role.portal-user': 'User',
        'app.association-detail.portal-access.deactivated-users.account-disabled': 'Disabled',
        'app.association-detail.portal-access.deactivated-users.expired-on': 'Deactivated on',
        'app.association-detail.property-description': 'Property Description',
        'app.association-detail.property-details': 'Property Details',
        'app.association-detail.property-type': 'Property Type',
        'app.association-detail.reserve-study-pdf': 'Reserve Study PDF',
        'app.association-detail.reserve-study': 'Reserve Study',
        'app.association-detail.roofs.help': 'Select roofing type',
        'app.association-detail.roofs.placeholder': 'Roofs',
        'app.association-detail.roofs': 'Roofs',
        'app.association-detail.secured-property.help': 'Select type of property security',
        'app.association-detail.secured-property.placeholder': 'Secured Property',
        'app.association-detail.secured-property': 'Secured Property',
        'app.association-detail.siding': 'Siding',
        'app.association-detail.spas.help': 'Enter the number of spas',
        'app.association-detail.spas': 'Spas',
        'app.association-detail.streets.help': 'Select streets types',
        'app.association-detail.streets.placeholder': 'Streets',
        'app.association-detail.streets': 'Streets',
        'app.association-detail.tennis-courts': 'Tennis Courts',
        'app.association-detail.tennis.help': 'Enter the number of tennis courts',
        'app.association-detail.tennis': 'Tennis',
        'app.association-detail.view-client': 'View Client',
        'app.association-detail.view-order': 'View Order',
        'app.association-detail.view-reserve-study': 'View Report',
        'app.association-detail.view-property-inventory': 'View Property Inventory',
        'app.association-detail.trash-enclosures': 'Trash Enclosures',
        'app.association-detail.monument-signs': 'Monument Signs',
        'app.association-detail.bike-walking-path': 'Bike/Walking Path',
        'app.association-detail.street-lighting': 'Street Lighting',
        'app.association-detail.street-signs': 'Street Signs',
        'app.association-detail.outdoor-furniture': 'Outdoor Furniture',
        'app.association-detail.awnings': 'Outdoor Furniture',
        'app.association-detail.mailboxes': 'Mailboxes',
        'app.association-detail.walkways': 'Walkways',
        'app.association-detail.fire-escapes': 'Fire Escapes',
        'app.association-detail.building-exterior-and-grounds': 'Amenitiy Responsibilities: Building Exteriors and Grounds',
        'app.association-detail.building-lighting': 'Building Lighting',
        'app.association-detail.decks-balconies': 'Decks/Balconies',
        'app.association-detail.carports': 'Carports',
        'app.association-detail.garages': 'Garages',
        'app.association-detail.exterior-stairways': 'Exterior Stairways',
        'app.association-detail.waterscapes-fountains': 'Waterscapes/Fountains',
        'app.association-detail.playground-equipment': 'Playground Equipment',
        'app.association-detail.gazebos': 'Gazebos',
        'app.association-detail.wading-pools': 'Wading Pools',
        'app.association-detail.saunas': 'Saunas',
        'app.association-detail.marinas-docks': 'Marinas/Docks',
        'app.association-detail.generators': 'Generators',
        'app.association-detail.water-heaters': 'Water Heaters',
        'app.association-detail.boilers': 'Boilers',
        'app.association-detail.hvac-units': 'HVAC units',
        'app.association-detail.chillers': 'Chillers',
        'app.association-detail.maintenance-buildings': 'Maintenance Buildings',
        'app.association-detail.volleyball-courts': 'Volleyball Courts',
        'app.association-detail.basketball-courts': 'Basketball Courts',
        'app.association-detail.building-interiors': 'Amenitiy Responsibilities: Building Interiors',
        'app.association-detail.interior-lighting': 'Interior Lighting',
        'app.association-detail.interior-painting': 'Interior Painting',
        'app.association-detail.interior-flooring': 'Interior Flooring',
        'app.association-detail.office': 'Office',
        'app.association-detail.laundry-equipment': 'Laundry Equipment',
        'app.association-detail.kitchen': 'Kitchen',
        'app.association-detail.gym': 'Gym',
        'app.association-detail.restrooms': 'Restrooms',

        'app.association-inventory.add-component': 'Add Component',
        'app.association-inventory.add-inventory-template': 'New Template',
        'app.association-inventory.apply-inventory-template': 'Apply Template',
        'app.association-inventory.add-subgroup': 'Add Subgroup',
        'app.association-inventory.alerts.warn-component-negative-rul.body': 'Component(s) have negative remaining life values. Report printing will be disabled until all component RLs are fixed.',
        'app.association-inventory.alerts.warn-component-negative-rul.title': 'Negative Component RULs',
        'app.association-inventory.alerts.warn-custom-executive-summary-text.body': 'Warning, the executive summary text has been overriden with customized paragraphs. Please review the overridden text before printing.',
        'app.association-inventory.alerts.warn-custom-executive-summary-text.title': 'Custom Executive Summary Text',
        'app.association-inventory.ara-number': 'ARA Number',
        'app.association-inventory.association-details': 'Association Details',
        'app.association-inventory.association-notes': 'Association Notes',
        'app.association-inventory.client-notes': 'Client Notes',
        'app.association-inventory.complete-no': 'No',
        'app.association-inventory.complete-yes': 'Yes',
        'app.association-inventory.component-filter-hide-unfunded': 'Hide Unfunded',
        'app.association-inventory.component-filters': 'Component Filters',
        'app.association-inventory.component': 'Component',
        'app.association-inventory.components': 'Components',
        'app.association-inventory.contact-notes': 'Contact Notes',
        'app.association-inventory.current-order-details': 'Current Order Details',
        'app.association-inventory.current-order': 'Current Order',
        'app.association-inventory.defined': 'Defined',
        'app.association-inventory.delete-subgroup': 'Delete Subgroup',
        'app.association-inventory.duplicate-subgroup': 'Duplicate Subgroup',
        'app.association-inventory.filter-by-subgroup': 'Subgroup Filter',
        'app.association-inventory.clear-pictures-questions': 'Clear Pictures/Questions',
        'app.association-inventory.filter-option-any': '- All Subgroups -',
        'app.association-inventory.grid.column-headers.avg-cost': 'Avg Cost',
        'app.association-inventory.grid.column-headers.category': 'Category',
        'app.association-inventory.grid.column-headers.complete': 'Complete',
        'app.association-inventory.grid.column-headers.component': 'Component',
        'app.association-inventory.grid.column-headers.id': 'Id',
        'app.association-inventory.grid.column-headers.qty': 'Qty',
        'app.association-inventory.grid.column-headers.reviewed': 'Reviewed',
        'app.association-inventory.grid.column-headers.rl': 'RL',
        'app.association-inventory.grid.column-headers.subgroup': 'Subgroup',
        'app.association-inventory.grid.column-headers.ul': 'UL',
        'app.association-inventory.grid.column-headers.clear-pictures': 'Clear Pictures',
        'app.association-inventory.inventory-components': 'Inventory Components',
        'app.association-inventory.links.association-details': 'Association',
        'app.association-inventory.links.adjust-avg-costs': 'Increase Avg Costs',
        'app.association-inventory.links.change-view': 'Change View',
        'app.association-inventory.links.delete-items': 'Delete Items',
        'app.association-inventory.links.delete-subgroup': 'Delete Subgroup',
        'app.association-inventory.links.export-list-to-excel': 'Export Inventory List to Excel',
        'app.association-inventory.links.mark-items-complete': 'Complete',
        'app.association-inventory.links.mark-items-incomplete': 'Incomplete',
        'app.association-inventory.links.mark-items-not-reviewed': 'Needs Review',
        'app.association-inventory.links.mark-items-reset-pictures-questions': 'Clear Pictures/Questions',
        'app.association-inventory.links.mark-items-reviewed': 'Reviewed',
        'app.association-inventory.links.move-items': 'Move Items',
        'app.association-inventory.links.print-report': 'Print Report',
        'app.association-inventory.links.rename-subgroup': 'Rename Subgroup',
        'app.association-inventory.links.reserve-study': 'Report',
        'app.association-inventory.links.set-items-completion': 'Bulk Complete',
        'app.association-inventory.links.set-items-reviewed': 'Bulk Review',
        'app.association-inventory.links.view-client-questions': 'Client Questions',
        'app.association-inventory.links.view-reserve-study': 'View Report',

        'app.association-inventory.modals.add-subgroup.title': 'Create New Subgroup',
        'app.association-inventory.modals.delete-items.title': 'Delete Items',
        'app.association-inventory.modals.delete-subgroup.title': 'Delete Subgroup',

        'app.association-inventory.modals.apply-template.note': 'Apply a saved inventory component template to this association. Note: Inventory components and their requisite subgroups will be automatically added!',
        'app.association-inventory.modals.apply-template.title': 'Apply Inventory Template',
        'app.association-inventory.modals.apply-template.name': 'Template Name',
        'app.association-inventory.modals.apply-template.description': 'Template Description',
        'app.association-inventory.modals.apply-template.success-button-title': 'Apply Inventory Template',

        'app.association-inventory.modals.add-template.note': 'Create a new template for your user account containing all shown inventory components and subgroups. Note: template will exclude pictures and optionally costs.',
        'app.association-inventory.modals.add-template.title': 'Add Inventory Template',
        'app.association-inventory.modals.add-template.name': 'Template Name',
        'app.association-inventory.modals.add-template.user': 'For User',
        'app.association-inventory.modals.add-template.description': 'Template Description',
        'app.association-inventory.modals.add-template.includeCostsCheckbox': 'Include Costs?',
        'app.association-inventory.modals.add-template.success-button-title': 'Add Inventory Template',

        'app.association-inventory.modals.duplicate-subgroup.association-destination': 'Destination Association',
        'app.association-inventory.modals.duplicate-subgroup.note': 'The subgroup, any assigned inventory will be copied to destination association. Note: destination subgroup code will be created automatically and may differ from source subgroup code.',
        'app.association-inventory.modals.duplicate-subgroup.subgroup': 'Source Subgroup',
        'app.association-inventory.modals.duplicate-subgroup.title': 'Duplicate Subgroup',

        'app.association-inventory.modals.move-items.title': 'Move Items',
        'app.association-inventory.modals.move-items.to-subgroup': 'To Subgroup',
        'app.association-inventory.modals.modify-avg-costs.label': 'Enter percentage to increase by:',
        'app.association-inventory.modals.rename-subgroup.title': 'Rename Subgroup',
        'app.association-inventory.modals.reset-item-pictures-questions.note': 'Warning: This action will clear all saved pictures and client questions field values for the selected items. Are you sure?',
        'app.association-inventory.modals.reset-item-pictures-questions.reset-items': 'Reset Items',
        'app.association-inventory.modals.reset-item-pictures-questions.title': 'Reset Item Pictures & Questions',

        'app.association-inventory.modals.bulk-update-items.generic.title': 'Set Multiple Inventory Items To {TOKEN_VALUE}',
        'app.association-inventory.modals.bulk-update-items.generic.note': 'Please confirm that you want all checked inventory items to be set as "{TOKEN_VALUE}". Once confirmed, the changes will be saved immediately. Are you sure?',
        'app.association-inventory.modals.bulk-update-items.generic.note-with-value':
            'Please confirm that you want all checked inventory items to have their average cost increased. Once confirmed, the changes will be saved immediately and CANNOT BE UNDONE. Are you sure?',
        'app.association-inventory.modals.bulk-update-items.generic.update-items': 'Update All To {TOKEN_VALUE}',
        'app.association-inventory.modals.bulk-update-items.generic.complete': 'Complete',
        'app.association-inventory.modals.bulk-update-items.generic.incomplete': 'Incomplete',
        'app.association-inventory.modals.bulk-update-items.generic.reviewed': 'Reviewed',
        'app.association-inventory.modals.bulk-update-items.generic.needs-review': 'Needs Review',
        'app.association-inventory.modals.bulk-update-items.generic.modify-avg-cost': 'Increase Avg Cost',

        'app.association-inventory.adjust-rul-years': 'Adjust RUL Years',
        'app.association-inventory.new-subgroup-code': 'Subgroup Code',
        'app.association-inventory.new-subgroup-template': 'Subgroup Template',
        'app.association-inventory.new-subgroup-title': 'Subgroup Title',
        'app.association-inventory.no-results': 'No results for association inventory subgroup',
        'app.association-inventory.of': 'of',
        'app.association-inventory.page-title': 'Association Inventory',
        'app.association-inventory.rename-subgroup-code': 'New Subgroup Code',
        'app.association-inventory.rename-subgroup-title': 'New Subgroup Title',
        'app.association-inventory.rename-subgroup': 'Rename Subgroup',
        'app.association-inventory.reset-component-ruls': 'Component List Manipulation',
        'app.association-inventory.reset-component-ruls-DEPRECATED': 'Subtract RULs & Reset Questions/Pictures',
        'app.association-inventory.restore-prev-pictures': 'Restore Previously Known Pictures',
        'app.association-inventory.reviewed-no': 'No',
        'app.association-inventory.reviewed-yes': 'Yes',
        'app.association-inventory.shown': 'Shown',
        'app.association-inventory.status': 'Status',
        'app.association-inventory.subgroup': 'Subgroup',
        'app.association-inventory.subgroups': 'Subgroups',
        'app.association-inventory.view-inventory-detail-link-title': 'View Details',

        'app.association-inventory-detail.invalid-inventory-id': 'This inventory does not exist.',
        'app.association-inventory-detail.association-details': 'Association Details',
        'app.association-inventory-detail.avg-cost': 'Avg Cost',
        'app.association-inventory-detail.best-cost-explanation': 'Best Explanation',
        'app.association-inventory-detail.best-cost': 'Best Cost',
        'app.association-inventory-detail.buttons.add-research': 'Add Research',
        'app.association-inventory-detail.buttons.calculate': 'Calculate Costs',
        'app.association-inventory-detail.buttons.delete-research': 'Delete Research',
        'app.association-inventory-detail.buttons.duplicate': 'Duplicate',
        'app.association-inventory-detail.buttons.inventory': 'View Inventory',
        'app.association-inventory-detail.buttons.new': 'New',
        'app.association-inventory-detail.buttons.property': 'Property Details',
        'app.association-inventory-detail.buttons.research-components': 'Research',
        'app.association-inventory-detail.buttons.select-picture': 'Done',
        'app.association-inventory-detail.cancel-changes': 'Cancel Changes',
        'app.association-inventory-detail.cancel': 'Cancel',
        'app.association-inventory-detail.change': 'Change',
        'app.association-inventory-detail.complete': 'Complete',
        'app.association-inventory-detail.component-decimal-number': 'Component Decimal',
        'app.association-inventory-detail.component-details': 'Component Details',
        'app.association-inventory-detail.component-number': 'Component Number',
        'app.association-inventory-detail.component-categories': 'Filter By Category',
        'app.association-inventory-detail.component-override-name': 'Override Component Name',
        'app.association-inventory-detail.component-pictures': 'Component Pictures',
        'app.association-inventory-detail.component-subgroup': 'Component Subgroup',
        'app.association-inventory-detail.component': 'Component',
        'app.association-inventory-detail.condition-level': 'Condition Level',
        'app.association-inventory-detail.condition-level-custom': 'Select A Condition Level, Or Enter Custom Text Below',
        'app.association-inventory-detail.condition': 'Condition',
        'app.association-inventory-detail.costs-discrepancy': 'Costs Discrepancy',
        'app.association-inventory-detail.costs-discrepancy.warning.body': 'Best and Worst Costs too far apart.',
        'app.association-inventory-detail.costs-discrepancy.warning.title': 'Costs Discrepancy',
        'app.association-inventory-detail.delete': 'Delete',
        'app.association-inventory-detail.evaluation': 'Evaluation',
        'app.association-inventory-detail.client-questions': 'Client Questions',
        'app.association-inventory-detail.explanation': 'Explanation',
        'app.association-inventory-detail.general-notes': 'General Notes',
        'app.association-inventory-detail.inventory-id': 'Inventory Id',
        'app.association-inventory-detail.links.add-new-component': 'Add New Component',
        'app.association-inventory-detail.links.add-new-research': 'Add New Research',
        'app.association-inventory-detail.links.add-subgroup': 'Add Subgroup',
        'app.association-inventory-detail.links.back-to-inventory-list': 'Back to Inventory List',
        'app.association-inventory-detail.links.calculate': 'Calculate',
        'app.association-inventory-detail.links.clear': 'Clear',
        'app.association-inventory-detail.links.duplicate-component': 'Duplicate Component',
        'app.association-inventory-detail.links.hide-images': 'Hide Assigned Images',
        'app.association-inventory-detail.links.next': 'Next >',
        'app.association-inventory-detail.links.previous': '< Previous',
        'app.association-inventory-detail.links.property-description': 'Property Description',
        'app.association-inventory-detail.links.research-components': 'Research Components',
        'app.association-inventory-detail.links.select': 'Select',
        'app.association-inventory-detail.links.view-condition-form': 'View Condition Form',
        'app.association-inventory-detail.links.view-image': 'View Image',
        'app.association-inventory-detail.location': 'Location',
        'app.association-inventory-detail.trash-disabled-title': 'Cannot delete the currently in-use explanation. A different explanation must be selected and saved prior to this one being deleted. If no other explanation is available, create one first.',

        'app.association-inventory-detail.modals.delete-research.body': 'You are about to delete this research item. This operation is permanent and cannot be undone.',
        'app.association-inventory-detail.modals.delete-research.cancel': 'Cancel',
        'app.association-inventory-detail.modals.delete-research.delete': 'Delete',
        'app.association-inventory-detail.modals.delete-research.title': 'Confirm Delete Research Item',
        'app.association-inventory-detail.modals.delete.body': 'You are about to delete this inventory item AND any attached research items. This operation is permanent and cannot be undone.',
        'app.association-inventory-detail.modals.delete.cancel': 'Cancel',
        'app.association-inventory-detail.modals.delete.delete': 'Delete',
        'app.association-inventory-detail.modals.delete.title': 'Confirm Delete Inventory Item',

        'app.association-inventory-detail.modals.replacement-costs.add-explanation': 'Add Explanation',
        'app.association-inventory-detail.modals.replacement-costs.add-explanation-notes': 'Add Notes',
        'app.association-inventory-detail.modals.replacement-costs.add-explanation-group': 'Add to Group',
        'app.association-inventory-detail.modals.replacement-costs.best-cost-explanations': 'Best Cost Explanations',
        'app.association-inventory-detail.modals.replacement-costs.best-cost': 'Best Cost',
        'app.association-inventory-detail.modals.replacement-costs.cancel': 'Cancel',
        'app.association-inventory-detail.modals.replacement-costs.component-details': 'Component Details',
        'app.association-inventory-detail.modals.replacement-costs.component-number': 'Component Number',
        'app.association-inventory-detail.modals.replacement-costs.component': 'Component',
        'app.association-inventory-detail.modals.replacement-costs.cost-type': 'Cost Type',
        'app.association-inventory-detail.modals.replacement-costs.delete': 'Delete',
        'app.association-inventory-detail.modals.replacement-costs.explanation': 'Explanation',
        'app.association-inventory-detail.modals.replacement-costs.groups': 'Groups',
        'app.association-inventory-detail.modals.replacement-costs.notes': 'Notes',
        'app.association-inventory-detail.modals.replacement-costs.title': 'Replacement Costs',
        'app.association-inventory-detail.modals.replacement-costs.worst-cost-explanations': 'Worst Cost Explanations',
        'app.association-inventory-detail.modals.replacement-costs.worst-cost': 'Worst Cost',

        'app.association-inventory-detail.modals.research-history.title': 'Research History',
        'app.association-inventory-detail.modals.research-history.existing-history': 'Research Existing History',

        'app.association-inventory-detail.modals.evaluations.title': 'Permanently Save Evaluation',
        'app.association-inventory-detail.modals.evaluations.component-id': 'Component Id',
        'app.association-inventory-detail.modals.evaluations.condition-level': 'Condition Level',
        'app.association-inventory-detail.modals.evaluations.additional-group': 'Add to Group',
        'app.association-inventory-detail.modals.evaluations.combo-group': 'Group Name',
        'app.association-inventory-detail.modals.evaluations.evaluation': 'Evaluation Text',
        'app.association-inventory-detail.modals.evaluations.set-as-evaluation': 'Apply ',
        'app.association-inventory-detail.modals.evaluations.edit-evaluation': 'Edit Evaluation',
        'app.association-inventory-detail.modals.evaluations.add-new-evaluation': 'Save and Close',
        'app.association-inventory-detail.modals.evaluations.form-title': 'Save evaluation as an option for future copies of this component',

        'app.association-inventory-detail.modals.save-changes.ignore-changes': 'Abandon Changes',
        'app.association-inventory-detail.modals.save-changes.title': 'Saving Changes...',
        'app.association-inventory-detail.modals.select-picture.currently-selected-picture': 'Currently Selected Picture',
        'app.association-inventory-detail.modals.select-picture.displaying': '',
        'app.association-inventory-detail.modals.select-picture.in-folder': 'in',
        'app.association-inventory-detail.modals.select-picture.picture': 'Picture',
        'app.association-inventory-detail.modals.select-picture.title': 'Select Component Picture for',
        'app.association-inventory-detail.modals.select-picture.upload-pictures-to-folder': 'Upload Pictures to Folder',
        'app.association-inventory-detail.next': 'Next',
        'app.association-inventory-detail.no-changes': 'No Changes',
        'app.association-inventory-detail.of': 'of',
        'app.association-inventory-detail.in-subgroup': 'in subgroup',
        'app.association-inventory-detail.page-title': 'Association Inventory Detail',
        'app.association-inventory-detail.path': 'Path',
        'app.association-inventory-detail.picture': 'Picture',
        'app.association-inventory-detail.previous': 'Prev',
        'app.association-inventory-detail.print-note': 'Print Note',
        'app.association-inventory-detail.print-client-questions': 'Print Client Questions',
        'app.association-inventory-detail.prompt.unsaved-changes.body': 'Warning: you have unsaved changes that will be lost if you continue. Press OK to abandon your changes, or press cancel to return to editing.',
        'app.association-inventory-detail.quantity': 'Quantity',
        'app.association-inventory-detail.remaining-useful-life': 'Remaining Useful Life',
        'app.association-inventory-detail.report-notes': 'Report Notes',
        'app.association-inventory-detail.research-history.company.placeholder': 'Company Name',
        'app.association-inventory-detail.research-history.company': 'Company',
        'app.association-inventory-detail.research-history.contact-first-name.placeholder': 'First Name',
        'app.association-inventory-detail.research-history.contact-first-name': 'First Name',
        'app.association-inventory-detail.research-history.contact-last-name.placeholder': 'Last Name',
        'app.association-inventory-detail.research-history.contact-last-name': 'Last Name',
        'app.association-inventory-detail.research-history.contact-name': 'Contact Name',
        'app.association-inventory-detail.research-history.phone.placeholder': '(000) 000-0000',
        'app.association-inventory-detail.research-history.phone': 'Phone',
        'app.association-inventory-detail.research-history.research-date': 'Research Date',
        'app.association-inventory-detail.research-history.project-date': 'Project Date',
        'app.association-inventory-detail.research-history.research-notes': 'Research Notes',
        'app.association-inventory-detail.research-history.researched-best-cost': 'Researched Best Cost',
        'app.association-inventory-detail.research-history.researched-ul': 'Researched UL',
        'app.association-inventory-detail.research-history.researched-worst-cost': 'Researched Worst Cost',
        'app.association-inventory-detail.research-history': 'Research History',
        'app.association-inventory-detail.reviewed': 'Reviewed',
        'app.association-inventory-detail.save': 'Save',
        'app.association-inventory-detail.shortcuts-to-other-components': 'Shortcuts to other Components',
        'app.association-inventory-detail.source': 'Source',
        'app.association-inventory-detail.spell-check': 'Spell Check',
        'app.association-inventory-detail.subgroup': 'Subgroup',
        'app.association-inventory-detail.useful-life': 'Useful Life',
        'app.association-inventory-detail.worst-cost-explanation': 'Worst Explanation',
        'app.association-inventory-detail.worst-cost': 'Worst Cost',

        'app.association-search.association-detail-link-title': 'View association details',
        'app.association-search.enter-keyword': 'Enter Keyword',
        'app.association-search.grid.column-headers.association-id': 'Id',
        'app.association-search.grid.column-headers.association-name': 'Association Name',
        'app.association-search.grid.column-headers.location': 'Location',
        'app.association-search.no-results': 'No matching associations found. Try changing your search term.',
        'app.association-search.page-title': 'Search Associations',
        'app.association-search.search-keyword': 'Search Keyword',
        'app.association-search.search-assoc-id': 'Search ID #',
        'app.association-search.enter-id': 'Enter ID #',
        'app.association-search.view-inventory-link-title': 'View inventory for association',
        'app.association-search.view-inventory': 'View Inventory',
        'app.association-search.view-order-link-title': 'View orders for association',
        'app.association-search.view-order': 'View Order',

        'app.client-dashboard.association-detail-link-title': 'View association details',
        'app.client-dashboard.enter-keyword': 'Enter Keyword',
        'app.client-dashboard.invited-user': 'Invited User',
        'app.client-dashboard.grid.column-headers.association-id': 'Id',
        'app.client-dashboard.grid.column-headers.association-name': 'Association Name',
        'app.client-dashboard.grid.column-headers.location': 'Location',
        'app.client-dashboard.no-results': 'No Associations To Display',
        'app.client-dashboard.no-results.1': 'You have not been invited to any associations',
        'app.client-dashboard.no-results.2': '- or -',
        'app.client-dashboard.no-results.3': 'Your ability to access any associations has been suspended',
        'app.client-dashboard.page-title': 'My Communities',
        'app.client-dashboard.managed-associations': 'Managed Associations',
        'app.client-dashboard.user-associations': 'Available Associations',
        'app.client-dashboard.search-keyword': 'Search Keyword',
        'app.client-dashboard.view-inventory': 'View Inventory',
        'app.client-dashboard.no-assocs.title': 'View Inventory',
        'app.client-dashboard.view-inventory-link-title': 'View inventory for association',

        'app.client-add.add-client-address': 'Client Address',
        'app.client-add.add-client-contact': 'Client Contact',
        'app.client-add.add-client-details': 'Client Details',
        'app.client-add.add-client-phone-numbers': 'Phone Numbers',
        'app.client-add.add-client': 'Add Client',
        'app.client-add.address.placeholder': '1234 Main St.',
        'app.client-add.address': 'Address',
        'app.client-add.address2.placeholder': 'Building, floor or suite',
        'app.client-add.address2': 'Address 2',
        'app.client-add.city.placeholder': '',
        'app.client-add.city': 'City',
        'app.client-add.client-name.placeholder': 'Enter Client Name',
        'app.client-add.client-name': 'Name',
        'app.client-add.client-type': 'Client Type',
        'app.client-add.contact-email.placeholder': 'Email',
        'app.client-add.contact-email': 'Email',
        'app.client-add.contact-firstname.placeholder': 'First Name',
        'app.client-add.contact-firstname': 'First Name',
        'app.client-add.contact-inactive': 'Inactive',
        'app.client-add.contact-lastname.placeholder': 'Last Name',
        'app.client-add.contact-lastname': 'Last Name',
        'app.client-add.contact-notes': 'Notes',
        'app.client-add.contact-phone': 'Phone',
        'app.client-add.contact-salutation': 'Salutation',
        'app.client-add.contact-title.placeholder': 'Title',
        'app.client-add.contact-title': 'Title',
        'app.client-add.country': 'Country',
        'app.client-add.fax': 'Fax',
        'app.client-add.inactive': 'Inactive',
        'app.client-add.notes': 'Notes',
        'app.client-add.page-title': 'Add Client',
        'app.client-add.phone-number.placeholder': '(___) ___-____',
        'app.client-add.phone': 'Phone',
        'app.client-add.region': 'Region',
        'app.client-add.select-option.placeholder': 'Choose...',
        'app.client-add.state': 'State',
        'app.client-add.zip.placeholder': '',
        'app.client-add.zip': 'Zip',

        'app.client-edit.add-client-address': 'Client Address',
        'app.client-edit.add-client-contact': 'Add new Contact',
        'app.client-edit.add-client-details': 'Client Details',
        'app.client-edit.add-client-phone-numbers': 'Phone Numbers',
        'app.client-edit.edit-client': 'Add Client',
        'app.client-edit.client-notes-add-author-text': 'Add new note',
        'app.client-edit.address.placeholder': '1234 Main St.',
        'app.client-edit.address': 'Address',
        'app.client-edit.address2.placeholder': 'Building, floor or suite',
        'app.client-edit.address2': 'Address 2',
        'app.client-edit.change': 'Change',
        'app.client-edit.city.placeholder': '',
        'app.client-edit.city': 'City',
        'app.client-edit.client-name.placeholder': 'Enter Client Name',
        'app.client-edit.client-name': 'Name',
        'app.client-edit.client-type': 'Client Type',
        'app.client-edit.contact-email.placeholder': 'Email',
        'app.client-edit.contact-email': 'Email',
        'app.client-edit.contact-firstname.placeholder': 'First Name',
        'app.client-edit.contact-firstname': 'First Name',
        'app.client-edit.contact-inactive': 'Inactive',
        'app.client-edit.contact-lastname.placeholder': 'Last Name',
        'app.client-edit.contact-lastname': 'Last Name',
        'app.client-edit.contact-notes': 'Notes',
        'app.client-edit.contact-phone': 'Phone',
        'app.client-edit.contact-salutation': 'Salutation',
        'app.client-edit.contact-title.placeholder': 'Title',
        'app.client-edit.contact-title': 'Title',
        'app.client-edit.country': 'Country',
        'app.client-edit.fax': 'Fax',
        'app.client-edit.inactive': 'Inactive',
        'app.client-edit.no-changes': 'No Changes',
        'app.client-edit.note-on': 'On',
        'app.client-edit.note-wrote': 'wrote',
        'app.client-edit.notes-add': 'Add New Note',
        'app.client-edit.notes': 'Notes',
        'app.client-edit.page-title': 'Add Client',
        'app.client-edit.phone-number.placeholder': '(___) ___-____',
        'app.client-edit.phone': 'Phone',
        'app.client-edit.region': 'Region',
        'app.client-edit.save-changes': 'Save Changes',
        'app.client-edit.save': 'Save',
        'app.client-edit.section-title.details': 'Client Details',
        'app.client-edit.section-title.contacts': 'Client Contacts',
        'app.client-edit.section-title.phone-numbers': 'Phone Numbers',
        'app.client-edit.section-title.location': 'Client Location',
        'app.client-edit.section-title.client-notes': 'Client Notes',
        'app.client-edit.select-option.placeholder': 'Choose...',
        'app.client-edit.state': 'State',
        'app.client-edit.zip.placeholder': '',
        'app.client-edit.zip': 'Zip',

        'app.client-detail.add-contact': 'Add Contact',
        'app.client-detail.address': 'Address',
        'app.client-detail.address2': 'Address 2',
        'app.client-detail.associations': 'Associations',
        'app.client-detail.city': 'City',
        'app.client-detail.client-id': 'Client Id',
        'app.client-detail.client-name': 'Name',
        'app.client-detail.client-notes': 'Client Notes',
        'app.client-detail.client-type': 'Client Type',
        'app.client-detail.contact-email.placeholder': 'Email',
        'app.client-detail.contact-email': 'Email',
        'app.client-detail.contact-firstname.placeholder': 'First Name',
        'app.client-detail.contact-firstname': 'First Name',
        'app.client-detail.contact-inactive': 'Inactive',
        'app.client-detail.contact-lastname.placeholder': 'Last Name',
        'app.client-detail.contact-lastname': 'Last Name',
        'app.client-detail.contact-notes': 'Notes',
        'app.client-detail.contact-phone': 'Phone',
        'app.client-detail.contact-salutation': 'Salutation',
        'app.client-detail.contact-title.placeholder': 'Title',
        'app.client-detail.contact-title': 'Title',
        'app.client-detail.contacts': 'Contacts',
        'app.client-detail.country': 'Country',
        'app.client-detail.edit-client': 'Edit Client',
        'app.client-detail.fax': 'Fax',
        'app.client-detail.inactive': 'Inactive',
        'app.client-detail.note-on': 'On',
        'app.client-detail.note-wrote': 'wrote',
        'app.client-detail.notes': 'Notes',
        'app.client-detail.page-title': 'Client Details',
        'app.client-detail.phone-number.placeholder': '(___) ___-____',
        'app.client-detail.phone': 'Phone',
        'app.client-detail.region': 'Region',
        'app.client-detail.select-option.placeholder': 'Choose...',
        'app.client-detail.state': 'State',
        'app.client-detail.view-association': 'View Association',
        'app.client-detail.zip': 'Zip',

        'app.client-search.client-detail-link-title': 'View client details',
        'app.client-search.enter-keyword': 'Enter Keyword',
        'app.client-search.grid.column-headers.client-id': 'Id',
        'app.client-search.grid.column-headers.client-name': 'Client Name',
        'app.client-search.grid.column-headers.location': 'Location',
        'app.client-search.no-results': 'No matching clients found. Try changing your search term.',
        'app.client-search.page-title': 'Search Clients',
        'app.client-search.search-keyword': 'Search Keyword',

        'app.client-contacts-search.client-detail-link-title': 'View client details',
        'app.client-contacts-search.enter-keyword': 'Enter Keyword',
        'app.client-contacts-search.filter-by-client-type': 'Client Type',
        'app.client-contacts-search.filter-by-region': 'Client Region',
        'app.client-contacts-search.grid.column-headers.client-id': 'Id',
        'app.client-contacts-search.grid.column-headers.client-name': 'Client Name',
        'app.client-contacts-search.grid.column-headers.client-phone': 'Client Phone',
        'app.client-contacts-search.grid.column-headers.client-region-name': 'Client Region',
        'app.client-contacts-search.grid.column-headers.client-type-name': 'Client Type',
        'app.client-contacts-search.grid.column-headers.client.client-details': 'Client Details',
        'app.client-contacts-search.grid.column-headers.client.client-id': 'Id',
        'app.client-contacts-search.grid.column-headers.client.client-address1': 'Address 1',
        'app.client-contacts-search.grid.column-headers.client.client-address2': 'Address 2',
        'app.client-contacts-search.grid.column-headers.client.client-city': 'City',
        'app.client-contacts-search.grid.column-headers.client.client-state': 'State',
        'app.client-contacts-search.grid.column-headers.client.client-zip': 'Zip',
        'app.client-contacts-search.grid.column-headers.client.client-city-state-zip': 'CityStateZip',
        'app.client-contacts-search.grid.column-headers.client.client-name': 'Name',
        'app.client-contacts-search.grid.column-headers.client.client-phone': 'Phone',
        'app.client-contacts-search.grid.column-headers.client.client-region-name': 'Region',
        'app.client-contacts-search.grid.column-headers.client.client-type-name': 'Type',
        'app.client-contacts-search.grid.column-headers.contact-email': 'Contact Email',
        'app.client-contacts-search.grid.column-headers.contact-first-name': 'First Name',
        'app.client-contacts-search.grid.column-headers.contact-id': 'Contact Id',
        'app.client-contacts-search.grid.column-headers.contact-last-name': 'Last Name',
        'app.client-contacts-search.grid.column-headers.contact-name': 'Contact Name',
        'app.client-contacts-search.grid.column-headers.contact-note': 'Contact Note',
        'app.client-contacts-search.grid.column-headers.contact-phone': 'Contact Phone',
        'app.client-contacts-search.grid.column-headers.contact-salutation': 'Contact Salutation',
        'app.client-contacts-search.grid.column-headers.contact-title': 'Contact Title',
        'app.client-contacts-search.grid.column-headers.contact.client-contact-details': 'Client Contact Details',
        'app.client-contacts-search.grid.column-headers.contact.contact-email': 'Email',
        'app.client-contacts-search.grid.column-headers.contact.contact-first-name': 'First Name',
        'app.client-contacts-search.grid.column-headers.contact.contact-id': 'Id',
        'app.client-contacts-search.grid.column-headers.contact.contact-last-name': 'Last Name',
        'app.client-contacts-search.grid.column-headers.contact.contact-name': 'Name',
        'app.client-contacts-search.grid.column-headers.contact.contact-note': 'Note',
        'app.client-contacts-search.grid.column-headers.contact.contact-phone': 'Phone',
        'app.client-contacts-search.grid.column-headers.contact.contact-salutation': 'Salutation',
        'app.client-contacts-search.grid.column-headers.contact.contact-title': 'Title',
        'app.client-contacts-search.grid.column-headers.contact.location': 'Location',
        'app.client-contacts-search.grid.column-headers.contact.region-name': 'Region',
        'app.client-contacts-search.grid.column-headers.location': 'Location',
        'app.client-contacts-search.grid.column-headers.region-name': 'Region',
        'app.client-contacts-search.no-results': 'No matching clients found. Try changing your search term.',
        'app.client-contacts-search.page-title': 'Search Client Contacts',
        'app.client-contacts-search.search-keyword': 'Search Keyword',
        'app.client-contacts-search.view-details-link-title': 'Details',
        'app.client-contacts-search.view-details': 'Details',

        'app.coordinator-jobs-search.filter-by-coordinator': 'Coordinator',
        'app.coordinator-jobs-search.filter-by-from-date': 'From Date',
        'app.coordinator-jobs-search.filter-by-paid': 'Coordinator Paid',
        'app.coordinator-jobs-search.filter-by-region': 'Region',
        'app.coordinator-jobs-search.filter-by-status': 'Status',
        'app.coordinator-jobs-search.filter-by-to-date': 'To Date',
        'app.coordinator-jobs-search.filter-option-paid-no': 'No (Unpaid)',
        'app.coordinator-jobs-search.filter-option-paid-yes': 'Yes (Paid)',
        'app.coordinator-jobs-search.grid.column-headers.accepted-price': 'Accepted Price',
        'app.coordinator-jobs-search.grid.column-headers.association-id': 'Assoc Id',
        'app.coordinator-jobs-search.grid.column-headers.association-name': 'Association',
        'app.coordinator-jobs-search.grid.column-headers.client-name': 'Client',
        'app.coordinator-jobs-search.grid.column-headers.completion-date': 'Completion Date',
        'app.coordinator-jobs-search.grid.column-headers.contact-email': 'Contact Email',
        'app.coordinator-jobs-search.grid.column-headers.contact-first-name': 'First Name',
        'app.coordinator-jobs-search.grid.column-headers.contact-last-name': 'Last Name',
        'app.coordinator-jobs-search.grid.column-headers.inspector-paid': 'Paid',
        'app.coordinator-jobs-search.grid.column-headers.region-name': 'Region',
        'app.coordinator-jobs-search.grid.column-headers.status-name': 'Status',
        'app.coordinator-jobs-search.no-results': 'No matching jobs found. Try changing your search criteria.',
        'app.coordinator-jobs-search.page-title': 'Search Coordinator Jobs',
        'app.coordinator-jobs-search.view-details': 'Details',
        'app.coordinator-jobs-search.set-all-paid': 'Set Selected to Paid',
        'app.coordinator-jobs-search.view-details-link-title': 'Details',
        'app.coordinator-jobs-search.modals.confirm-set-all-paid.title': 'Confirm Set Selected To Paid',
        'app.coordinator-jobs-search.modals.confirm-set-all-paid.body': 'Are you sure you want to set all the jobs selected in the grid to coordinator paid?',
        'app.coordinator-jobs-search.modals.confirm-set-all-paid.success': 'Set Selected to Paid',

        'app.dashboard.active-jobs.association-detail-link-title': 'View association details',
        'app.dashboard.active-jobs.filter-by-coordinator': 'Filter by Project Coordinator',
        'app.dashboard.active-jobs.filter-by-manager': 'Filter by Manager',
        'app.dashboard.active-jobs.filter-by-region-id': 'Filter by Region',
        'app.dashboard.active-jobs.filter-by-status-id': 'Filter by Status',
        'app.dashboard.active-jobs.filter-option-status-active': '- ACTIVE -',
        'app.dashboard.active-jobs.grid.column-headers.association-id': 'Id',
        'app.dashboard.active-jobs.grid.column-headers.association-name': 'Association Name',
        'app.dashboard.active-jobs.grid.column-headers.coordinator': 'Coordinator',
        'app.dashboard.active-jobs.grid.column-headers.due-date': 'Due Date',
        'app.dashboard.active-jobs.grid.column-headers.location': 'Location',
        'app.dashboard.active-jobs.grid.column-headers.manager': 'Manager',
        'app.dashboard.active-jobs.grid.column-headers.num-days': '# Days',
        'app.dashboard.active-jobs.grid.column-headers.price': 'Price',
        'app.dashboard.active-jobs.grid.column-headers.service-level': 'Service Level',
        'app.dashboard.active-jobs.grid.column-headers.start-date': 'Start Date',
        'app.dashboard.active-jobs.grid.column-headers.status': 'Status',
        'app.dashboard.active-jobs.list-of-active-jobs': 'List of Active Jobs',
        'app.dashboard.active-jobs.no-results': 'No matching jobs',
        'app.dashboard.active-jobs.page-title': 'Active Jobs',
        'app.dashboard.active-jobs.view-inventory-link-title': 'View inventory for association',
        'app.dashboard.active-jobs.view-inventory': 'View Inventory',
        'app.dashboard.active-jobs.view-order-link-title': 'View Order Details',
        'app.dashboard.active-jobs.view-order': 'View Order',
        'app.dashboard.page-title': 'Active Jobs Dashboard',
        'app.dashboard.active-jobs.google-earth-export': 'Google Earth Export',

        'app.prepared-bids.association-detail-link-title': 'View association details',
        'app.prepared-bids.filter-by-coordinator': 'Filter by Project Coordinator',
        'app.prepared-bids.filter-by-manager': 'Filter by Manager',
        'app.prepared-bids.filter-by-region-id': 'Filter by Region',
        'app.prepared-bids.filter-by-status-id': 'Filter by Status',
        'app.prepared-bids.filter-option-status-prepared-bids': '- BIDS TO PREPARE -',
        'app.prepared-bids.grid.column-headers.association-id': 'Id',
        'app.prepared-bids.grid.column-headers.association-name': 'Association Name',
        'app.prepared-bids.grid.column-headers.coordinator': 'Coordinator',
        'app.prepared-bids.grid.column-headers.due-date': 'Due Date',
        'app.prepared-bids.grid.column-headers.bid-date': 'Bid Date',
        'app.prepared-bids.grid.column-headers.location': 'Location',
        'app.prepared-bids.grid.column-headers.manager': 'Manager',
        'app.prepared-bids.grid.column-headers.num-days': '# Days',
        'app.prepared-bids.grid.column-headers.price': 'Price',
        'app.prepared-bids.grid.column-headers.service-level': 'Service Level',
        'app.prepared-bids.grid.column-headers.start-date': 'Start Date',
        'app.prepared-bids.grid.column-headers.status': 'Status',
        'app.prepared-bids.list-of-prepared-bids': 'List of Bids to Prepare',
        'app.prepared-bids.no-results': 'No matching bids',
        'app.prepared-bids.page-title': 'Prepare Bids',
        'app.prepared-bids.view-inventory-link-title': 'View inventory for association',
        'app.prepared-bids.view-inventory': 'View Inventory',
        'app.prepared-bids.view-bid-link-title': 'View Bid Details',
        'app.prepared-bids.view-bid': 'View Bid',

        'app.send-bids.association-detail-link-title': 'View association details',
        'app.send-bids.client-detail-link-title': 'View client details',
        'app.send-bids.filter-by-coordinator': 'Filter by Project Coordinator',
        'app.send-bids.filter-by-manager': 'Filter by Manager',
        'app.send-bids.filter-by-region-id': 'Filter by Region',
        'app.send-bids.filter-by-status-id': 'Filter by Status',
        'app.send-bids.filter-option-status-send-bids': '- BIDS TO SEND -',
        'app.send-bids.grid.column-headers.association-id': 'Id',
        'app.send-bids.grid.column-headers.association-name': 'Association Name',
        'app.send-bids.grid.column-headers.coordinator': 'Coordinator',
        'app.send-bids.grid.column-headers.due-date': 'Due Date',
        'app.send-bids.grid.column-headers.bid-date': 'Bid Date',
        'app.send-bids.grid.column-headers.location': 'Location',
        'app.send-bids.grid.column-headers.client-name': 'Client Name',
        'app.send-bids.grid.column-headers.manager': 'Manager',
        'app.send-bids.grid.column-headers.num-days': '# Days',
        'app.send-bids.grid.column-headers.price': 'Price',
        'app.send-bids.grid.column-headers.service-level': 'Service Level',
        'app.send-bids.grid.column-headers.start-date': 'Start Date',
        'app.send-bids.grid.column-headers.status': 'Status',
        'app.send-bids.list-of-send-bids': 'List of Bids to Send',
        'app.send-bids.modals.set-bids-sent.title': 'Set Selected Bids Sent',
        'app.send-bids.modals.set-bids-sent.bid-sent-date': 'Set Bid Sent Date',
        'app.send-bids.modals.set-bids-sent.set-bids-sent': 'Set Bids Sent',
        'app.send-bids.no-results': 'No matching bids',
        'app.send-bids.page-title': 'Send Bids',
        'app.send-bids.view-inventory-link-title': 'View inventory for association',
        'app.send-bids.view-inventory': 'View Inventory',
        'app.send-bids.view-bid-link-title': 'View Bid Details',
        'app.send-bids.view-bid': 'View Bid',
        'app.send-bids.links.print-selected-envelopes': 'Print Selected Envelopes',
        'app.send-bids.links.print-selected-bids': 'Print Selected Bids',
        'app.send-bids.links.set-selected-to-sent': 'Set Selected To Sent',

        'app.association-export-orders.association-detail-link-title': 'View association details',
        'app.association-export-orders.filter-by-coordinator': 'Filter by Project Coordinator',
        'app.association-export-orders.filter-by-from-bid-date': 'From Bid Date',
        'app.association-export-orders.filter-by-manager': 'Filter by Manager',
        'app.association-export-orders.filter-by-region-id': 'Filter by Region',
        'app.association-export-orders.filter-by-status-id': 'Filter by Status',
        'app.association-export-orders.filter-by-to-bid-date': 'To Bid Date',
        'app.association-export-orders.filter-option-status-active': '- ACTIVE -',
        'app.association-export-orders.filter-option-status-won-sent': '- SENT/WON -',
        'app.association-export-orders.grid.column-headers.association-address': 'Address',
        'app.association-export-orders.grid.column-headers.association-id': 'Id',
        'app.association-export-orders.grid.column-headers.association-name': 'Association Name',
        'app.association-export-orders.grid.column-headers.association-address1': 'Association Address 1',
        'app.association-export-orders.grid.column-headers.association-address2': 'Association Address 2',
        'app.association-export-orders.grid.column-headers.association-city': 'Association City',
        'app.association-export-orders.grid.column-headers.association-state': 'Association State',
        'app.association-export-orders.grid.column-headers.association-zip': 'Association Zip',
        'app.association-export-orders.grid.column-headers.association-type-name': 'Association Type',
        'app.association-export-orders.grid.column-headers.bid-date': 'Bid Date',
        'app.association-export-orders.grid.column-headers.bid-sent-date': 'Bid Sent Date',
        'app.association-export-orders.grid.column-headers.coordinator': 'Coordinator',
        'app.association-export-orders.grid.column-headers.due-date': 'Due Date',
        'app.association-export-orders.grid.column-headers.location': 'Location',
        'app.association-export-orders.grid.column-headers.manager': 'Manager',
        'app.association-export-orders.grid.column-headers.num-days': '# Days',
        'app.association-export-orders.grid.column-headers.order-id': 'Order Id',
        'app.association-export-orders.grid.column-headers.price': 'Price',
        'app.association-export-orders.grid.column-headers.region-name': 'Region',
        'app.association-export-orders.grid.column-headers.service-level': 'Service Level',
        'app.association-export-orders.grid.column-headers.start-date': 'Start Date',
        'app.association-export-orders.grid.column-headers.status': 'Status',
        'app.association-export-orders.grid.column-headers.won-date': 'Won Date',
        'app.association-export-orders.list-of-won-sent-jobs': 'List of Won/Sent Jobs',
        'app.association-export-orders.no-results': 'No matching jobs',
        'app.association-export-orders.page-title': 'Export Association Orders',
        'app.association-export-orders.view-inventory-link-title': 'View inventory for association',
        'app.association-export-orders.view-inventory': 'View Inventory',
        'app.association-export-orders.view-order-link-title': 'View Order Details',
        'app.association-export-orders.view-order': 'View Order',
        'app.association-export-orders.google-earth-export': 'Google Earth Export',

        'app.default-managers.edit-region-link': 'Edit Region',
        'app.default-managers.grid.column-headers.coordinator': 'Project Coordinator',
        'app.default-managers.grid.column-headers.manager': 'Manager',
        'app.default-managers.grid.column-headers.region-name': 'Region',
        'app.default-managers.no-results': 'No matching regions found',
        // 'app.default-managers.page-title': 'Edit Region (Default Manager, Coordinator)',
        'app.default-managers.page-title': 'Edit Region',
        'app.default-managers.region-default-manager': 'Default Manager',
        'app.default-managers.region-default-site-inspector': 'Default Site Inspector',
        'app.default-managers.region-default-users': 'Region Default Users',
        'app.default-managers.region-description': 'Region Description',
        'app.default-managers.region-id': 'Region Id',
        'app.default-managers.region-information': 'Region Information',
        'app.default-managers.region-name': 'Region Name',
        'app.default-managers.region-office-included': 'Included',
        'app.default-managers.region-offices': 'Region Offices',
        'app.default-managers.region-offices-assigned-to-region': 'Offices Assigned to Region',

        'app.app-layout.home': 'Home',
        'app.app-layout.page-title': 'AppLayout page title',

        'app.app-internal.page-title': 'AppInternal page title',

        'app.login.login': 'LOGIN',
        'app.login.login-account-login': 'Account Login',
        'app.login.login-instructions-1': 'Tap the button below, then enter your username and password when prompted.',
        'app.login.login-instructions-2': 'If you need help, please send us an email at',

        'app.activate-account.page-title': 'Activate Account',

        'app.activate-login.activate-account': 'ACTIVATE ACCOUNT',
        'app.activate-login.enter-your-password': 'Enter your password',
        'app.activate-login.username': 'Username',
        'app.activate-login.password': 'Password',
        'app.activate-login.create-new-password': 'Create a new password',
        'app.activate-login.new-password': 'New Password',
        'app.activate-login.new-password-confirm': 'Confirm Password',
        'app.activate-login.activate-your-account': 'Activate Your Account',
        'app.activate-login.activate-instructions-1': 'To activate your account, you\'ll need to enter the password that we emailed to you.',
        'app.activate-login.activate-instructions-2': 'If you didn\'t receive the email, try checking your junk or spam mail folder.',
        'app.activate-login.activate-instructions-2-change-password': 'Next, we require you to set a new account password that you\'ll use to login to the app.',
        'app.activate-login.activate-instructions-3': 'If you need help, please send us an email at',

        'app.user-change-password.change-your-password': 'CHANGE PASSWORD',
        'app.user-change-password.create-new-password': 'Create a new password',
        'app.user-change-password.enter-your-password': 'Enter your password',
        'app.user-change-password.instructions-1': 'Before continuing, we require you to change your account password. Use the form below',
        'app.user-change-password.instructions-2': 'to enter your current account password and then to choose a new password.',
        'app.user-change-password.instructions-3': 'If you need help, please send us an email at',
        'app.user-change-password.new-password-confirm': 'Confirm Password',
        'app.user-change-password.new-password': 'New Password',
        'app.user-change-password.password': 'Password',
        'app.user-change-password.update-account': 'Update Account',
        'app.user-change-password.username': 'Username',

        'app.lookup-tables.lookup-table': 'Lookup Table',
        'app.lookup-tables.lookup-tables': 'Lookup Tables',
        'app.lookup-tables.confirm.confirm-delete': 'Warning! Are you sure you want to permanently delete this item?',

        'app.lookup-tables.modals.delete-lookup-obj.generic.title': 'Delete Lookup Object {TOKEN_VALUE}',
        'app.lookup-tables.modals.delete-lookup-obj.generic.note': 'Please confirm that you want to remove the lookup object "{TOKEN_VALUE}".',
        'app.lookup-tables.modals.delete-lookup-obj.generic.note-2': 'If there are records that reference this lookup value, they be updated automatically to prevent orphan records. Use the form below to configure how this action will be applied.',
        'app.lookup-tables.modals.delete-lookup-obj.generic.delete-object': 'Delete {TOKEN_VALUE}',
        'app.lookup-tables.modals.delete-lookup-obj.generic.choose-default-type': 'Choose Default Type',

        'app.lookup-tables.modals.delete-lookup-obj.association-types.title': 'Delete Association Type',
        'app.lookup-tables.modals.delete-lookup-obj.association-types.note': 'Warning! Are you sure you want to permanently delete this association type?',
        'app.lookup-tables.modals.delete-lookup-obj.association-types.note-2': 'To continue, you must select a replacement Association Type to be applied on any records that reference the one being deleted',
        'app.lookup-tables.modals.delete-lookup-obj.association-types.delete-object': 'Delete Association Type',
        'app.lookup-tables.modals.delete-lookup-obj.association-types.choose-default-type': 'Replacement Type',
        'app.lookup-tables.modals.delete-lookup-obj.association-types.pending-deletion': 'Delete Type',

        'app.lookup-tables.modals.delete-lookup-obj.client-types.title': 'Delete Client Type',
        'app.lookup-tables.modals.delete-lookup-obj.client-types.note': 'Warning! Are you sure you want to permanently delete this client type?',
        'app.lookup-tables.modals.delete-lookup-obj.client-types.note-2': 'To continue, you must select a replacement Client Type to be applied on any records that reference the one being deleted',
        'app.lookup-tables.modals.delete-lookup-obj.client-types.delete-object': 'Delete Client Type',
        'app.lookup-tables.modals.delete-lookup-obj.client-types.choose-default-type': 'Replacement Type',
        'app.lookup-tables.modals.delete-lookup-obj.client-types.pending-deletion': 'Delete Type',

        'app.lookup-tables.modals.delete-lookup-obj.roof-types.title': 'Delete Roof Type',
        'app.lookup-tables.modals.delete-lookup-obj.roof-types.note': 'Warning! Are you sure you want to permanently delete this roof type?',
        'app.lookup-tables.modals.delete-lookup-obj.roof-types.note-2': 'To continue, you must select a replacement Roof Type to be applied on any records that reference the one being deleted',
        'app.lookup-tables.modals.delete-lookup-obj.roof-types.delete-object': 'Delete Roof Type',
        'app.lookup-tables.modals.delete-lookup-obj.roof-types.choose-default-type': 'Replacement Type',
        'app.lookup-tables.modals.delete-lookup-obj.roof-types.pending-deletion': 'Delete Type',

        'app.lookup-tables.modals.delete-lookup-obj.fencing-types.title': 'Delete Fencing Type',
        'app.lookup-tables.modals.delete-lookup-obj.fencing-types.note': 'Warning! Are you sure you want to permanently delete this fencing type?',
        'app.lookup-tables.modals.delete-lookup-obj.fencing-types.note-2': 'To continue, you must select a replacement Fencing Type to be applied on any records that reference the one being deleted',
        'app.lookup-tables.modals.delete-lookup-obj.fencing-types.delete-object': 'Delete Fencing Type',
        'app.lookup-tables.modals.delete-lookup-obj.fencing-types.choose-default-type': 'Replacement Type',
        'app.lookup-tables.modals.delete-lookup-obj.fencing-types.pending-deletion': 'Delete Type',

        'app.lookup-tables.modals.delete-lookup-obj.siding-types.title': 'Delete Siding Type',
        'app.lookup-tables.modals.delete-lookup-obj.siding-types.note': 'Warning! Are you sure you want to permanently delete this siding type?',
        'app.lookup-tables.modals.delete-lookup-obj.siding-types.note-2': 'To continue, you must select a replacement Siding Type to be applied on any records that reference the one being deleted',
        'app.lookup-tables.modals.delete-lookup-obj.siding-types.delete-object': 'Delete Siding Type',
        'app.lookup-tables.modals.delete-lookup-obj.siding-types.choose-default-type': 'Replacement Type',
        'app.lookup-tables.modals.delete-lookup-obj.siding-types.pending-deletion': 'Delete Type',

        'app.lookup-tables.modals.delete-lookup-obj.secured-types.title': 'Delete Secured Type',
        'app.lookup-tables.modals.delete-lookup-obj.secured-types.note': 'Warning! Are you sure you want to permanently delete this secured type?',
        'app.lookup-tables.modals.delete-lookup-obj.secured-types.note-2': 'To continue, you must select a replacement Secured Type to be applied on any records that reference the one being deleted',
        'app.lookup-tables.modals.delete-lookup-obj.secured-types.delete-object': 'Delete Secured Type',
        'app.lookup-tables.modals.delete-lookup-obj.secured-types.choose-default-type': 'Replacement Type',
        'app.lookup-tables.modals.delete-lookup-obj.secured-types.pending-deletion': 'Delete Type',

        'app.lookup-tables.modals.delete-lookup-obj.rec-room-types.title': 'Delete Rec Room Type',
        'app.lookup-tables.modals.delete-lookup-obj.rec-room-types.note': 'Warning! Are you sure you want to permanently delete this rec room type?',
        'app.lookup-tables.modals.delete-lookup-obj.rec-room-types.note-2': 'To continue, you must select a replacement Rec Room Type to be applied on any records that reference the one being deleted',
        'app.lookup-tables.modals.delete-lookup-obj.rec-room-types.delete-object': 'Delete Rec Room Type',
        'app.lookup-tables.modals.delete-lookup-obj.rec-room-types.choose-default-type': 'Replacement Type',
        'app.lookup-tables.modals.delete-lookup-obj.rec-room-types.pending-deletion': 'Delete Type',

        'app.lookup-tables.modals.delete-lookup-obj.status-levels.title': 'Delete Status Level',
        'app.lookup-tables.modals.delete-lookup-obj.status-levels.note': 'Warning! Are you sure you want to permanently delete this order status level?',
        'app.lookup-tables.modals.delete-lookup-obj.status-levels.note-2': 'To continue, you must select a replacement Status Level to be applied on any records that reference the one being deleted',
        'app.lookup-tables.modals.delete-lookup-obj.status-levels.delete-object': 'Delete Status Level',
        'app.lookup-tables.modals.delete-lookup-obj.status-levels.choose-default-type': 'Replacement Status',
        'app.lookup-tables.modals.delete-lookup-obj.status-levels.pending-deletion': 'Delete Status',

        'app.lookup-tables.modals.delete-lookup-obj.regions.title': 'Delete Region',
        'app.lookup-tables.modals.delete-lookup-obj.regions.note': 'Warning! Are you sure you want to permanently delete this region?',
        'app.lookup-tables.modals.delete-lookup-obj.regions.note-2': 'To continue, you must select a replacement Region to be applied on any records that reference the one being deleted',
        'app.lookup-tables.modals.delete-lookup-obj.regions.delete-object': 'Delete Region',
        'app.lookup-tables.modals.delete-lookup-obj.regions.choose-default-type': 'Replacement Region',
        'app.lookup-tables.modals.delete-lookup-obj.regions.pending-deletion': 'Delete Region',

        'app.lookup-tables.modals.delete-lookup-obj.component-categories.title': 'Delete Category',
        'app.lookup-tables.modals.delete-lookup-obj.component-categories.note': 'Warning! Are you sure you want to permanently delete this component category?',
        'app.lookup-tables.modals.delete-lookup-obj.component-categories.note-2': 'To continue, you must select a replacement Category to be applied on any records that reference the one being deleted',
        'app.lookup-tables.modals.delete-lookup-obj.component-categories.delete-object': 'Delete Category',
        'app.lookup-tables.modals.delete-lookup-obj.component-categories.choose-default-type': 'Replacement Category',
        'app.lookup-tables.modals.delete-lookup-obj.component-categories.pending-deletion': 'Delete Category',

        'app.lookup-tables.modals.delete-lookup-obj.components.title': 'Delete Component',
        'app.lookup-tables.modals.delete-lookup-obj.components.note': 'Warning! Are you sure you want to permanently delete this component?',
        'app.lookup-tables.modals.delete-lookup-obj.components.note-2': 'To continue, you must select a replacement Component to be applied on any records that reference the one being deleted',
        'app.lookup-tables.modals.delete-lookup-obj.components.delete-object': 'Delete Component',
        'app.lookup-tables.modals.delete-lookup-obj.components.choose-default-type': 'Replacement Component',
        'app.lookup-tables.modals.delete-lookup-obj.components.pending-deletion': 'Delete Component',

        'app.lookup-tables.modals.delete-lookup-obj.component-locations.title': 'Delete Component Locations',
        'app.lookup-tables.modals.delete-lookup-obj.component-locations.note': 'Warning! Are you sure you want to permanently delete this component\'s locations?',
        'app.lookup-tables.modals.delete-lookup-obj.component-locations.note-2': 'To continue, you must confirm this action by pressing the confirm button below, which will remove any assigned Component Locations from the chosen component.',
        'app.lookup-tables.modals.delete-lookup-obj.component-locations.delete-object': 'Delete Locations',
        'app.lookup-tables.modals.delete-lookup-obj.component-locations.choose-default-type': '',
        'app.lookup-tables.modals.delete-lookup-obj.component-locations.pending-deletion': 'Delete Locations',

        'app.lookup-tables.modals.delete-lookup-obj.inventory-templates.title': 'Delete Inventory Template',
        'app.lookup-tables.modals.delete-lookup-obj.inventory-templates.note': 'Warning! Are you sure you want to permanently delete this inventory template?',
        'app.lookup-tables.modals.delete-lookup-obj.inventory-templates.note-2': 'To continue, you must confirm this action by pressing the confirm button below, which will remove the selected Inventory Template.',
        'app.lookup-tables.modals.delete-lookup-obj.inventory-templates.delete-object': 'Delete Template',
        'app.lookup-tables.modals.delete-lookup-obj.inventory-templates.choose-default-type': '',
        'app.lookup-tables.modals.delete-lookup-obj.inventory-templates.pending-deletion': 'Delete Template',

        'app.lookup-tables.modals.delete-lookup-obj.replacement-cost-types.title': 'Delete Replacement Cost Type',
        'app.lookup-tables.modals.delete-lookup-obj.replacement-cost-types.note': 'Warning! Are you sure you want to permanently delete this replacement cost type?',
        'app.lookup-tables.modals.delete-lookup-obj.replacement-cost-types.note-2': 'To continue, you must select a replacement Replacement Cost Type to be applied on any records that reference the one being deleted',
        'app.lookup-tables.modals.delete-lookup-obj.replacement-cost-types.delete-object': 'Delete Replacement Cost Type',
        'app.lookup-tables.modals.delete-lookup-obj.replacement-cost-types.choose-default-type': 'Replacement Cost Type',
        'app.lookup-tables.modals.delete-lookup-obj.replacement-cost-types.pending-deletion': 'Delete Replacement Cost Type',

        'app.lookup-tables.modals.delete-lookup-obj.service-levels.title': 'Delete Service Level',
        'app.lookup-tables.modals.delete-lookup-obj.service-levels.note': 'Warning! Are you sure you want to permanently delete this service level?',
        'app.lookup-tables.modals.delete-lookup-obj.service-levels.note-2': 'To continue, you must select a replacement Service Level to be applied on any records that reference the one being deleted',
        'app.lookup-tables.modals.delete-lookup-obj.service-levels.delete-object': 'Delete Service Level',
        'app.lookup-tables.modals.delete-lookup-obj.service-levels.choose-default-type': 'Replacement Service Level',
        'app.lookup-tables.modals.delete-lookup-obj.service-levels.pending-deletion': 'Delete Service Level',

        'app.lookup-tables.modals.delete-lookup-obj.replacement-costs.title': 'Delete Replacement Cost',
        'app.lookup-tables.modals.delete-lookup-obj.replacement-costs.note': 'Warning! Are you sure you want to permanently delete this replacement cost?',
        'app.lookup-tables.modals.delete-lookup-obj.replacement-costs.note-2': 'To continue, you must select a replacement Replacement Cost to be applied on any records that reference the one being deleted',
        'app.lookup-tables.modals.delete-lookup-obj.replacement-costs.delete-object': 'Delete Replacement Cost',
        'app.lookup-tables.modals.delete-lookup-obj.replacement-costs.choose-default-type': 'Replacement Cost',
        'app.lookup-tables.modals.delete-lookup-obj.replacement-costs.pending-deletion': 'Delete Replacement Cost',

        'app.lookup-tables.modals.delete-lookup-obj.group-components-standard-evaluations.title': 'Delete Standard Evaluations',
        'app.lookup-tables.modals.delete-lookup-obj.group-components-standard-evaluations.note': 'Warning! Are you sure you want to permanently delete these standard evaluations?',
        'app.lookup-tables.modals.delete-lookup-obj.group-components-standard-evaluations.note-2': 'To continue, you must confirm this action by pressing the confirm button below, which will remove all referenced standard evaluations.',
        'app.lookup-tables.modals.delete-lookup-obj.group-components-standard-evaluations.delete-object': 'Delete Standard Evaluations',
        'app.lookup-tables.modals.delete-lookup-obj.group-components-standard-evaluations.choose-default-type': '',
        'app.lookup-tables.modals.delete-lookup-obj.group-components-standard-evaluations.pending-deletion': 'Delete Standard Evaluations',

        'app.lookup-tables.page-title': 'Database Management',
        'app.lookup-tables.system-configuration': 'System Configuration Data Tables',

        'app.lookup-tables.tables.textContents.description': 'Text Content',
        'app.lookup-tables.tables.textContents.name': 'Content Name',
        'app.lookup-tables.tables.textContents.table-title': 'Text Contents',
        'app.lookup-tables.tables.textContents.textContentKey': 'Key',
        'app.lookup-tables.tables.textContents.contents': 'Contents',
        'app.lookup-tables.tables.textContents.table-description': 'Manage text content. Edit bid letter and report text values.',

        'app.lookup-tables.tables.associationTypes.description': 'Type Description',
        'app.lookup-tables.tables.associationTypes.table-title': 'Association Types',
        'app.lookup-tables.tables.associationTypes.name': 'Association Type Name',
        'app.lookup-tables.tables.associationTypes.table-description': 'Manage association types. Edit the names and descriptions of existing types, or add new documents.',
        'app.lookup-tables.tables.associationTypes.associationTypeId': 'Id',

        'app.lookup-tables.tables.fencingTypes.description': 'Fencing Description',
        'app.lookup-tables.tables.fencingTypes.name': 'Fencing Type Name',
        'app.lookup-tables.tables.fencingTypes.table-title': 'Fencing Types',
        'app.lookup-tables.tables.fencingTypes.fencingTypeId': 'Id',
        'app.lookup-tables.tables.fencingTypes.table-description': 'Manage fencing types. Edit the names and descriptions of existing types, or add new documents.',

        'app.lookup-tables.tables.roofTypes.description': 'Roof Description',
        'app.lookup-tables.tables.roofTypes.name': 'Roof Type Name',
        'app.lookup-tables.tables.roofTypes.table-title': 'Roof Types',
        'app.lookup-tables.tables.roofTypes.roofTypeId': 'Id',
        'app.lookup-tables.tables.roofTypes.table-description': 'Manage roof types. Edit the names and descriptions of existing types, or add new documents.',

        'app.lookup-tables.tables.sidingTypes.description': 'Siding Description',
        'app.lookup-tables.tables.sidingTypes.name': 'Siding Type Name',
        'app.lookup-tables.tables.sidingTypes.table-title': 'Siding Types',
        'app.lookup-tables.tables.sidingTypes.sidingTypeId': 'Id',
        'app.lookup-tables.tables.sidingTypes.table-description': 'Manage siding types. Edit the names and descriptions of existing types, or add new documents.',

        'app.lookup-tables.tables.securedTypes.description': 'Secured Description',
        'app.lookup-tables.tables.securedTypes.name': 'Secured Type Name',
        'app.lookup-tables.tables.securedTypes.table-title': 'Secured Types',
        'app.lookup-tables.tables.securedTypes.securedTypeId': 'Id',
        'app.lookup-tables.tables.securedTypes.table-description': 'Manage secured types. Edit the names and descriptions of existing types, or add new documents.',

        'app.lookup-tables.tables.recRoomTypes.description': 'Recreation Rooms Description',
        'app.lookup-tables.tables.recRoomTypes.name': 'Recreation Rooms Type Name',
        'app.lookup-tables.tables.recRoomTypes.table-title': 'Recreation Room Types',
        'app.lookup-tables.tables.recRoomTypes.recRoomTypeId': 'Id',
        'app.lookup-tables.tables.recRoomTypes.table-description': 'Manage recreation room types. Edit the names and descriptions of existing types, or add new documents.',

        'app.lookup-tables.tables.clientTypes.table-title': 'Client Types',
        'app.lookup-tables.tables.clientTypes.name': 'Client Type Name',
        'app.lookup-tables.tables.clientTypes.clientTypeId': 'Id',
        'app.lookup-tables.tables.clientTypes.table-description': 'Manage client types. Edit the names and descriptions of existing types, or add new documents.',

        'app.lookup-tables.tables.componentCategories.name': 'Category Name',
        'app.lookup-tables.tables.componentCategories.table-title': 'Component Categories',
        'app.lookup-tables.tables.componentCategories.description': 'Description',
        'app.lookup-tables.tables.componentCategories.categoryId': 'Id',
        'app.lookup-tables.tables.componentCategories.table-description': 'Manage component categories. Edit the category titles and descriptions of existing component categories, or add new documents.',

        'app.lookup-tables.tables.componentLocations.componentId': 'Component Id',
        'app.lookup-tables.tables.componentLocations.locations': 'Locations',
        'app.lookup-tables.tables.componentLocations.name': 'Component Name',
        'app.lookup-tables.tables.componentLocations.table-title': 'Component Locations',
        'app.lookup-tables.tables.componentLocations.table-description': 'Manage component locations. Edit the component ids and location titles, or add new documents, or add new documents.',

        'app.lookup-tables.tables.components.name': 'Component Name',
        'app.lookup-tables.tables.components.componentId': 'Id',
        'app.lookup-tables.tables.components.componentCategoryId': 'Category Id',
        'app.lookup-tables.tables.components.table-title': 'Components',
        'app.lookup-tables.tables.components.summary': 'Summary',
        'app.lookup-tables.tables.components.usefulLife': 'Useful Life',
        'app.lookup-tables.tables.components.inactive': 'Inactive',
        'app.lookup-tables.tables.components.table-description': 'Manage components. Edit the component category, name useful life and summary text, or add new documents.',

        'app.lookup-tables.tables.groupComponentsStandardEvaluations.componentId': 'Component Id',
        'app.lookup-tables.tables.groupComponentsStandardEvaluations.table-title': 'Standard Evaluations',
        'app.lookup-tables.tables.groupComponentsStandardEvaluations.conditionLevel': 'Condition Level',
        'app.lookup-tables.tables.groupComponentsStandardEvaluations.evaluation': 'Evaluation',
        'app.lookup-tables.tables.groupComponentsStandardEvaluations.groupId': 'Group Id',
        'app.lookup-tables.tables.groupComponentsStandardEvaluations.table-description': 'Manage standard evaluations. Edit the component id, condition level, evaluation text and group id, or add new documents.',

        'app.lookup-tables.tables.inventoryTemplates.name': 'Template Name',
        'app.lookup-tables.tables.inventoryTemplates.templateId': 'Id',
        'app.lookup-tables.tables.inventoryTemplates.table-title': 'Inventory Templates',
        'app.lookup-tables.tables.inventoryTemplates.groupId': 'Group Id',
        'app.lookup-tables.tables.inventoryTemplates.regionId': 'Region Id',
        'app.lookup-tables.tables.inventoryTemplates.table-description': 'Manage inventory templates. Add/Edit/Delete existing inventory templates, or add new documents.',

        'app.lookup-tables.tables.inventoryTemplatesGroupsComponents.componentId': 'Component Id',
        'app.lookup-tables.tables.inventoryTemplatesGroupsComponents.templateName': 'Template Name',
        'app.lookup-tables.tables.inventoryTemplatesGroupsComponents.location': 'Location',
        'app.lookup-tables.tables.inventoryTemplatesGroupsComponents.table-title': 'Template Components',
        'app.lookup-tables.tables.inventoryTemplatesGroupsComponents.quantity': 'Quantity',
        'app.lookup-tables.tables.inventoryTemplatesGroupsComponents.usefulLife': 'Useful Life',
        'app.lookup-tables.tables.inventoryTemplatesGroupsComponents.table-description': 'Manage inventory templates. Add/Edit/Delete existing templates along with the components they contain, or add new documents.',

        'app.lookup-tables.tables.inventoryTemplateGroupComponents.componentId': 'Component Id',
        'app.lookup-tables.tables.inventoryTemplateGroupComponents.templateId': 'TemplateId Id',
        'app.lookup-tables.tables.inventoryTemplateGroupComponents.groupId': 'Group Id',
        'app.lookup-tables.tables.inventoryTemplateGroupComponents.templateName': 'Template Name',
        'app.lookup-tables.tables.inventoryTemplateGroupComponents.location': 'Location',
        'app.lookup-tables.tables.inventoryTemplateGroupComponents.table-title': 'Template Components',
        'app.lookup-tables.tables.inventoryTemplateGroupComponents.quantity': 'Quantity',
        'app.lookup-tables.tables.inventoryTemplateGroupComponents.usefulLife': 'Useful Life',
        'app.lookup-tables.tables.inventoryTemplateGroupComponents.table-description': 'Manage inventory templates. Add/Edit/Delete existing templates along with the components they contain, or add new documents.',

        'app.lookup-tables.tables.regions.description': 'Description',
        'app.lookup-tables.tables.regions.name': 'Region Name',
        'app.lookup-tables.tables.regions.table-title': 'Regions',
        'app.lookup-tables.tables.regions.regionId': 'Id',
        'app.lookup-tables.tables.regions.table-description': 'Manage regions. Edit the region names and descriptions of existing regions, or add new documents.',

        'app.lookup-tables.tables.replacementCostTypes.description': 'Description',
        'app.lookup-tables.tables.replacementCostTypes.name': 'Replacement Cost Type',
        'app.lookup-tables.tables.replacementCostTypes.replacementCostTypeId': 'Id',
        'app.lookup-tables.tables.replacementCostTypes.table-title': 'Replacement Cost Types',
        'app.lookup-tables.tables.replacementCostTypes.table-description': 'Manage replacement cost types. Edit the the cost type names and descriptions, or add new documents.',

        'app.lookup-tables.tables.replacementCosts.componentId': 'Component Id',
        'app.lookup-tables.tables.replacementCosts.explanation': 'Explanation',
        'app.lookup-tables.tables.replacementCosts.groupId': 'Group Id',
        'app.lookup-tables.tables.replacementCosts.notes': 'Notes',
        'app.lookup-tables.tables.replacementCosts.table-title': 'Replacement Costs',
        'app.lookup-tables.tables.replacementCosts.replacementCostId': 'Id',
        'app.lookup-tables.tables.replacementCosts.cost': 'Cost',
        'app.lookup-tables.tables.replacementCosts.replacementCostType': 'Replacement Cost Type',
        'app.lookup-tables.tables.replacementCosts.table-description': 'Manage replacement costs. Edit the component ids, replacement cost types, explanations, costs, notes and group ids, or add new documents.',

        'app.lookup-tables.tables.serviceLevels.description': 'Description',
        'app.lookup-tables.tables.serviceLevels.serviceLevelId': 'Id',
        'app.lookup-tables.tables.serviceLevels.introDescription': 'Intro Description',
        'app.lookup-tables.tables.serviceLevels.name': 'Service',
        'app.lookup-tables.tables.serviceLevels.table-title': 'Service Levels',
        'app.lookup-tables.tables.serviceLevels.report': 'Report',
        'app.lookup-tables.tables.serviceLevels.serviceLevelList': 'Service Level',
        'app.lookup-tables.tables.serviceLevels.timeframe': 'Timeframe',
        'app.lookup-tables.tables.serviceLevels.table-description': 'Manage order service levels. Edit the service name, description texts, report texts, timeframe and intro descriptions, or add new documents.',

        'app.lookup-tables.tables.statusLevels.name': 'Status Name',
        'app.lookup-tables.tables.statusLevels.table-title': 'Status Levels',
        'app.lookup-tables.tables.statusLevels.statusId': 'Id',
        'app.lookup-tables.tables.statusLevels.table-description': 'Manage order status levels. Edit the status level name text, or add new documents.',

        'app.lookup-tables.tables.userResumes.employee': 'Employee',
        'app.lookup-tables.tables.userResumes.username': 'Username',
        'app.lookup-tables.tables.userResumes.userFullName': 'Full Name',
        'app.lookup-tables.tables.userResumes.nevadaPermit': 'Nevada Permit',
        'app.lookup-tables.tables.userResumes.resume': 'Resume',
        'app.lookup-tables.tables.userResumes.table-title': 'User Resumes',
        'app.lookup-tables.tables.userResumes.table-description': 'Manage the user resumes and permit numbers. Edit the html resume text and permit numbers for employees, or add new documents.',

        'app.lookup-tables.view-edit': 'View/Edit Table',
        'app.lookup-tables.configure': 'Configure',

        'app.my-account.login-details': 'Login Details',
        'app.my-account.login-email': 'Email',
        'app.my-account.login-last-login': 'Last Login',
        'app.my-account.login-username': 'Username',
        'app.my-account.page-title': 'My Account',
        'app.my-account.profile-details': 'Profile Details',
        'app.my-account.profile-first-name': 'First Name',
        'app.my-account.profile-last-name': 'Last Name',
        'app.my-account.profile-signature': 'Signature',
        'app.my-account.profile-title': 'Title',
        'app.my-account.security-active': 'Account Active',
        'app.my-account.security-details': 'Security Details',
        'app.my-account.security-locked': 'Account Locked',
        'app.my-account.security-roles': 'Assigned Roles',
        'app.my-account.security-roles-none': 'None Assigned',

        'app.nav.search': 'Search...',

        'app.nav-user-info.logout': 'Logout',
        'app.nav-user-info.my-profile': 'My Profile',
        'app.nav-user-info.view-profile': 'View Profile',

        'app.new-research-bids.feedback-no': 'No',
        'app.new-research-bids.feedback-yes': 'Yes',
        'app.new-research-bids.filter-by-bid-date-range': 'Bid Date Range',
        'app.new-research-bids.filter-by-completion-date-range': 'Completion Date Range',
        'app.new-research-bids.filter-by-from-bid-date': 'From Bid Date',
        'app.new-research-bids.filter-by-from-completion-date': 'From Completion Date',
        'app.new-research-bids.filter-by-to-bid-date': 'To Bid Date',
        'app.new-research-bids.filter-by-to-completion-date': 'To Completion Date',
        'app.new-research-bids.filter-date-range-options.all-dates': 'All Dates',
        'app.new-research-bids.filter-date-range-options.last-five-years': 'Last 5 Years',
        'app.new-research-bids.filter-date-range-options.last-four-years': 'Last 4 Years',
        'app.new-research-bids.filter-date-range-options.last-six-months': 'Last 6 Months',
        'app.new-research-bids.filter-date-range-options.last-six-years': 'Last 6 Years',
        'app.new-research-bids.filter-date-range-options.last-thirty-days': 'Last 30 Days',
        'app.new-research-bids.filter-date-range-options.last-three-months': 'Last 3 Months',
        'app.new-research-bids.filter-date-range-options.last-three-years': 'Last 3 Years',
        'app.new-research-bids.filter-date-range-options.last-twelve-months': 'Last 12 Months',
        'app.new-research-bids.filter-date-range-options.last-two-years': 'Last 2 Years',
        'app.new-research-bids.filter-date-range-options.month-to-date': 'Month To Date',
        'app.new-research-bids.filter-date-range-options.previous-month': 'Previous Month',
        'app.new-research-bids.filter-date-range-options.previous-year': 'Previous Year',
        'app.new-research-bids.filter-date-range-options.year-to-date': 'Year To Date',
        'app.new-research-bids.grid.column-headers.association-name': 'Association',
        'app.new-research-bids.grid.column-headers.association-type-name': 'Assoc Type',
        'app.new-research-bids.grid.column-headers.clubhouse': 'Clubhouse',
        'app.new-research-bids.grid.column-headers.feedback': 'Feedback',
        'app.new-research-bids.grid.column-headers.gated': 'Gated',
        'app.new-research-bids.grid.column-headers.level-1-economy': 'L1 Price',
        'app.new-research-bids.grid.column-headers.order-status': 'Status',
        'app.new-research-bids.grid.column-headers.pools': 'Pools',
        'app.new-research-bids.grid.column-headers.region-name': 'Region',
        'app.new-research-bids.grid.column-headers.streets': 'Streets',
        'app.new-research-bids.grid.column-headers.units': 'Units',
        'app.new-research-bids.no-results': 'No matching bids found. Try changing your search criteria.',
        'app.new-research-bids.page-title': 'New Research Bids',
        'app.new-research-bids.search': 'Search',
        'app.new-research-bids.view-order-detail-link-title': 'Open Order',

        'app.order-add.add-order': 'Add Order',
        'app.order-add.association': 'Association',
        'app.order-add.client-associations': 'Client Associations',
        'app.order-add.client-region': 'Client Region',
        'app.order-add.client': 'Client Name',
        'app.order-add.create-order': 'Create Order',
        'app.order-add.grid.column-headers.association-id': 'Assoc Id',
        'app.order-add.grid.column-headers.association-name': 'Assoc Name',
        'app.order-add.grid.column-headers.client-name': 'Client Name',
        'app.order-add.grid.column-headers.create-order': 'Create Order',
        'app.order-add.grid.column-headers.region-name': 'Region Name',
        'app.order-add.new-association': 'New Association',
        'app.order-add.new-client': 'New Client',
        'app.order-add.new-order-details': 'Choose Client',
        'app.order-add.page-title': 'Add Order',
        'app.order-add.select-option.placeholder': 'Choose...',

        'app.order-add-bid.add-bid-details': 'Add Bid Details',

        'app.order-add-bid.add-new-bid': 'Add New Bid',
        'app.order-add-bid.association-info': 'Association Info',
        'app.order-add-bid.association': 'Association',
        'app.order-add-bid.association-name': 'Association Name',
        'app.order-add-bid.association-info.association-id': 'Association Id',
        'app.order-add-bid.association-info.association-name': 'Association Name',
        'app.order-add-bid.association-info.association-city': 'Association City',
        'app.order-add-bid.association-info.association-state': 'Association State',
        'app.order-add-bid.association-info.association-zip': 'Association Zip',
        'app.order-add-bid.association-info.association-hoa-type': 'Association HOA Type',
        'app.order-add-bid.association-info.association-num-units': 'Association Number of Units',
        'app.order-add-bid.association-info.association-client': 'Association Client',
        'app.order-add-bid.association-info.association-contact': 'Association Contact',
        'app.order-add-bid.client-contact': 'Client Contact',
        'app.order-add-bid.client-info': 'Client Info',
        'app.order-add-bid.client-name': 'Client Company',
        'app.order-add-bid.client': 'Client Name',
        'app.order-add-bid.create-bid': 'Create Bid',
        'app.order-add-bid.new-association': 'New Association',
        'app.order-add-bid.new-client': 'New Client',
        'app.order-add-bid.new-client-contact': 'New Contact',
        'app.order-add-bid.cancel-new-bid': 'Cancel',
        'app.order-add-bid.order-info': 'Order Info',
        'app.order-add-bid.page-title': 'Add New Bid',
        'app.order-add-bid.select-option.placeholder': 'Choose...',
        'app.order-add-bid.order-manager-user': 'Project Manager',
        'app.order-add-bid.order-site-inspector-user': 'Site Inspector',
        'app.order-add-bid.modals.confirm-add-bid.body': 'You are about to create a new bid and reassign the association\'s default client and contact. Are you sure?',
        'app.order-add-bid.modals.confirm-add-bid.confirm': 'Create New Bid',
        'app.order-add-bid.modals.confirm-add-bid.title': 'Confirm Create Bid and Reassign Association Client/Contact',

        'app.bids-add.assigned-associations': 'Association Assignment',
        'app.bids-add.association': 'Association',
        'app.bids-add.associations': 'Associations',
        'app.bids-add.contact-details': 'Contact Details',
        'app.bids-add.contact-first-name': 'First Name',
        'app.bids-add.contact-last-name': 'Last Name',
        'app.bids-add.contact-title': 'Title',
        'app.bids-add.create-client-invite': 'Invite User',
        'app.bids-add.create-portal-invite': 'Invite User',
        'app.bids-add.create-portal-invites': 'Invite Users',
        'app.bids-add.user-details': 'User Details',
        'app.bids-add.login-email': 'Email',
        'app.bids-add.login-last-login': 'Last Login',
        'app.bids-add.login-password': 'Password',
        'app.bids-add.login-username': 'Username',
        'app.bids-add.modals.create-bid.confirm-password': 'Confirm Password',
        'app.bids-add.modals.create-bid.email-in-use': '* Email is already in use',
        'app.bids-add.modals.create-bid.email': 'Email Address',
        'app.bids-add.modals.create-bid.username': 'Matched User',
        'app.bids-add.modals.create-bid.first-name': 'First Name',
        'app.bids-add.modals.create-bid.last-name': 'Last Name',
        'app.bids-add.modals.create-bid.new-username': 'New Username',
        'app.bids-add.modals.create-bid.password-min-length': '* Password must be at least {TOKEN_VALUE} characters',
        'app.bids-add.modals.create-bid.password': 'Password',
        'app.bids-add.modals.create-bid.temporary-password': 'Temporary Password',
        'app.bids-add.modals.create-bid.passwords-mismatched': '* Passwords do not match',
        'app.bids-add.modals.create-bid.professional-title': 'Title',
        'app.bids-add.modals.create-bid.required': 'Required',
        'app.bids-add.modals.create-bid.title': 'Create Bid',
        'app.bids-add.modals.create-bid.username-in-use': '* Username is already in use',
        'app.bids-add.modals.reset-password.new-password-confirm': 'Confirm New Password',
        'app.bids-add.modals.reset-password.new-password': 'New Password',
        'app.bids-add.modals.reset-password.set-changes': 'Set Changes',
        'app.bids-add.modals.reset-password.title': 'Reset Password',
        'app.bids-add.modals.reset-password.unlock-if-locked-out': 'Locked Out',
        'app.bids-add.not-found': 'User "{TOKEN_VALUE}" not found!',
        'app.bids-add.page-title': 'Create New Bid',
        'app.bids-add.reset-password': 'Reset Password',
        'app.bids-add.resume-details': 'Professional Details',
        'app.bids-add.resume-permit-number-nv': 'Permit Number (Nevada)',
        'app.bids-add.resume-signature': 'Document Signatures',
        'app.bids-add.resume-text': 'Resume Content',
        'app.bids-add.roles': 'Roles',
        'app.bids-add.search-users': 'Search Users',
        'app.bids-add.security-active-no': 'No',
        'app.bids-add.security-active-yes': 'Yes',
        'app.bids-add.security-active': 'Account Active',
        'app.bids-add.security-details': 'Security Permissions',
        'app.bids-add.security-inactive': 'Account Disabled',
        'app.bids-add.security-locked-no': 'No',
        'app.bids-add.security-locked-yes': 'Yes',
        'app.bids-add.security-locked': 'Account Locked',
        'app.bids-add.security-roles-none': 'None Assigned',
        'app.bids-add.security-roles': 'Access Level',
        'app.bids-add.security-roles.tooltip': 'Managers can invite new portal users to assigned associations, or revoke portal user access',
        'app.bids-add.security-expiration-date': 'Deactivate On',
        'app.bids-add.security-expiration-date.tooltip': 'Automatically deactivate access to association(s) on specified date',
        'app.bids-add.security-clear-expiration-date': 'Clear Date',

        'app.order-detail.active-contact-association': 'Association Details',
        'app.order-detail.active-contact-client': 'Association Client Contact Details',
        'app.order-detail.active-contact-information': 'Active Contact Information',
        'app.order-detail.association-id': 'Association Id',
        'app.order-detail.association-name': 'Association Name',
        'app.order-detail.association-type': 'Association Type',
        'app.order-detail.association-zip': 'Zip',
        'app.order-detail.bidLetter3YearPlanLanguage': 'Include Language for 3-Year Plans on Bid Letter',
        'app.order-detail.client-contact-email': 'Email',
        'app.order-detail.client-contact-id': 'Contact Id',
        'app.order-detail.client-contact-phone': 'Contact Phone',
        'app.order-detail.client-id': 'Client Id',
        'app.order-detail.client-manager': 'Manager/Contact',
        'app.order-detail.client-name': 'Name',
        'app.order-detail.client-phone': 'Client Phone',
        'app.order-detail.client-type': 'Client Type',
        'app.order-detail.contract-received': 'Contract Received',
        'app.order-detail.coordinator-paid': 'Coordinator Paid',
        'app.order-detail.create-order': 'Create Order',
        'app.order-detail.current-order-due-date': 'Current Due Date',
        'app.order-detail.edit-order': 'Edit Order',
        'app.order-detail.entered-in-quickbooks': 'Entered in Quickbooks',
        'app.order-detail.feedback': 'Feedback',
        'app.order-detail.first-reminder-sent': 'First Reminder Sent',
        'app.order-detail.follow-up-date': 'Follow Up Date',
        'app.order-detail.include-3-year-plan-language': 'Include 3-Year Plan on Bid Letter',
        'app.order-detail.invoice-sent-in-quickbooks': 'Invoice Sent in Quickbooks',
        'app.order-detail.missing-data.warning.title': 'Order Changes Required',
        'app.order-detail.missing-data.warning.body': 'Missing pricing data was detected. Please reset prices manually or by pressing the Set Order Pricing button. Then be sure to save all order changes.',
        'app.order-detail.modals.calculate-prices.are-you-sure': 'Are you sure you want to continue?',
        'app.order-detail.modals.calculate-prices.content': 'This will overwrite any existing order pricing levels that are configured. Additionally, it may overwrite the Follow Up, Reminder and Bid Date field values.',
        'app.order-detail.modals.calculate-prices.header': 'Automatically recalculate prices based on level pricing',
        'app.order-detail.modals.calculate-prices.title': 'Auto Calculate Prices',
        'app.order-detail.modals.create-next-plan-year-order.are-you-sure': 'Are you sure you want to continue?',
        'app.order-detail.modals.create-next-plan-year-order.content': 'This will create the next sequenced 3 Year Plan order for this association.',
        'app.order-detail.modals.create-next-plan-year-order.content-period-ended': 'End of 3rd year, contact client to renew. Do you want to create a 3 Year Plan renewal order for this client?',
        'app.order-detail.modals.create-next-plan-year-order.create-order': 'Create Next Plan Year Order',
        'app.order-detail.modals.create-next-plan-year-order.header': 'Automatically create next plan year order',
        'app.order-detail.modals.create-next-plan-year-order.title': 'Create Next Plan Year Order',
        'app.order-detail.modals.delete.body': 'You are about to delete this order AND any attached reserve study charts. This operation is permanent and cannot be undone.',
        'app.order-detail.modals.delete.cancel': 'Cancel',
        'app.order-detail.modals.delete.delete': 'Delete',
        'app.order-detail.modals.delete.title': 'Confirm Delete Inventory Item',
        'app.order-detail.modals.new-order.current-association-id': 'Association Id',
        'app.order-detail.modals.new-order.current-association-name': 'Association Name',
        'app.order-detail.modals.new-order.title': 'Create New Order',
        'app.order-detail.modals.set-due-date.title': 'Set Due Date',
        'app.order-detail.new-order-association': 'Order Association',
        'app.order-detail.new-order-client': 'Order Client',
        'app.order-detail.new-order-due-date': 'New Due Date',
        'app.order-detail.new-order': 'Create New Order',
        'app.order-detail.number-of-weeks': 'Add Weeks',
        'app.order-detail.order-accepted-price': 'Accepted Price',
        'app.order-detail.order-bid-received-date': 'Bid Received Date',
        'app.order-detail.order-bid-sent-date': 'Bid Sent Date',
        'app.order-detail.order-client-details': 'Order Client Details',
        'app.order-detail.order-client-info': 'Order Client Info',
        'app.order-detail.order-company': 'Company',
        'app.order-detail.order-completed-date': 'Completed Date',
        'app.order-detail.order-coordinator-assigned': 'Project Coordinator',
        'app.order-detail.order-dash-letter': 'Order Dash Letter',
        'app.order-detail.order-dash-number': 'Order Dash Number',
        'app.order-detail.order-dates': 'Order Dates',
        'app.order-detail.order-details': 'Order Details',
        'app.order-detail.order-due-date': 'Due Date',
        'app.order-detail.order-follow-up-notes': 'Follow Up Notes',
        'app.order-detail.order-information': 'Order Information',
        'app.order-detail.order-links-event-dates': 'Order Event Dates',
        'app.order-detail.order-links-options': 'Order Options',
        'app.order-detail.order-links': 'Links',
        'app.order-detail.order-manager-assigned': 'Manager Assigned',
        'app.order-detail.order-notes-add-author-text': 'Add new note',
        'app.order-detail.order-notes': 'Order Notes',
        'app.order-detail.order-number': 'Order Number',
        'app.order-detail.order-override-accepted-price': 'Override Calculated Accepted Price',
        'app.order-detail.order-pricing-3-year-plan': '3-Year Plan',
        'app.order-detail.order-pricing': 'Order Pricing',
        'app.order-detail.order-selected-service': 'Selected Service',
        'app.order-detail.order-si-date': 'S/I Date',
        'app.order-detail.order-start-date': 'Start Date',
        'app.order-detail.order-status': 'Status',
        'app.order-detail.order-won-date': 'Won Date',
        'app.order-detail.order': 'Order',
        'app.order-detail.page-title.edit-order': 'Edit Order',
        'app.order-detail.page-title': 'Order Detail',
        'app.order-detail.prepared-for-fye': 'Prepared for FYE',
        'app.order-detail.pricing-3-year-plan-create-next-plan-year-order': 'Create Next Plan Year Order',
        'app.order-detail.pricing-3-year-plan-level-4': 'Level 4',
        'app.order-detail.pricing-3-year-plan-level-due.no-site-visit': 'No Site Visit',
        'app.order-detail.pricing-3-year-plan-level-due.site-visit': 'With Site Visit',
        'app.order-detail.pricing-3-year-plan-level-due': 'Level Due',
        'app.order-detail.pricing-3-year-plan-pricing': 'Pricing',
        'app.order-detail.pricing-3-year-plan-year-count': 'Year Count',
        'app.order-detail.pricing-3-year-plan-year-count.warning.title': 'Order Changes Pending',
        'app.order-detail.pricing-3-year-plan-year-count.warning.body': 'You must save all pending order changes before creating the next plan year order',
        'app.order-detail.pricing-3-year-plan-year': 'Year',
        'app.order-detail.pricing-economy': 'Economy',
        'app.order-detail.pricing-level-renamed-level4': 'RENAMED4',
        'app.order-detail.pricing-level-renamed-level5': '4',
        'app.order-detail.pricing-level': 'Level',
        'app.order-detail.pricing-rush': 'Rush',
        'app.order-detail.pricing-3-year-plan-set-plan-pricing': 'Set 3 Year Plan Pricing',
        'app.order-detail.pricing-standard': 'Standard',
        'app.order-detail.print-envelope': 'Print Envelope',
        'app.order-detail.property-description': 'Property Description',
        'app.order-detail.reminder-bid-date': 'Reminder Bid Date',
        'app.order-detail.research-bids': 'Research Bids',
        'app.order-detail.sample-sent': 'Sample Sent',
        'app.order-detail.second-reminder-sent': 'Second Reminder Sent',
        'app.order-detail.send-reminder-email': 'Send Reminder Email',
        'app.order-detail.set-due-date': 'Set Due Date',
        'app.order-detail.set-prices': 'Set Order Pricing',
        'app.order-detail.stale-accepted-price.warning.title': 'Order Changes Required',
        'app.order-detail.stale-accepted-price.warning.body':
            'An Accepted Price mismatch has been detected. The entered Accepted Price doesn\'t match the price calculated for the selected service level. \
         If this is intentional be sure to turn on Override Accepted Price. If this is not intentional, enter the matching calculated value for the selected service level and save changes.',
        'app.order-detail.stale-accepted-price-and-missing-data.warning.body': 'A stale Accepted Price has been detected, but cannot be fixed until missing pricing data has been created.',
        'app.order-detail.unsolicited-bid': 'Unsolicited Bid',
        'app.order-detail.view-association': 'View Association',
        'app.order-detail.view-bid-envelope': 'Bid Envelope',
        'app.order-detail.view-bid-letter': 'Bid Letter',
        'app.order-detail.view-client': 'View Client',
        'app.order-detail.view-follow-up-notes': 'Follow Up Notes',
        'app.order-detail.worksheet-received': 'Worksheet Received',
        'app.order-detail.use-two-option-pricing': 'Use Two-Option Pricing',
        'app.order-detail.is-preliminary-study': 'Preliminary Study',

        'app.component-detail.component-information': 'Component Information',
        'app.component-detail.component-replacement-costs': 'Component Standard Costs',
        'app.component-detail.component-replacement-costs.best-costs': 'Best Replacement Costs',
        'app.component-detail.component-replacement-costs.worst-costs': 'Worst Replacement Costs',
        'app.component-detail.component-replacement-costs.group': 'Group',
        'app.component-detail.component-information-locations': 'Component Locations',
        'app.component-detail.component-standard-evaluations': 'Standard Evaluations',

        'app.component-detail.grid.column-headers.component-id': 'Id',
        'app.component-detail.grid.column-headers.cost': 'Cost',
        'app.component-detail.grid.column-headers.type-name': 'Type',
        'app.component-detail.grid.column-headers.explanation': 'Explanation',
        'app.component-detail.grid.column-headers.notes': 'Notes',
        'app.component-detail.grid.column-headers.group-id': 'Group Id',
        'app.component-detail.grid.column-headers.group-id-name': 'Group Name',
        'app.component-detail.grid.column-headers.condition-level': 'Condition Level',
        'app.component-detail.grid.column-headers.evaluation': 'Evaluation',
        'app.component-detail.grid.column-headers.standard-evaluation-id': 'Evaluation Id',
        'app.component-detail.grid.add-new-best-cost': 'Add New Best Cost',
        'app.component-detail.grid.add-new-worst-cost': 'Add New Worst Cost',
        'app.component-detail.grid.add-new-standard-evaluation': 'Add New Standard Evaluation',

        'app.component-detail.modals.delete-replacement-cost.title': 'Delete Replacement Cost',
        'app.component-detail.modals.delete-replacement-cost.body': 'Warning! Are you sure you want to permanently delete this replacement cost?',
        'app.component-detail.modals.delete-replacement-cost.delete': 'Delete Replacement Cost',

        'app.component-detail.modals.delete-standard-evaluation.title': 'Delete Standard Evaluation',
        'app.component-detail.modals.delete-standard-evaluation.body': 'Warning! Are you sure you want to permanently delete this standard evaluation?',
        'app.component-detail.modals.delete-standard-evaluation.delete': 'Delete Standard Evaluation',

        'app.component-detail.component-information.component-category-id': 'Category Id',
        'app.component-detail.component-information.component-category-name': 'Category Name',
        'app.component-detail.component-information.component-category': 'Component Category',
        'app.component-detail.component-information.component-id-already-in-use': 'Component Id {TOKEN_VALUE} is already in use!',
        'app.component-detail.component-information.component-id': 'Component Id',
        'app.component-detail.component-information.component-inactive': 'Component Inactive',
        'app.component-detail.component-information.component-name': 'Component Name',
        'app.component-detail.component-information.component-summary': 'Component Summary',
        'app.component-detail.component-information.component-useful-life': 'Useful Life',
        'app.component-detail.edit-component': 'Edit Component',
        'app.component-detail.page-title.component-detail': 'Component Detail',
        'app.component-detail.page-title.edit-component': 'Edit Component',
        'app.component-detail.page-title': 'Component Detail',

        'app.order-search.filter-by-association': 'Filter by Association',
        'app.order-search.filter-by-client': 'Filter by Client',
        'app.order-search.filter-by-status': 'Filter by Status',
        'app.order-search.grid.column-headers.association-city': 'City',
        'app.order-search.grid.column-headers.association-id': 'Assoc Id',
        'app.order-search.grid.column-headers.association-name': 'Assoc Name',
        'app.order-search.grid.column-headers.association-state': 'State',
        'app.order-search.grid.column-headers.association-type': 'Type',
        'app.order-search.grid.column-headers.association-zip': 'Zip',
        'app.order-search.grid.column-headers.order-id': 'Order Id',
        'app.order-search.grid.column-headers.order-status': 'Status',
        'app.order-search.no-results': 'No matching orders found. Try changing your search criteria.',
        'app.order-search.page-title': 'Search Orders',
        'app.order-search.search-keyword': 'Search Keyword',
        'app.order-search.view-inventory': 'View Inventory',
        'app.order-search.view-inventory-link-title': 'View inventory',
        'app.order-search.view-order': 'View Order',
        'app.order-search.view-order-link-title': 'View order',

        'app.outstanding-bids.filter-by-client': 'Client',
        'app.outstanding-bids.filter-by-follow-up-date': 'To Follow Up Date',
        'app.outstanding-bids.filter-by-from-follow-up-date': 'From Follow Up Date',
        'app.outstanding-bids.filter-by-to-follow-up-date': 'To Follow Up Date',
        'app.outstanding-bids.filter-by-from-bid-date': 'From Bid Date',
        'app.outstanding-bids.filter-by-region': 'Region',
        'app.outstanding-bids.filter-by-status': 'Status',
        'app.outstanding-bids.filter-by-to-bid-date': 'To Bid Date',
        'app.outstanding-bids.filter-by-unsolicited-bid': 'Unsolicited Bid',
        'app.outstanding-bids.filter-option-unsolicited-any': '- SHOW ALL -',
        'app.outstanding-bids.filter-option-unsolicited-no': 'No',
        'app.outstanding-bids.filter-option-unsolicited-yes': 'Yes',
        'app.outstanding-bids.filter-option-won-jobs': 'Won Jobs',
        'app.outstanding-bids.grid.column-headers.accepted-price': 'Accepted Price',
        'app.outstanding-bids.grid.column-headers.association-id': 'Assoc Id',
        'app.outstanding-bids.grid.column-headers.association-name': 'Association',
        'app.outstanding-bids.grid.column-headers.bid-date': 'Bid Date',
        'app.outstanding-bids.grid.column-headers.follow-up-date': 'Follow Up Date',
        'app.outstanding-bids.grid.column-headers.client-name': 'Client',
        'app.outstanding-bids.grid.column-headers.client-phone': 'Client Phone',
        'app.outstanding-bids.grid.column-headers.contact-firstname': 'First Name',
        'app.outstanding-bids.grid.column-headers.contact-lastname': 'Last Name',
        'app.outstanding-bids.grid.column-headers.contact-name': 'Name',
        'app.outstanding-bids.grid.column-headers.level-1-economy': 'Level1Economy',
        'app.outstanding-bids.grid.column-headers.order-status': 'Status',
        'app.outstanding-bids.no-results': 'No matching bids found. Try changing your search criteria.',
        'app.outstanding-bids.page-title': 'Outstanding Bids',
        'app.outstanding-bids.view-order-detail-link-title': 'View Bid',
        'app.outstanding-bids.follow-up-order-button-title': 'Follow Up',
        'app.outstanding-bids.modals.update-order.are-you-sure': 'Update Order Details',
        'app.outstanding-bids.modals.update-order.association': 'Association',
        'app.outstanding-bids.modals.update-order.button-update': 'Update',
        'app.outstanding-bids.modals.update-order.current-follow-up-date': 'Follow Up Date',
        'app.outstanding-bids.modals.update-order.current-order-status': 'Current Bid Status',
        'app.outstanding-bids.modals.update-order.do-you-wish-to-continue': 'Are you sure you want to continue?',
        'app.outstanding-bids.modals.update-order.new-order-follow-up-date': 'Set Follow Up Date',
        'app.outstanding-bids.modals.update-order.new-order-follow-up-notes': 'Add Follow Up Notes',
        'app.outstanding-bids.modals.update-order.new-order-status': 'Set Bid Status',
        'app.outstanding-bids.modals.update-order.new-status': 'New Status',
        'app.outstanding-bids.modals.update-order.order-id': 'Order Id',
        'app.outstanding-bids.modals.update-order.title': 'Update Bid',
        'app.outstanding-bids.modals.update-order.header-text': 'Change bid status and/or bid follow up date value',
        'app.outstanding-bids.modals.update-order.warning': 'This action may overwrite the bid status and/or follow up date field values!',
        'app.outstanding-bids.export-to-excel': 'Export to Excel',
        'app.outstanding-bids.send-reminder-email': 'Send Reminder Email',

        'app.reminder-bids.export-to-excel': 'Export to Excel',
        'app.reminder-bids.filter-by-client': 'Client',
        'app.reminder-bids.filter-by-follow-up-date': 'To Follow Up Date',
        'app.reminder-bids.filter-by-from-bid-completion-date': 'From Bid Completion Date',
        'app.reminder-bids.filter-by-from-bid-date': 'From Bid Date',
        'app.reminder-bids.filter-by-from-bid-reminder-date': 'From Bid Reminder Date',
        'app.reminder-bids.filter-by-from-bid-sent-date': 'From Bid Sent Date',
        'app.reminder-bids.filter-by-from-follow-up-date': 'From Follow Up Date',
        'app.reminder-bids.filter-by-region': 'Region',
        'app.reminder-bids.filter-by-status': 'Status',
        'app.reminder-bids.filter-by-to-bid-completion-date': 'To Bid Completion Date',
        'app.reminder-bids.filter-by-to-bid-date': 'To Bid Date',
        'app.reminder-bids.filter-by-to-bid-reminder-date': 'To Bid Reminder Date',
        'app.reminder-bids.filter-by-to-bid-sent-date': 'To Bid Sent Date',
        'app.reminder-bids.filter-by-to-follow-up-date': 'To Follow Up Date',
        'app.reminder-bids.filter-by-service-level': 'Service Level',
        'app.reminder-bids.filter-by-unsolicited-bid': 'Unsolicited Bid',
        'app.reminder-bids.filter-option-status-won-sent': '- SENT/WON -',
        'app.reminder-bids.filter-option-status-3-year': '- ALL 3 YEAR PLANS -',
        'app.reminder-bids.filter-option-service-level-3-year': '- ALL 3 YEAR PLANS -',
        'app.reminder-bids.filter-option-unsolicited-any': '- SHOW ALL -',
        'app.reminder-bids.filter-option-unsolicited-no': 'No',
        'app.reminder-bids.filter-option-unsolicited-yes': 'Yes',
        'app.reminder-bids.filter-option-won-jobs': 'Won Jobs',
        'app.reminder-bids.follow-up-order-button-title': 'Follow Up',
        'app.reminder-bids.grid.column-headers.accepted-price': 'Accepted Price',
        'app.reminder-bids.grid.column-headers.association-id': 'Assoc Id',
        'app.reminder-bids.grid.column-headers.association-name': 'Association',
        'app.reminder-bids.grid.column-headers.bid-date': 'Bid Date',
        'app.reminder-bids.grid.column-headers.bid-reminder-date': 'Reminder Date',
        'app.reminder-bids.grid.column-headers.bid-sent-date': 'Sent Date',
        'app.reminder-bids.grid.column-headers.client-name': 'Client',
        'app.reminder-bids.grid.column-headers.client-phone': 'Client Phone',
        'app.reminder-bids.grid.column-headers.contact-firstname': 'First Name',
        'app.reminder-bids.grid.column-headers.contact-lastname': 'Last Name',
        'app.reminder-bids.grid.column-headers.contact-name': 'Name',
        'app.reminder-bids.grid.column-headers.follow-up-date': 'Follow Up Date',
        'app.reminder-bids.grid.column-headers.order-status': 'Status',
        'app.reminder-bids.grid.column-headers.service-level': 'Service Level',
        'app.reminder-bids.modals.send-reminder-email.body-content': 'Email Body Content',
        'app.reminder-bids.modals.send-reminder-email.body-content-start': 'Email Body Content Start',
        'app.reminder-bids.modals.send-reminder-email.body-content-mid': 'Email Body Content Mid',
        'app.reminder-bids.modals.send-reminder-email.body-content-end': 'Email Body Content End',
        'app.reminder-bids.modals.send-reminder-email.default-content': 'Hello! {{brandingKey}} recently provided a Reserve Study proposal for {{inviteAssocName}}. We are contacting you to check on the status of your bid selection.',
        'app.reminder-bids.modals.send-reminder-email.default-content-start': 'Hello! ',
        'app.reminder-bids.modals.send-reminder-email.default-content-mid': ' recently provided a Reserve Study proposal for ',
        'app.reminder-bids.modals.send-reminder-email.default-content-end': '. We are contacting you to check on the status of your bid selection.',
        'app.reminder-bids.modals.send-reminder-email.default-header': 'Reserve Study Proposal Status?',
        'app.reminder-bids.modals.send-reminder-email.header-text': 'Email Body Header Text',
        'app.reminder-bids.modals.send-reminder-email.modal-title': 'Modify Email Content',
        'app.reminder-bids.modals.update-order.are-you-sure': 'Update Order Details',
        'app.reminder-bids.modals.update-order.association': 'Association',
        'app.reminder-bids.modals.update-order.button-update': 'Update',
        'app.reminder-bids.modals.update-order.current-follow-up-date': 'Follow Up Date',
        'app.reminder-bids.modals.update-order.current-order-status': 'Current Bid Status',
        'app.reminder-bids.modals.update-order.do-you-wish-to-continue': 'Are you sure you want to continue?',
        'app.reminder-bids.modals.update-order.header-text': 'Change bid status and/or bid follow up date value',
        'app.reminder-bids.modals.update-order.new-order-follow-up-date': 'Set Follow Up Date',
        'app.reminder-bids.modals.update-order.new-order-follow-up-notes': 'Add Follow Up Notes',
        'app.reminder-bids.modals.update-order.new-order-status': 'Set Bid Status',
        'app.reminder-bids.modals.update-order.new-status': 'New Status',
        'app.reminder-bids.modals.update-order.order-id': 'Order Id',
        'app.reminder-bids.modals.update-order.title': 'Update Bid',
        'app.reminder-bids.modals.update-order.warning': 'This action may overwrite the bid status and/or follow up date field values!',
        'app.reminder-bids.no-results': 'No matching bids found. Try changing your search criteria.',
        'app.reminder-bids.page-title': 'Reminder Bids',
        'app.reminder-bids.send-reminder-email': 'Send Reminder Email',
        'app.reminder-bids.view-order-detail-link-title': 'View Bid',
        'app.reminder-bids.view-association-link-title': 'View Association',
        'app.reminder-bids.view-client-link-title': 'View Client',
        'app.reminder-bids.create-order-link-title': 'Create Order',
        'app.reminder-bids.remove-any-reminders': 'Remove Selected Reminders',
        'app.reminder-bids.3-yr-pending-start': 'Set as 3 Yr Pending Start',
        'app.reminder-bids.3-yr-renewal': 'Set as 3 Yr Renewal',
        'app.reminder-bids.set-all-statuses': 'Change Status of Selected',
        'app.reminder-bids.create-bulk-orders': 'Create Orders',

        'app.user-inventory-templates.filter-by-client': 'Client',
        'app.user-inventory-templates.filter-by-follow-up-date': 'To Follow Up Date',
        'app.user-inventory-templates.filter-by-from-follow-up-date': 'From Follow Up Date',
        'app.user-inventory-templates.filter-by-to-follow-up-date': 'To Follow Up Date',
        'app.user-inventory-templates.filter-by-from-bid-date': 'From Bid Date',
        'app.user-inventory-templates.filter-by-region': 'Region',
        'app.user-inventory-templates.filter-by-status': 'Status',
        'app.user-inventory-templates.filter-by-to-bid-date': 'To Bid Date',
        'app.user-inventory-templates.filter-by-unsolicited-bid': 'Unsolicited Bid',
        'app.user-inventory-templates.filter-option-unsolicited-any': '- SHOW ALL -',
        'app.user-inventory-templates.modals.delete-template.title': 'Remove User Inventory Template',
        'app.user-inventory-templates.modals.delete-template.delete': 'Permanently Delete',
        'app.user-inventory-templates.modals.delete-template.body': 'Are you sure you want to remove this inventory template? This operation is permanent and cannot be undone.',
        'app.user-inventory-templates.modals.delete-template-item.title': 'Remove inventory item from template',
        'app.user-inventory-templates.modals.delete-template-item.delete': 'Remove Item',
        'app.user-inventory-templates.modals.delete-template-item.body': 'Are you sure you want to remove this inventory item from the template? This operation is permanent and cannot be undone.',
        'app.user-inventory-templates.modals.rename-template.title': 'Rename User Inventory Template',
        'app.user-inventory-templates.modals.rename-template.rename': 'Rename',
        'app.user-inventory-templates.modals.rename-template.body': 'Enter a new name:',
        'app.user-inventory-templates.modals.rename-template-new-name': 'Enter New Name:',
        'app.user-inventory-templates.modals.rename-template-new-name.placeholder': 'Enter Name',
        'app.user-inventory-templates.modals.rename-template-new-name-description': 'Enter New Description:',
        'app.user-inventory-templates.modals.rename-template-new-name-description.placeholder': 'Enter Description',
        'app.user-inventory-templates.filter-option-unsolicited-no': 'No',
        'app.user-inventory-templates.filter-option-unsolicited-yes': 'Yes',
        'app.user-inventory-templates.filter-option-won-jobs': 'Won Jobs',
        'app.user-inventory-templates.grid.column-headers.component-subgroup-name': 'Subgroup',
        'app.user-inventory-templates.grid.column-headers.component-id': 'Component Id',
        'app.user-inventory-templates.grid.column-headers.component-name': 'Component Name',
        'app.user-inventory-templates.grid.column-headers.category-name': 'Category Name',
        'app.user-inventory-templates.grid.column-headers.quantity': 'Quantity',
        'app.user-inventory-templates.grid.column-headers.useful-life': 'UL',
        'app.user-inventory-templates.grid.column-headers.remaining-useful-life': 'RUL',
        'app.user-inventory-templates.no-results': 'No matching inventory template items found.',
        'app.user-inventory-templates.page-title': 'Inventory Template',
        'app.user-inventory-templates.grid-title.template-items': 'Template Items',

        'app.root-home.placeholder': '',

        'app.portal-invites.user-groups.allowed-users': 'Allowed Users',
        'app.portal-invites.user-groups.user-managers': 'User Managers',
        'app.portal-invites.user-groups.deactivated-users': 'Deactivated Users',
        'app.portal-invites.user-groups.none-deactivated': 'None Deactivated',
        'app.portal-invites.user-groups.none-assigned': 'None Assigned',
        'app.portal-invites.manage-user-access': 'Manage User Access',
        'app.portal-invites.invite-user': 'Invite User',

        'app.portal-invites-add.assigned-associations': 'Association Assignment',
        'app.portal-invites-add.association': 'Association',
        'app.portal-invites-add.associations': 'Associations',
        'app.portal-invites-add.contact-details': 'Contact Details',
        'app.portal-invites-add.contact-first-name': 'First Name',
        'app.portal-invites-add.contact-last-name': 'Last Name',
        'app.portal-invites-add.contact-title': 'Title',
        'app.portal-invites-add.create-client-invite': 'Invite User',
        'app.portal-invites-add.create-portal-invite': 'Invite User',
        'app.portal-invites-add.create-portal-invites': 'Invite Users',
        'app.portal-invites-add.user-details': 'User Details',
        'app.portal-invites-add.login-email': 'Email',
        'app.portal-invites-add.login-last-login': 'Last Login',
        'app.portal-invites-add.login-password': 'Password',
        'app.portal-invites-add.login-username': 'Username',
        'app.portal-invites-add.modals.create-invite.confirm-password': 'Confirm Password',
        'app.portal-invites-add.modals.create-invite.email-in-use': '* Email is already in use',
        'app.portal-invites-add.modals.create-invite.email': 'Email Address',
        'app.portal-invites-add.modals.create-invite.username': 'Matched User',
        'app.portal-invites-add.modals.create-invite.first-name': 'First Name',
        'app.portal-invites-add.modals.create-invite.last-name': 'Last Name',
        'app.portal-invites-add.modals.create-invite.new-username': 'New Username',
        'app.portal-invites-add.modals.create-invite.password-min-length': '* Password must be at least {TOKEN_VALUE} characters',
        'app.portal-invites-add.modals.create-invite.password': 'Password',
        'app.portal-invites-add.modals.create-invite.temporary-password': 'Temporary Password',
        'app.portal-invites-add.modals.create-invite.passwords-mismatched': '* Passwords do not match',
        'app.portal-invites-add.modals.create-invite.professional-title': 'Title',
        'app.portal-invites-add.modals.create-invite.required': 'Required',
        'app.portal-invites-add.modals.create-invite.title': 'Invite User',
        'app.portal-invites-add.modals.create-invite.username-in-use': '* Username is already in use',
        'app.portal-invites-add.modals.reset-password.new-password-confirm': 'Confirm New Password',
        'app.portal-invites-add.modals.reset-password.new-password': 'New Password',
        'app.portal-invites-add.modals.reset-password.set-changes': 'Set Changes',
        'app.portal-invites-add.modals.reset-password.title': 'Reset Password',
        'app.portal-invites-add.modals.reset-password.unlock-if-locked-out': 'Locked Out',
        'app.portal-invites.add.modals.reset-password.password-change-required': 'Must Change On Login',
        'app.portal-invites-add.not-found': 'User "{TOKEN_VALUE}" not found!',
        'app.portal-invites-add.page-title': 'Invite User',
        'app.portal-invites-add.reset-password': 'Reset Password',
        'app.portal-invites-add.resume-details': 'Professional Details',
        'app.portal-invites-add.resume-permit-number-nv': 'Permit Number (Nevada)',
        'app.portal-invites-add.resume-signature': 'Document Signatures',
        'app.portal-invites-add.resume-text': 'Resume Content',
        'app.portal-invites-add.roles': 'Roles',
        'app.portal-invites-add.search-users': 'Search Users',
        'app.portal-invites-add.security-active-no': 'No',
        'app.portal-invites-add.security-active-yes': 'Yes',
        'app.portal-invites-add.security-active': 'Account Active',
        'app.portal-invites-add.security-details': 'Security Permissions',
        'app.portal-invites-add.security-inactive': 'Account Disabled',
        'app.portal-invites-add.security-locked-no': 'No',
        'app.portal-invites-add.security-locked-yes': 'Yes',
        'app.portal-invites-add.security-locked': 'Account Locked',
        'app.portal-invites-add.security-roles-none': 'None Assigned',
        'app.portal-invites-add.security-roles': 'Access Level',
        'app.portal-invites-add.security-roles.tooltip': 'Managers can invite new portal users to assigned associations, or revoke portal user access',
        'app.portal-invites-add.security-expiration-date': 'Deactivate On',
        'app.portal-invites-add.security-expiration-date.tooltip': 'Automatically deactivate access to association(s) on specified date',
        'app.portal-invites-add.security-clear-expiration-date': 'Clear Date',

        'app.report-portal-association.page-title': 'Portal Report',

        'app.report-association.address-care-of': 'C/O',
        'app.report-association.adjustments': 'Adjustments',
        'app.report-association.amount-funded': 'Amount Funded',
        'app.report-association.annual-increase': 'Annual Increase',
        'app.report-association.auto-compute': 'Auto Compute',
        'app.report-association.beginning-assumptions': 'Beginning Assumptions',
        'app.report-association.beginning-balance': 'Beginning Balance',
        'app.report-association.cash-flow': 'Cash Flow',
        'app.report-association.change': 'Change',
        'app.report-association.association-inventory-data-missing-body': 'There is no inventory data available for this association.',
        'app.report-association.association-inventory-data-missing': 'Association Inventory Data Missing',
        'app.report-association.chart-data-missing-body': 'There is no reserve chart data available for this association.',
        'app.report-association.chart-data-missing': 'Chart Data Missing',
        'app.report-association.order-data-missing-body': 'The latest order for this association is missing data, preventing the page from loading.',
        'app.report-association.order-data-missing': 'Order Data Missing',
        'app.report-association.alerts.warn-component-negative-rul.title': 'Negative Component RULs',
        'app.report-association.alerts.warn-component-negative-rul.body': 'Component(s) have negative remaining life values. Report printing will be disabled until all component RLs are fixed.',
        'app.report-association.alerts.warn-association-inventory-data-missing.body': 'There is no inventory data available for this association.',
        'app.report-association.alerts.warn-association-inventory-data-missing.title': 'Association Inventory Data Missing',
        'app.report-association.alerts.warn-association-inventory-no-results.body': 'This association does not have any matching inventory components with "Client Questions" data and are set to "Print".',
        'app.report-association.alerts.warn-association-inventory-no-results.title': 'No Matching Inventory Components',

        'app.report-association.create-invite-to-portal': 'Create Invite to Portal',
        'app.report-association.current-expenditures': 'Current Expenditures',
        'app.report-association.current-mrc': 'Current MRC',
        'app.report-association.current-pct-funded': 'Current PCT Funded',
        'app.report-association.expenditures-by-year': 'Expenditures By Year',
        'app.report-association.expenditures': 'Expenditures',
        'app.report-association.full-funding': 'Full Funding',
        'app.report-association.fully-funded': 'Fully Funded',
        'app.report-association.fully-funded-balance': 'Fully Funded Balance',
        'app.report-association.funding-amount': 'Funding Amount',
        'app.report-association.grid-title-prefix': 'Group',
        'app.report-association.grid.column-headers.erb': 'Ending Reserve Balance',
        'app.report-association.grid.column-headers.ffb': 'Fully Funded Balance',
        'app.report-association.grid.column-headers.id': 'Id',
        'app.report-association.grid.column-headers.ii': 'Interest Income',
        'app.report-association.grid.column-headers.name': 'Component Name',
        'app.report-association.grid.column-headers.pf': '% Funded',
        'app.report-association.grid.column-headers.rb': 'Reserve Balance',
        'app.report-association.grid.column-headers.rc': 'Reserve Contributions',
        'app.report-association.grid.column-headers.re': 'Reserve Expenses',
        'app.report-association.grid.column-headers.reserve-study-values': 'Reserve Study Values',
        'app.report-association.grid.column-headers.study-avg-cost': 'Study Avg Cost',
        'app.report-association.grid.column-headers.study-rl': 'Study RL',
        'app.report-association.grid.column-headers.study-ul': 'Study UL',
        'app.report-association.grid.column-headers.year': 'Year',
        'app.report-association.grid.column-headers.your-avg-cost': 'Your Avg Cost',
        'app.report-association.grid.column-headers.your-included': 'Include',
        'app.report-association.grid.column-headers.your-rl': 'Your RL',
        'app.report-association.grid.column-headers.your-ul': 'Your UL',
        'app.report-association.grid.column-headers.your-values': 'Your Values',
        'app.report-association.hypothetical-expenditures-by-year': 'Hypothetical Expenditures By Year',
        'app.report-association.hypothetical-fully-funded-balance': 'Hypothetical Fully Funded Balance',
        'app.report-association.hypothetical-fully-funded': 'Hypothetical Fully Funded',
        'app.report-association.hypothetical-funding-amount': 'Hypothetical Funding Amount',
        'app.report-association.hypothetical-mrc': 'Hypothetical MRC',
        'app.report-association.hypothetical-pct-funded': 'Hypothetical PCT Funded',
        'app.report-association.hypothetical-percent-funded': 'Hypothetical Percent Funded',
        'app.report-association.inflation': 'Inflation',
        'app.report-association.interest': 'Interest',
        'app.report-association.inventory-analyzed': 'Inventory Analyzed',
        'app.report-association.minimum-mrc': 'Minimum MRC',
        'app.report-association.minimum-pct-funded': 'Minimum PCT Funded',
        'app.report-association.modals.toggle-invite.access-level': 'Access Level',
        'app.report-association.modals.toggle-invite.allow': 'Allow',
        'app.report-association.modals.toggle-invite.are-you-sure': 'Are you sure you want to',
        'app.report-association.modals.toggle-invite.association': 'Association',
        'app.report-association.modals.toggle-invite.confirm': 'Confirm',
        'app.report-association.modals.toggle-invite.confirm-changes': 'Confirm Changes',
        'app.report-association.modals.toggle-invite.resend': 'Resend Invite Email',
        'app.report-association.modals.toggle-invite.deactivate-never': 'Never',
        'app.report-association.modals.toggle-invite.deactivate-on': 'Deactivate On',
        'app.report-association.modals.toggle-invite.promote': 'Promote to Manager',
        'app.report-association.modals.toggle-invite.demote': 'Demote to User',
        'app.report-association.modals.toggle-invite.disable': 'Disable',
        'app.report-association.modals.toggle-invite.disable-access': 'Disable Access',
        'app.report-association.modals.toggle-invite.enable-access': 'Enable Access',
        'app.report-association.modals.toggle-invite.portal-access-for': 'user access for',
        'app.report-association.modals.toggle-invite.title': 'User Access',
        'app.report-association.modals.toggle-invite.user': 'User',
        'app.report-association.modals.toggle-invite.modify': 'Modify',
        'app.report-association.mrc-value': 'MRC Value',
        'app.report-association.mrc': 'MRC',
        'app.report-association.new-scenario': 'New Scenario',
        'app.report-association.no-changes': 'No Changes',
        'app.report-association.page-title': 'Reserve Study Analysis',
        'app.report-association.page.component-evaluation': 'Component Evaluation',
        'app.report-association.page.component-funding-information.current-fund-balance': 'Current Fund Balance as a percentage of Ideal Balance',
        'app.report-association.page.component-funding-information.grand-total': 'Grand Total',
        'app.report-association.page.component-funding-information.grid-column-headers.avg-current-cost': 'Average Current Cost',
        'app.report-association.page.component-funding-information.grid-column-headers.component-name': 'Component Name',
        'app.report-association.page.component-funding-information.grid-column-headers.current-fund-balance': 'Current Fund Balance',
        'app.report-association.page.component-funding-information.grid-column-headers.id': 'ID',
        'app.report-association.page.component-funding-information.grid-column-headers.ideal-balance': 'Ideal Balance',
        'app.report-association.page.component-funding-information.grid-column-headers.monthly': 'Monthly',
        'app.report-association.page.component-funding-information.grid-column-headers.quantity': 'Quantity',
        'app.report-association.page.component-funding-information.grid-column-headers.rul': 'RUL',
        'app.report-association.page.component-funding-information.grid-column-headers.ul': 'UL',
        'app.report-association.page.component-funding-information.subtotals': 'Subtotals',
        'app.report-association.page.component-funding-information': 'Component Funding Information',
        'app.report-association.page.component-client-questions': 'Report Notes',
        'app.report-association.page.component-client-questions-prev': 'Report Notes - Client Questions',
        'app.report-association.page.component-client-questions.grid-column-headers.id': 'ID',
        'app.report-association.page.component-client-questions.grid-column-headers.component-name': 'Component Name',
        'app.report-association.page.component-client-questions.grid-column-headers.location': 'Location',
        'app.report-association.page.component-client-questions.grid-column-headers.quantity': 'Quantity',
        'app.report-association.page.yearly-cash-flow.grid-column-headers.starting-balance': 'Starting Balance',
        'app.report-association.page.yearly-cash-flow.grid-column-headers.reserve-income': 'Reserve Income',
        'app.report-association.page.yearly-cash-flow.grid-column-headers.interest-earnings': 'Interest Earnings',
        'app.report-association.page.yearly-cash-flow.grid-column-headers.special-assessments': 'Special Assessments',
        'app.report-association.page.yearly-cash-flow.grid-column-headers.funds-available': 'Funds Available',
        'app.report-association.page.yearly-cash-flow.grid-column-headers.reserve-expenditures': 'Reserve Expenditures',
        'app.report-association.page.yearly-cash-flow.grid-column-headers.ending-balance': 'Ending Balance',
        'app.report-association.page.yearly-cash-flow.grid-column-headers.year': 'Year',
        'app.report-association.page.projected-expenditures.no-expenditures-projected': 'No Expenditures Projected',
        'app.report-association.page.projected-expenditures.grid-column-headers.year': 'Year',
        'app.report-association.page.projected-expenditures.grid-column-headers.subgroup': 'Subgroup',
        'app.report-association.page.projected-expenditures.grid-column-headers.component-id': 'Comp. Id',
        'app.report-association.page.projected-expenditures.grid-column-headers.component-name': 'Component Name',
        'app.report-association.page.projected-expenditures.grid-column-headers.projected-cost': 'Projected Cost',
        'app.report-association.page.projected-expenditures.grid-column-headers.total-per-annum': 'Total Per Annum',

        'app.report-association.page.significant-components.grid-column-headers.id': 'ID #',
        'app.report-association.page.significant-components.grid-column-headers.component-name': 'Component Name',
        'app.report-association.page.significant-components.grid-column-headers.ul': 'UL',
        'app.report-association.page.significant-components.grid-column-headers.rul': 'RUL',
        'app.report-association.page.significant-components.grid-column-headers.average-current': 'Average Current',
        'app.report-association.page.significant-components.grid-column-headers.significance-curr-cost-ul': 'Significance: (Curr Cost/UL)',
        'app.report-association.page.significant-components.grid-column-headers.significance-as-currency': 'As $',
        'app.report-association.page.significant-components.grid-column-headers.significance-as-percentage': 'As %',

        'app.report-association.portal-access.allowed-users': 'Allowed Users',
        'app.report-association.portal-access.deactivated-users.account-disabled': 'Disabled',
        'app.report-association.portal-access.deactivated-users.expired-on': 'Deactivated on',
        'app.report-association.portal-access.deactivated-users.role.portal-manager': 'Manager',
        'app.report-association.portal-access.deactivated-users.role.portal-user': 'User',
        'app.report-association.portal-access.deactivated-users': 'Deactivated Users',
        'app.report-association.portal-access.invite-to-portal': 'Invite to Portal',
        'app.report-association.portal-access.managers': 'User Managers',
        'app.report-association.portal-access.none-assigned': 'None assigned',
        'app.report-association.portal-access.none-deactivated': 'None deactivated',
        'app.report-association.portal-access': 'Manage User Access',
        'app.report-association.manage-user-access': 'Manage User Access',
        'app.report-association.report-parameters': 'Reserve Study Charts',
        'app.report-association.reserve-study-pdf': 'Report PDF',
        'app.report-association.save-as-new-scenario': 'Copy Scenario',
        'app.report-association.save-changes-to-scenario': 'Save Changes',
        'app.report-association.scenario-name': 'Name',
        'app.report-association.scenario-description': 'Description',
        'app.report-association.scenario-shared': 'Shared With Others',
        'app.report-association.scenario': 'Load Scenario',
        'app.report-association.my-scenarios': 'My Saved Scenarios',
        'app.report-association.shared-scenarios': 'Shared Scenarios',
        'app.report-association.scenarios': 'Scenarios',
        'app.report-association.no-scenarios': 'No scenarios',
        'app.report-association.scenario-snapshots': 'Scenario Snapshots',
        'app.report-association.modify-saved-scenario': 'Modify Saved Scenario ',
        'app.report-association.create-new-scenario': 'Create New Scenario ',
        'app.report-association.save-current-scenario': 'Save Current Scenario ',
        'app.report-association.copy-to-new-scenario': 'Copy To New Scenario ',
        'app.report-association.shared-by-me': 'Shared By Me',
        'app.report-association.shared-by-others': 'Shared By Others',
        'app.report-association.my-scenario-shared': 'Shared',
        'app.report-association.my-scenario-not-shared': 'Not Shared',
        'app.report-association.save-this-scenario': 'Save This Scenario',
        'app.report-association.optimize-scenario': 'Optimize Scenario',

        'app.report-association.save-new-OLD': 'Create',
        'app.report-association.save-new': 'Save',
        'app.report-association.save': 'Save',
        'app.report-association.save-copy': 'Duplicate',
        'app.report-association.drop-changes': 'Drop Changes',
        'app.report-association.save-scenario': 'Save',
        'app.report-association.rename-scenario': 'Rename',
        'app.report-association.no-scenario': 'No Scenario Loaded',
        'app.report-association.scenario-new-reset': 'New Scenario',
        'app.report-association.update-scenario': 'Save Changes',
        'app.report-association.delete-scenario': 'Delete',
        'app.report-association.revert-scenario': 'Revert',

        'app.report-association.page.executive-summary': 'Executive Summary',
        'app.report-association.page.funding-summary': 'Funding Summary',
        'app.report-association.page.general-information': 'General Information and Frequently Asked Questions',
        'app.report-association.page.glossary': 'Glossary of Commonly Used Words and Phrases',
        'app.report-association.page.introduction': 'Introduction',
        'app.report-association.page.percent-funded-graph': 'Percent Funded - Graph',
        'app.report-association.page.projected-reserve-expenditures-by-year': 'Projected Expenditures By Year',
        'app.report-association.page.reserve-contributions-graph': 'Reserve Contributions - Graph',
        'app.report-association.page.significant-components-graph': 'Significant Components - Graph',
        'app.report-association.page.significant-components': 'Significant Components',
        'app.report-association.page.table-of-contents': 'Table of Contents',
        'app.report-association.page.yearly-cash-flow': 'Yearly Cash Flow',
        'app.report-association.page.yearly-reserve-expenditures-graph': 'Yearly Reserve Expenditures - Graph',
        'app.report-association.page.yearly-summary': 'Yearly Summary',
        'app.report-association.page.yearly-summary-recommended-funding': 'Yearly Summary (Recommended Funding)',
        'app.report-association.page.yearly-summary-current': 'Yearly Summary (Current Funding)',
        'app.report-association.page.yearly-summary-minimum': 'Yearly Summary (Minimum Funding)',

        'app.report-association.page.ca-disclosure-form.customize-disclosure-form': 'Customize Disclosure Form',
        'app.report-association.page.ca-disclosure-form.disclosure-variables': 'Disclosure Variables',
        'app.report-association.page.ca-disclosure-form.exhibit-text': 'Summary Page Text',
        'app.report-association.page.ca-disclosure-form.approved-assessment': 'Approved Assessment',
        'app.report-association.page.ca-disclosure-form.client-approved-special-assessment': 'Approved Special Assessment',
        'app.report-association.page.ca-disclosure-form.report-date': 'Report Date',
        'app.report-association.page.ca-disclosure-form.alert.value-missing': 'Value Missing',
        'app.report-association.page.ca-disclosure-form.alert.value-missing.report-date': 'Report Date value not defined',
        'app.report-association.page.ca-disclosure-form.alert.value-missing.approved-reserve-contribution': 'Approved Reserve Contribution value not defined',
        'app.report-association.page.ca-disclosure-form.alert.special-assessment-involved': 'Special Assessment Recommended',
        'app.report-association.page.ca-disclosure-form.alert.special-assessment-involved.exercise-caution': 'Double-check work when dealing with Special Assessments',
        'app.report-association.page.ca-disclosure-form.alert.special-assessment-involved.value-mismatch': 'Approved SA Doesn\'t match Recommended. Ignore this if this is intentional',
        'app.report-association.page.ca-disclosure-form.disclosure-for-fye-period': 'Disclosure For FYE Period',
        'app.report-association.page.ca-disclosure-form.reserve-balances-sufficient': 'Reserve Balances Sufficient',
        'app.report-association.page.ca-disclosure-form.projected-balance-at-fye': 'Projected Balance at FYE',
        'app.report-association.page.ca-disclosure-form.approved-reserve-contribution': 'Approved Reserve Contribution',
        'app.report-association.page.ca-disclosure-form.annual-pct-increases': 'Annual % Increases',
        'app.report-association.page.ca-disclosure-form.num-of-years': '# of Years',
        'app.report-association.page.ca-disclosure-form.second-increase-pct': 'Second Increase %',
        'app.report-association.page.ca-disclosure-form.report-parameters': 'Report Parameters',
        'app.report-association.page.ca-disclosure-form.fully-funded-balance': 'Fully Funded Balance',
        'app.report-association.page.ca-disclosure-form.projected-fund-balance': 'Projected Fund Balance',
        'app.report-association.page.ca-disclosure-form.projected-pct-funded-at-fye': 'Projected % Funded at FYE',
        'app.report-association.page.ca-disclosure-form.funding-deficiency-per-unit': 'Funding Deficiency Per Unit',
        'app.report-association.page.ca-disclosure-form.num-units': 'Number of Units',
        'app.report-association.page.ca-disclosure-form.inflation-rate': 'Inflation Rate',
        'app.report-association.page.ca-disclosure-form.after-tax-interest-rate': 'After-Tax Interest Rate',
        'app.report-association.page.ca-disclosure-form.recommended-mrc': 'Recommended MRC',
        'app.report-association.page.ca-disclosure-form.recommended-sa': 'Recommended SA',
        'app.report-association.page.ca-disclosure-form.first-pct-num-years-second-pct': '1st %, # Yrs, 2nd %',
        'app.report-association.page.ca-disclosure-form.report-prepared-for-fye': 'Report Prepared For FYE',
        'app.report-association.page.ca-disclosure-form.add-assessment': 'Add Assessment',
        'app.report-association.page.ca-disclosure-form.add-year-calculation': 'Add Year Calculation',
        'app.report-association.page.ca-disclosure-form.modals.missing-values.title': 'Missing Values Warning',
        'app.report-association.page.ca-disclosure-form.modals.missing-values.header': 'Missing Disclosure Form Values',
        'app.report-association.page.ca-disclosure-form.modals.missing-values.content': 'Warning: Disclosure cannot be printed until missing form values are entered',

        'app.report-association.percent-funded': 'Percent Funded',
        'app.report-association.recommended-mrc': 'Recommended MRC',
        'app.report-association.recommended-pct-funded': 'Recommended PCT Funded',
        'app.report-association.reserve-study-chart': 'Reserve Study Chart',
        'app.report-association.sealed-bid-proposal': 'Sealed Bid Proposal',
        'app.report-association.secondary-adjustment-years': 'Secondary Adjustment Years',
        'app.report-association.secondary-annual-increase': 'Secondary Annual Increase',
        'app.report-association.special-assessment': 'Special Assessment',
        'app.report-association.view-bid-envelope': 'Bid Envelope',
        'app.report-association.view-bid-letter': 'Bid Letter',
        'app.report-association.view-order': 'View Order',
        'app.report-association.yearly-summary': 'Yearly Summary',
        'app.report-association.component-funding': 'Component Funding',

        'app.research-bids.buildings': 'Buildings',
        'app.research-bids.contact-keyword': 'Contact Details',
        'app.research-bids.enter-keyword': 'Enter Any Contact Details',
        'app.research-bids.feedback-no': 'No',
        'app.research-bids.feedback-yes': 'Yes',
        'app.research-bids.filter-by-association-type': 'HOA Type',
        'app.research-bids.filter-by-buildings-range': 'Number of Buildings',
        'app.research-bids.filter-by-client': 'Client',
        'app.research-bids.filter-by-from-bid-date': 'From Bid Date ( Required )',
        'app.research-bids.filter-by-from-completion-date': 'From Completion Date',
        'app.research-bids.filter-by-pools': 'Number of Pools',
        'app.research-bids.filter-by-region': 'Region',
        'app.research-bids.filter-by-spas': 'Number of Spas',
        'app.research-bids.filter-by-status': 'Status',
        'app.research-bids.filter-by-streets': 'Streets',
        'app.research-bids.filter-by-to-bid-date': 'To Bid Date',
        'app.research-bids.filter-by-to-completion-date': 'To Completion Date',
        'app.research-bids.filter-by-units-range': 'Number of Units',
        'app.research-bids.grid.column-headers.accept-price': 'Accept Price',
        'app.research-bids.grid.column-headers.association-city': 'City',
        'app.research-bids.grid.column-headers.association-id': 'Assoc Id',
        'app.research-bids.grid.column-headers.association-mailing-address': 'Assoc Mailing Address',
        'app.research-bids.grid.column-headers.association-name': 'Association',
        'app.research-bids.grid.column-headers.association-state': 'State',
        'app.research-bids.grid.column-headers.association-type': 'Assoc Type',
        'app.research-bids.grid.column-headers.bid-date': 'Bid Date',
        'app.research-bids.grid.column-headers.buildings': 'Buildings',
        'app.research-bids.grid.column-headers.client-name': 'Client',
        'app.research-bids.grid.column-headers.client-street-address': 'Client Street Address',
        'app.research-bids.grid.column-headers.client-city': 'Client City',
        'app.research-bids.grid.column-headers.client-state': 'Client State',
        'app.research-bids.grid.column-headers.client-postal-code': 'Client Postal Code',
        'app.research-bids.grid.column-headers.clubhouse': 'Clubhouse',
        'app.research-bids.grid.column-headers.completion-date': 'Completion Date',
        'app.research-bids.grid.column-headers.construct-date': 'Construct Date',
        'app.research-bids.grid.column-headers.contact': 'Contact',
        'app.research-bids.grid.column-headers.contact-email': 'Contact Email',
        'app.research-bids.grid.column-headers.elevators': 'Elevators',
        'app.research-bids.grid.column-headers.feedback': 'Feedback',
        'app.research-bids.grid.column-headers.fencing': 'Fencing',
        'app.research-bids.grid.column-headers.gated': 'Gated',
        'app.research-bids.grid.column-headers.int-halls': 'Int Halls',
        'app.research-bids.grid.column-headers.irrigation': 'Irrigation',
        'app.research-bids.grid.column-headers.level-1-economy': 'Level1Economy',
        'app.research-bids.grid.column-headers.level-2-economy': 'Level2Economy',
        'app.research-bids.grid.column-headers.level-3-economy': 'Level3Economy',
        'app.research-bids.grid.column-headers.mechanical': 'Mechanical',
        'app.research-bids.grid.column-headers.order-status': 'Status',
        'app.research-bids.grid.column-headers.painted-exterior': 'Painted Exterior',
        'app.research-bids.grid.column-headers.pools': 'Pools',
        'app.research-bids.grid.column-headers.prepared-for-fye-date': 'Prepared For FYE Date',
        'app.research-bids.grid.column-headers.region-name': 'Region',
        'app.research-bids.grid.column-headers.roofs': 'Roofs',
        'app.research-bids.grid.column-headers.order-service': 'Service',
        'app.research-bids.grid.column-headers.spas': 'Spas',
        'app.research-bids.grid.column-headers.stories': 'Stories',
        'app.research-bids.grid.column-headers.streets': 'Streets',
        'app.research-bids.grid.column-headers.tennis': 'Tennis',
        'app.research-bids.grid.column-headers.units': 'Units',
        'app.research-bids.grid.column-headers.manager': 'Project Manager',
        'app.research-bids.grid.column-headers.coordinator': 'Project Coordinator',
        'app.research-bids.grid.column-headers.site-inspection-date': 'SI Date',
        'app.research-bids.no-results': 'No matching bids found. Try changing your search criteria.',
        'app.research-bids.page-title': 'Research Bids',
        'app.research-bids.search': 'Search',
        'app.research-bids.units': 'Units',
        'app.research-bids.view-order-detail-link-title': 'Details',
        'app.research-bids.filter-by-bid-sent-range': 'Bid Sent Date Range', // 'Bid Completion Date Range',
        'app.research-bids.filter-date-range-options.all-dates': 'All Dates',
        'app.research-bids.filter-date-range-options.last-five-years': 'Last 5 Years',
        'app.research-bids.filter-date-range-options.last-four-years': 'Last 4 Years',
        'app.research-bids.filter-date-range-options.last-six-months': 'Last 6 Months',
        'app.research-bids.filter-date-range-options.last-six-years': 'Last 6 Years',
        'app.research-bids.filter-date-range-options.last-thirty-days': 'Last 30 Days',
        'app.research-bids.filter-date-range-options.last-three-months': 'Last 3 Months',
        'app.research-bids.filter-date-range-options.last-three-years': 'Last 3 Years',
        'app.research-bids.filter-date-range-options.last-twelve-months': 'Last 12 Months',
        'app.research-bids.filter-date-range-options.last-two-years': 'Last 2 Years',
        'app.research-bids.filter-date-range-options.month-to-date': 'Month To Date',
        'app.research-bids.filter-date-range-options.previous-month': 'Previous Month',
        'app.research-bids.filter-date-range-options.previous-year': 'Previous Year',
        'app.research-bids.filter-date-range-options.year-to-date': 'Year To Date',

        'app.research-components-search.enter-component-id': '1390, 401, etc.',
        'app.research-components-search.enter-search-term': 'Showers, Asphalt, Fencing, etc...',
        'app.research-components-search.filter-by-association': 'Filter by Association',
        'app.research-components-search.filter-by-bid-sent-range': 'Bid Sent Date Range', // 'Bid Completion Date Range',
        'app.research-components-search.filter-by-research-date-range': 'Research Date Range',
        'app.research-components-search.filter-by-component-id': 'Component ID',
        'app.research-components-search.filter-by-from-date': 'From Bid Sent Date', // 'From Completion Date',
        'app.research-components-search.filter-by-to-date': 'To Bid Sent Date', // 'To Completion Date',
        'app.research-components-search.filter-by-search-term': 'Search Term',
        'app.research-components-search.filter-date-range-options.all-dates': 'All Dates',
        'app.research-components-search.filter-date-range-options.last-five-years': 'Last 5 Years',
        'app.research-components-search.filter-date-range-options.last-four-years': 'Last 4 Years',
        'app.research-components-search.filter-date-range-options.last-six-months': 'Last 6 Months',
        'app.research-components-search.filter-date-range-options.last-six-years': 'Last 6 Years',
        'app.research-components-search.filter-date-range-options.last-thirty-days': 'Last 30 Days',
        'app.research-components-search.filter-date-range-options.last-three-months': 'Last 3 Months',
        'app.research-components-search.filter-date-range-options.last-three-years': 'Last 3 Years',
        'app.research-components-search.filter-date-range-options.last-twelve-months': 'Last 12 Months',
        'app.research-components-search.filter-date-range-options.last-two-years': 'Last 2 Years',
        'app.research-components-search.filter-date-range-options.month-to-date': 'Month To Date',
        'app.research-components-search.filter-date-range-options.previous-month': 'Previous Month',
        'app.research-components-search.filter-date-range-options.previous-year': 'Previous Year',
        'app.research-components-search.filter-date-range-options.year-to-date': 'Year To Date',
        'app.research-components-search.grid.column-headers.association-city': 'City',
        'app.research-components-search.grid.column-headers.association-id': 'Assoc Id',
        'app.research-components-search.grid.column-headers.association-name': 'Association Name',
        'app.research-components-search.grid.column-headers.association-state': 'State',
        'app.research-components-search.grid.column-headers.association-type': 'Type',
        'app.research-components-search.grid.column-headers.avg-cost': 'Avg Cost',
        'app.research-components-search.grid.column-headers.category-id': 'Cat Id',
        'app.research-components-search.grid.column-headers.component-name': 'Component Name',
        'app.research-components-search.grid.column-headers.history': 'History',
        'app.research-components-search.grid.column-headers.quantity': 'Quantity',
        'app.research-components-search.grid.column-headers.useful-life': 'UL',
        'app.research-components-search.grid.column-headers.view-inventory': 'Inventory',
        'app.research-components-search.grid.column-headers.view-order': 'Order',
        'app.research-components-search.history-no': 'No',
        'app.research-components-search.history-yes': 'Yes',
        'app.research-components-search.no-results': 'No matching components found.',
        'app.research-components-search.page-title': 'Research Components',
        'app.research-components-search.show-results-without-research-data': 'Include Results With No Research Data',
        'app.research-components-search.view-inventory': 'Inventory',
        'app.research-components-search.view-inventory-link-title': 'View Inventory Details',
        'app.research-components-search.view-order': 'Order',
        'app.research-components-search.view-order-link-title': 'View Order Details',

        'app.sidebar.links.administration.add-user': 'Add New User',
        'app.sidebar.links.administration.coordinator-jobs': 'Coordinator Jobs',
        'app.sidebar.links.administration.default-managers': 'Edit Regions',
        'app.sidebar.links.administration.invite-client': 'Invite Portal User',
        'app.sidebar.links.administration.manage-lookup-tables': 'Lookup Tables',
        'app.sidebar.links.administration.query-database': 'Query Database',
        'app.sidebar.links.administration.users': 'Search Users',
        'app.sidebar.links.administration': 'Administration',
        'app.sidebar.links.analysis': 'Analysis',
        'app.sidebar.links.associations.add-new': 'Add New Association',
        'app.sidebar.links.associations.export-association-orders': 'Export Orders',
        'app.sidebar.links.associations.search': 'Search Associations',
        'app.sidebar.links.associations': 'Associations',
        'app.sidebar.links.clients.add-new': 'Add New Client',
        'app.sidebar.links.clients.search-contacts': 'Export Contacts',
        'app.sidebar.links.clients.search': 'Search Clients',
        'app.sidebar.links.clients': 'Clients',
        'app.sidebar.links.communities-home.communities': 'Communities',
        'app.sidebar.links.communities-home.my-account': 'My Account',
        'app.sidebar.links.communities-home': 'My Communities',
        'app.sidebar.links.hide-menu': '',
        'app.sidebar.links.home.active-jobs': 'Active Jobs',
        'app.sidebar.links.home.my-account': 'My Account',
        'app.sidebar.links.home': 'Home',
        'app.sidebar.links.home.prepared-bids': 'Prepare Bids',
        'app.sidebar.links.inventory.research-components': 'Research Components',
        'app.sidebar.links.inventory': 'Inventory',
        'app.sidebar.links.inventory.my-inv-templates': 'My Templates',
        'app.sidebar.links.orders.add-new': 'Add New Order',
        'app.sidebar.links.orders.add-new-bid': 'Add New Bid',
        'app.sidebar.links.orders.new-research-bids': 'New Research Bids',
        'app.sidebar.links.orders.outstanding-bids': 'Outstanding Bids',
        'app.sidebar.links.orders.research-bids': 'Research Bids',
        'app.sidebar.links.orders.reminder-bids': 'Reminder Bids',
        'app.sidebar.links.orders.search': 'Search Orders',
        'app.sidebar.links.orders.won-jobs': 'Won Jobs',
        'app.sidebar.links.orders.send-bids': 'Send Bids',
        'app.sidebar.links.orders': 'Orders',

        'app.user-detail.contact-details': 'Contact Details',
        'app.user-detail.inventory-templates': 'Inventory Templates',
        'app.user-detail.inventory-templates.item': 'Item',
        'app.user-detail.inventory-templates.subgroup': 'Subgroup',
        'app.user-detail.inventory-templates.contains': 'Contains',
        'app.user-detail.contact-first-name': 'First Name',
        'app.user-detail.contact-last-name': 'Last Name',
        'app.user-detail.contact-title': 'Title',
        'app.user-detail.hide-replacement-costs': 'Hide Replacement Costs',
        'app.user-detail.login-details': 'Login Details',
        'app.user-detail.login-email': 'Email',
        'app.user-detail.login-last-login': 'Last Login',
        'app.user-detail.login-never': 'Never',
        'app.user-detail.login-password': 'Password',
        'app.user-detail.login-username': 'Username',
        'app.user-detail.modals.new-user.confirm-password': 'Confirm Password',
        'app.user-detail.modals.new-user.email-in-use': '* Email is already in use',
        'app.user-detail.modals.new-user.email': 'Email Address',
        'app.user-detail.modals.new-user.first-name': 'First Name',
        'app.user-detail.modals.new-user.last-name': 'Last Name',
        'app.user-detail.modals.new-user.new-username': 'New Username',
        'app.user-detail.modals.new-user.password-min-length': '* Password must be at least {TOKEN_VALUE} characters',
        'app.user-detail.modals.new-user.password': 'Password',
        'app.user-detail.modals.new-user.passwords-mismatched': '* Passwords do not match',
        'app.user-detail.modals.new-user.professional-title': 'Title',
        'app.user-detail.modals.new-user.required': 'Required',
        'app.user-detail.modals.new-user.title': 'Create New User',
        'app.user-detail.modals.new-user.username-in-use': '* Username is already in use',
        'app.user-detail.modals.reset-password.new-password-confirm': 'Confirm New Password',
        'app.user-detail.modals.reset-password.new-password': 'New Password',
        'app.user-detail.modals.reset-password.set-changes': 'Set Changes',
        'app.user-detail.modals.reset-password.title': 'Reset Password',
        'app.user-detail.modals.reset-password.unlock-if-locked-out': 'Locked Out',
        'app.user-detail.modals.reset-password.password-change-required': 'Must Change On Login',
        'app.user-detail.new-user': 'Create New User',
        'app.user-detail.new-user-resume': 'Create Missing User Resume',
        'app.user-detail.not-found': 'User "{TOKEN_VALUE}" not found!',
        'app.user-detail.page-title': 'User Profile',
        'app.user-detail.page-title.edit': 'Edit User Profile',
        'app.user-detail.portal-access': 'Manage Portal User Access',
        'app.user-detail.portal-invites': 'Portal Invites',
        'app.user-detail.portal-role-admin': 'User Manager Associations',
        'app.user-detail.portal-role-user': 'User Associations',
        'app.user-detail.portal-invite-deactive': 'Deactive Associations',
        'app.user-detail.profile-settings': 'Profile Settings',
        'app.user-detail.reset-password': 'Reset Password',
        'app.user-detail.resume-details': 'Professional Details',
        'app.user-detail.resume-permit-number-nv': 'Permit Number (Nevada)',
        'app.user-detail.resume-signature': 'Document Signatures',
        'app.user-detail.resume-text': 'Resume Content',
        'app.user-detail.roles': 'Roles',
        'app.user-detail.search-users': 'Search Users',
        'app.user-detail.view-profile': 'View Profile',
        'app.user-detail.edit-profile': 'Edit Profile',
        'app.user-detail.security-active-no': 'No',
        'app.user-detail.security-active-yes': 'Yes',
        'app.user-detail.security-active': 'Account Active',
        'app.user-detail.security-details': 'Security Details',
        'app.user-detail.security-inactive': 'Account Disabled',
        'app.user-detail.security-locked-no': 'No',
        'app.user-detail.security-locked-yes': 'Yes',
        'app.user-detail.security-locked': 'Account Locked',
        'app.user-detail.security-roles-none': 'None Assigned',
        'app.user-detail.security-roles': 'Assigned Roles',
        'app.user-detail.security-regions-none': 'None Assigned',
        'app.user-detail.security-regions': 'Assigned Regions',
        'app.user-detail.security-groups': 'Assigned Groups',
        'app.user-detail.can-see-all-jobs': 'Can See All Jobs',

        'app.user-add.contact-details': 'Contact Details',
        'app.user-add.contact-first-name': 'First Name',
        'app.user-add.contact-last-name': 'Last Name',
        'app.user-add.contact-title': 'Title',
        'app.user-add.login-details': 'Login Details',
        'app.user-add.login-email': 'Email',
        'app.user-add.login-last-login': 'Last Login',
        'app.user-add.login-password': 'Password',
        'app.user-add.login-username': 'Username',
        'app.user-add.modals.new-user.confirm-password': 'Confirm Password',
        'app.user-add.modals.new-user.email': 'Email Address',
        'app.user-add.modals.new-user.email-in-use': '* Email is already in use',
        'app.user-add.modals.new-user.first-name': 'First Name',
        'app.user-add.modals.new-user.last-name': 'Last Name',
        'app.user-add.modals.new-user.new-username': 'New Username',
        'app.user-add.modals.new-user.password': 'Password',
        'app.user-add.modals.new-user.temporary-password': 'Temporary Password',
        'app.user-add.modals.new-user.password-min-length': '* Password must be at least {TOKEN_VALUE} characters',
        'app.user-add.modals.new-user.passwords-mismatched': '* Passwords do not match',
        'app.user-add.modals.new-user.assigned-roles-invalid': '* Must assign at least 1 role',
        'app.user-add.modals.new-user.assigned-regions-invalid': '* Must assign at least 1 region',
        'app.user-add.modals.new-user.professional-title': 'Title',
        'app.user-add.modals.new-user.required': 'Required',
        'app.user-add.modals.new-user.title': 'Create New User',
        'app.user-add.modals.new-user.username-in-use': '* Username is already in use',
        'app.user-add.modals.reset-password.new-password': 'New Password',
        'app.user-add.modals.reset-password.new-password-confirm': 'Confirm New Password',
        'app.user-add.modals.reset-password.set-changes': 'Set Changes',
        'app.user-add.modals.reset-password.title': 'Reset Password',
        'app.user-add.modals.reset-password.unlock-if-locked-out': 'Locked Out',
        'app.user-add.modals.reset-password.password-change-required': 'Must Change On Login',
        'app.user-add.new-user': 'Create New User',
        'app.user-add.not-found': 'User "{TOKEN_VALUE}" not found!',
        'app.user-add.page-title': 'Add User',
        'app.user-add.reset-password': 'Reset Password',
        'app.user-add.resume-details': 'Professional Details',
        'app.user-add.resume-permit-number-nv': 'Permit Number (Nevada)',
        'app.user-add.resume-signature': 'Document Signatures',
        'app.user-add.resume-text': 'Resume Content',
        'app.user-add.roles': 'Roles',
        'app.user-add.search-users': 'Search Users',
        'app.user-add.security-active': 'Account Active',
        'app.user-add.security-active-no': 'No',
        'app.user-add.security-active-yes': 'Yes',
        'app.user-add.security-details': 'Security Details',
        'app.user-add.security-inactive': 'Account Disabled',
        'app.user-add.security-locked': 'Account Locked',
        'app.user-add.security-locked-no': 'No',
        'app.user-add.security-locked-yes': 'Yes',
        'app.user-add.security-roles': 'Assigned Roles',
        'app.user-add.security-roles-none': 'None Assigned',
        'app.user-add.security-regions': 'Assigned Regions',
        'app.user-add.security-regions-none': 'None Assigned',
        'app.user-add.security-assigned-additional-groups': 'Assigned Additional Groups',
        'app.user-add.security-additional-groups': 'Additional Groups',

        'app.user-search.enter-keyword': 'Enter Keyword',
        'app.user-search.grid.column-headers.active': 'Active',
        'app.user-search.grid.column-headers.email': 'Email',
        'app.user-search.grid.column-headers.first-name': 'First Name',
        'app.user-search.grid.column-headers.last-login-date': 'Last Login Date',
        'app.user-search.grid.column-headers.last-name': 'Last Name',
        'app.user-search.grid.column-headers.locked': 'Locked',
        'app.user-search.grid.column-headers.roles': 'Roles',
        'app.user-search.grid.column-headers.title': 'Title',
        'app.user-search.grid.column-headers.username': 'User Name',
        'app.user-search.filter-option-employees': 'Employees',
        'app.user-search.filter-option-portal-users': 'Invited Users',
        'app.user-search.no-results': 'No matching users found. Try changing your search term.',
        'app.user-search.page-title': 'Search Users',
        'app.user-search.page-title.users': 'Users',
        'app.user-search.page-title.employees': 'Employees',
        'app.user-search.page-title.portal-users': 'Invited Users',
        'app.user-search.search-results': 'Search Results',
        'app.user-search.roles-none': 'None',
        'app.user-search.search-keyword': 'Search Keyword',
        'app.user-search.user-detail-link-title': 'View user details',

        'app.create-invite.assigned-associations': 'Association Assignment',
        'app.create-invite.association': 'Association',
        'app.create-invite.associations': 'Associations',
        'app.create-invite.contact-details': 'Contact Details',
        'app.create-invite.contact-first-name': 'First Name',
        'app.create-invite.contact-last-name': 'Last Name',
        'app.create-invite.contact-title': 'Title',
        'app.create-invite.create-client-invite': 'Create Portal Invite',
        'app.create-invite.create-portal-invite': 'Create Portal Invite',
        'app.create-invite.create-portal-invites': 'Create Portal Invites',
        'app.create-invite.login-details': 'Invite Recipient',
        'app.create-invite.login-email': 'Email',
        'app.create-invite.login-last-login': 'Last Login',
        'app.create-invite.login-password': 'Password',
        'app.create-invite.login-username': 'Username',
        'app.create-invite.modals.create-invite.confirm-password': 'Confirm Password',
        'app.create-invite.modals.create-invite.email-in-use': '* Email is already in use',
        'app.create-invite.modals.create-invite.email': 'Email Address',
        'app.create-invite.modals.create-invite.username': 'Matched User',
        'app.create-invite.modals.create-invite.first-name': 'First Name',
        'app.create-invite.modals.create-invite.last-name': 'Last Name',
        'app.create-invite.modals.create-invite.new-username': 'New Username',
        'app.create-invite.modals.create-invite.password-min-length': '* Password must be at least {TOKEN_VALUE} characters',
        'app.create-invite.modals.create-invite.password': 'Password',
        'app.create-invite.modals.create-invite.temporary-password': 'Temporary Password',
        'app.create-invite.modals.create-invite.passwords-mismatched': '* Passwords do not match',
        'app.create-invite.modals.create-invite.professional-title': 'Title',
        'app.create-invite.modals.create-invite.required': 'Required',
        'app.create-invite.modals.create-invite.title': 'Create Portal Invite',
        'app.create-invite.modals.create-invite.username-in-use': '* Username is already in use',
        'app.create-invite.modals.reset-password.new-password-confirm': 'Confirm New Password',
        'app.create-invite.modals.reset-password.new-password': 'New Password',
        'app.create-invite.modals.reset-password.set-changes': 'Set Changes',
        'app.create-invite.modals.reset-password.title': 'Reset Password',
        'app.create-invite.modals.reset-password.unlock-if-locked-out': 'Locked Out',
        'app.create-invite.modals.reset-password.password-change-required': 'Must Change On Login',
        'app.create-invite.not-found': 'User "{TOKEN_VALUE}" not found!',
        'app.create-invite.page-title': 'Create Portal Invite',
        'app.create-invite.reset-password': 'Reset Password',
        'app.create-invite.resume-details': 'Professional Details',
        'app.create-invite.resume-permit-number-nv': 'Permit Number (Nevada)',
        'app.create-invite.resume-signature': 'Document Signatures',
        'app.create-invite.resume-text': 'Resume Content',
        'app.create-invite.roles': 'Roles',
        'app.create-invite.search-users': 'Search Users',
        'app.create-invite.security-active-no': 'No',
        'app.create-invite.security-active-yes': 'Yes',
        'app.create-invite.security-active': 'Account Active',
        'app.create-invite.security-details': 'Security Permissions',
        'app.create-invite.security-inactive': 'Account Disabled',
        'app.create-invite.security-locked-no': 'No',
        'app.create-invite.security-locked-yes': 'Yes',
        'app.create-invite.security-locked': 'Account Locked',
        'app.create-invite.security-roles-none': 'None Assigned',
        'app.create-invite.security-roles': 'Access Level',
        'app.create-invite.security-roles.tooltip': 'Managers can invite new portal users to assigned associations, or revoke portal user access',
        'app.create-invite.security-expiration-date': 'Deactivate On',
        'app.create-invite.security-expiration-date.tooltip': 'Automatically deactivate access to association(s) on specified date',
        'app.create-invite.security-clear-expiration-date': 'Clear Date',

        'app.won-jobs.filter-by-from-won-date': 'From Won Date',
        'app.won-jobs.filter-by-quickbooks': 'Entered in Quickbooks',
        'app.won-jobs.filter-by-region': 'Region',
        'app.won-jobs.filter-by-status': 'Status',
        'app.won-jobs.filter-by-to-won-date': 'To Won Date',
        'app.won-jobs.filter-by-unsolicited-bid': 'Unsolicited Bid',
        'app.won-jobs.filter-option-invoices': 'Invoices',
        'app.won-jobs.filter-option-quickbooks-any': '- SHOW ALL -',
        'app.won-jobs.filter-option-quickbooks-no': 'No',
        'app.won-jobs.filter-option-quickbooks-yes': 'Yes',
        'app.won-jobs.filter-option-quickbooks': 'Quickbooks',
        'app.won-jobs.filter-option-won-jobs': 'Won Jobs',
        'app.won-jobs.grid.column-headers.accepted-price': 'Accepted Price',
        'app.won-jobs.grid.column-headers.association-id': 'Assoc Id',
        'app.won-jobs.grid.column-headers.association-name': 'Association',
        'app.won-jobs.grid.column-headers.client-city': 'Client City',
        'app.won-jobs.grid.column-headers.contact-email': 'Contact Email',
        'app.won-jobs.grid.column-headers.contact-name': 'Contact Name',
        'app.won-jobs.grid.column-headers.client-name': 'Client',
        'app.won-jobs.grid.column-headers.order-status': 'Status',
        'app.won-jobs.grid.column-headers.region-name': 'Region',
        'app.won-jobs.grid.column-headers.service-level': 'Service Level',
        'app.won-jobs.grid.column-headers.won-date': 'Won Date',
        'app.won-jobs.links.set-all-invoice-sent': 'Set all to Invoice Sent',
        'app.won-jobs.links.set-all-entered-into-quickbooks': 'Set all to Entered in Quickbooks',
        'app.won-jobs.no-results': 'No matching jobs found. Try changing your search criteria.',
        'app.won-jobs.page-title': 'Won Jobs',
        'app.won-jobs.page-title.quickbooks': 'Quickbooks Entry Required',
        'app.won-jobs.page-title.jobs': 'Jobs',
        'app.won-jobs.page-title.invoices': 'Quickbooks Invoicing Required',
        'app.won-jobs.view-order-detail-link-title': 'View Order',
        'app.won-jobs.modals.bulk-update-jobs.generic.title': 'Set Multiple Jobs To {TOKEN_VALUE}',
        'app.won-jobs.modals.bulk-update-jobs.generic.note': 'Please confirm that you want all checked jobs to be set as "{TOKEN_VALUE}". Once confirmed, the changes will be saved immediately. Are you sure?',
        'app.won-jobs.modals.bulk-update-jobs.generic.update-jobs': 'Update All To {TOKEN_VALUE}',
        'app.won-jobs.modals.bulk-update-jobs.generic.invoice-sent': 'Invoice Sent',
        'app.won-jobs.modals.bulk-update-jobs.generic.entered-into-quickbooks': 'Entered in Quickbooks',
    };

    public static getImageMessages(brandKey: string) {
        switch (brandKey) {
            default:
            case Branding.appBrandKeys.complexSolutions:
                return ComplexSolutionsMessages;

            case Branding.appBrandKeys.appliedReserve:
                return AppliedReserveMessages;
        }
    }

    public static getBrandMessages(brandKey: string) {
        // Returns app text messages for the specified brand
        switch (brandKey) {
            default:
            case Branding.appBrandKeys.complexSolutions:
                return _.merge({}, Messages.defaultMessages, ComplexSolutionsMessages);

            case Branding.appBrandKeys.appliedReserve:
                return _.merge({}, Messages.defaultMessages, AppliedReserveMessages);
        }
    }

    public static getInitialIntlState(brandKey: string) {
        // Returns initial state for 'intl' field, required by intl provider
        const key = brandKey ? brandKey : Branding.appBrandKeys.complexSolutions;

        return {
            defaultLocale: 'en',
            locale: 'en',
            messages: Messages.getBrandMessages(key),
        };
    }
}



// WEBPACK FOOTER //
// ./src/config/intl-messages.tsx